export const INDIA_JSON = {
    "type": "Topology",
    "arcs": [
      [
        [16312, 12107],
        [-64, 75],
        [-43, 4],
        [-65, -160],
        [-60, 21]
      ],
      [
        [16080, 12047],
        [-11, 40]
      ],
      [
        [16069, 12087],
        [-12, 98],
        [13, 77],
        [-32, 126],
        [23, 26],
        [-22, 88]
      ],
      [
        [16039, 12502],
        [144, 53],
        [36, 142],
        [-27, 67],
        [23, 56]
      ],
      [
        [16215, 12820],
        [74, 16]
      ],
      [
        [16289, 12836],
        [9, -130],
        [-31, -86],
        [151, -50]
      ],
      [
        [16418, 12570],
        [-37, -172],
        [-69, -33],
        [1, -72]
      ],
      [
        [16313, 12293],
        [-1, -186]
      ],
      [
        [16418, 12570],
        [30, -19]
      ],
      [
        [16448, 12551],
        [94, -69],
        [20, -201],
        [-2, -89],
        [-22, -22]
      ],
      [
        [16538, 12170],
        [-76, -9],
        [3, 126],
        [-18, 59],
        [-58, -57],
        [-76, 4]
      ],
      [
        [16411, 11849],
        [-20, 90],
        [-75, 24],
        [-6, 69]
      ],
      [
        [16310, 12032],
        [60, 11],
        [87, 48],
        [60, -42]
      ],
      [
        [16517, 12049],
        [22, -80],
        [-24, -107],
        [-36, -50],
        [-68, 37]
      ],
      [
        [16039, 12502],
        [3, 55],
        [-61, 59],
        [-4, 49]
      ],
      [
        [15977, 12665],
        [12, 51],
        [40, 6],
        [9, 55],
        [42, 16],
        [47, 116]
      ],
      [
        [16127, 12909],
        [25, -68],
        [63, -21]
      ],
      [
        [16240, 11484],
        [-2, -116],
        [-69, -47],
        [19, -194]
      ],
      [
        [16188, 11127],
        [-98, 64],
        [-11, -81],
        [-58, -21],
        [4, 82],
        [-16, 144],
        [-47, 305]
      ],
      [
        [15962, 11620],
        [60, -15],
        [31, -62],
        [70, -68],
        [53, 60],
        [64, -51]
      ],
      [
        [16080, 12047],
        [1, -62],
        [82, -13],
        [31, -36]
      ],
      [
        [16194, 11936],
        [16, -166],
        [-22, -49],
        [43, -72]
      ],
      [
        [16231, 11649],
        [22, -112],
        [-13, -53]
      ],
      [
        [15962, 11620],
        [-40, 98],
        [-50, 44],
        [13, 88],
        [-30, 131],
        [37, 21]
      ],
      [
        [15892, 12002],
        [34, 15],
        [15, 75],
        [53, -15],
        [75, 10]
      ],
      [
        [15892, 12002],
        [-25, 41],
        [-60, 233],
        [-5, 61]
      ],
      [
        [15802, 12337],
        [-5, 63],
        [44, 73],
        [-8, 101],
        [12, 95],
        [-23, 45]
      ],
      [
        [15822, 12714],
        [83, 4]
      ],
      [
        [15905, 12718],
        [9, -70],
        [63, 17]
      ],
      [
        [16231, 11649],
        [56, -20],
        [59, 24]
      ],
      [
        [16346, 11653],
        [-2, -57],
        [32, -91],
        [-7, -81],
        [37, -34],
        [7, -107],
        [-25, -71],
        [-72, 15],
        [-34, -107],
        [-39, -27],
        [-55, 34]
      ],
      [
        [16312, 12107],
        [-2, -75]
      ],
      [
        [16411, 11849],
        [-48, -36]
      ],
      [
        [16363, 11813],
        [-106, 80],
        [-23, 51],
        [-40, -8]
      ],
      [
        [16538, 12170],
        [8, -79],
        [-29, -42]
      ],
      [
        [16363, 11813],
        [15, -57],
        [-32, -103]
      ],
      [
        [7865, 4559],
        [-31, -13]
      ],
      [
        [7834, 4546],
        [-56, 22],
        [-68, -74],
        [-45, 16],
        [-21, 42]
      ],
      [
        [7644, 4552],
        [-34, 30],
        [-1, 74],
        [-58, 23],
        [-11, -39],
        [-97, -4],
        [-21, -34],
        [-65, -22],
        [-44, 44]
      ],
      [
        [7313, 4624],
        [101, 47],
        [-21, 107],
        [86, 3],
        [-2, -46],
        [97, 15],
        [13, -54],
        [60, 13],
        [10, 56],
        [89, 34],
        [60, 127]
      ],
      [
        [7806, 4926],
        [27, -36],
        [89, 1],
        [35, 54]
      ],
      [
        [7957, 4945],
        [38, -87],
        [12, -123],
        [-29, -97]
      ],
      [
        [7978, 4638],
        [-64, -12],
        [-10, -75],
        [-39, 8]
      ],
      [
        [7978, 4638],
        [-33, -207]
      ],
      [
        [7945, 4431],
        [-44, 8],
        [9, 66],
        [-45, 54]
      ],
      [
        [6743, 4263],
        [16, -169],
        [86, -5],
        [52, -94]
      ],
      [
        [6897, 3995],
        [-10, -60]
      ],
      [
        [6887, 3935],
        [-105, -2],
        [-194, 119],
        [-31, 48],
        [-76, 73],
        [-55, -130],
        [-81, -108],
        [-37, -15]
      ],
      [
        [6308, 3920],
        [-89, 37],
        [-69, -6],
        [-22, 33]
      ],
      [
        [6128, 3984],
        [52, 35],
        [42, 55],
        [13, 88],
        [-31, 19],
        [9, 112]
      ],
      [
        [6213, 4293],
        [90, 3],
        [35, 56],
        [25, 85]
      ],
      [
        [6363, 4437],
        [23, 3]
      ],
      [
        [6386, 4440],
        [41, 15],
        [33, -40],
        [51, 12],
        [50, -51],
        [64, -16]
      ],
      [
        [6625, 4360],
        [46, -69],
        [72, -28]
      ],
      [
        [6897, 3995],
        [41, 33],
        [32, 101],
        [65, 139]
      ],
      [
        [7035, 4268],
        [26, 40],
        [48, -13],
        [61, 55],
        [94, 28]
      ],
      [
        [7264, 4378],
        [158, -83],
        [15, 148],
        [57, -15]
      ],
      [
        [7494, 4428],
        [121, -80],
        [-3, -36],
        [-72, -46],
        [61, -32],
        [13, -40]
      ],
      [
        [7614, 4194],
        [-24, -85],
        [-44, -51]
      ],
      [
        [7546, 4058],
        [-123, 21],
        [-45, 50],
        [-99, 0],
        [12, -87],
        [-26, -114],
        [45, -30],
        [-70, -69]
      ],
      [
        [7240, 3829],
        [-30, -8],
        [-109, 36],
        [-30, -39],
        [-102, -3],
        [-26, -20]
      ],
      [
        [6943, 3795],
        [-22, 89],
        [-34, 51]
      ],
      [
        [6943, 3795],
        [-6, -62],
        [-53, -21]
      ],
      [
        [6884, 3712],
        [-21, -34],
        [-74, -4],
        [-101, 56],
        [-61, 62],
        [-128, -31],
        [-44, -30],
        [-137, 10],
        [-56, 31]
      ],
      [
        [6262, 3772],
        [21, 61],
        [44, 56],
        [-19, 31]
      ],
      [
        [6884, 3712],
        [43, -13],
        [-33, -60],
        [38, -56],
        [68, -3],
        [-12, -54],
        [37, -66]
      ],
      [
        [7025, 3460],
        [-29, -100],
        [-38, 47],
        [-58, -20],
        [7, -36]
      ],
      [
        [6907, 3351],
        [-60, -42],
        [-55, 67]
      ],
      [
        [6792, 3376],
        [-34, 61],
        [3, 78],
        [-89, -7],
        [-39, -26],
        [-129, -25],
        [-127, -75],
        [-102, 35]
      ],
      [
        [6275, 3417],
        [24, 35],
        [10, 111],
        [-38, -9],
        [13, 115],
        [-22, 103]
      ],
      [
        [6275, 3417],
        [-8, -34],
        [81, -109],
        [36, -16],
        [20, -122],
        [26, -5]
      ],
      [
        [6430, 3131],
        [-41, -34],
        [-61, 25]
      ],
      [
        [6328, 3122],
        [-90, 47],
        [-91, -11],
        [-18, 52],
        [2, 89],
        [-93, 11],
        [-76, 26],
        [-46, -12]
      ],
      [
        [5916, 3324],
        [-24, 51],
        [-96, -15]
      ],
      [
        [5796, 3360],
        [29, 116],
        [-105, 36]
      ],
      [
        [5720, 3512],
        [-8, 44],
        [48, 102],
        [68, 14],
        [64, -30],
        [119, 26],
        [89, -30],
        [43, 128],
        [119, 6]
      ],
      [
        [5796, 3360],
        [-74, -33],
        [-6, -38],
        [-88, -35]
      ],
      [
        [5628, 3254],
        [-51, -33],
        [-122, 5]
      ],
      [
        [5455, 3226],
        [52, 50],
        [17, 65],
        [-57, 21],
        [-148, 101]
      ],
      [
        [5319, 3463],
        [94, 54],
        [26, 51]
      ],
      [
        [5439, 3568],
        [61, 24],
        [32, -60],
        [129, -3],
        [59, -17]
      ],
      [
        [6792, 3376],
        [-24, -92],
        [-83, -162],
        [-61, 26],
        [-43, -59]
      ],
      [
        [6581, 3089],
        [-41, 46],
        [-73, 15],
        [-37, -19]
      ],
      [
        [7025, 3460],
        [23, -11]
      ],
      [
        [7048, 3449],
        [55, -75],
        [135, -19]
      ],
      [
        [7238, 3355],
        [-25, -34],
        [-40, -162],
        [-41, -37]
      ],
      [
        [7132, 3122],
        [-21, 26],
        [-140, 19],
        [-39, -37],
        [-17, 69],
        [25, 36],
        [13, 80],
        [-46, 36]
      ],
      [
        [5916, 3324],
        [9, -122],
        [66, -39],
        [-63, -36],
        [11, -105],
        [43, -12],
        [30, -67],
        [-64, -7],
        [-41, -38],
        [16, -121],
        [-44, 0],
        [-11, -88],
        [11, -108]
      ],
      [
        [5879, 2581],
        [-26, -38]
      ],
      [
        [5853, 2543],
        [-45, -31],
        [-54, 24]
      ],
      [
        [5754, 2536],
        [-1, 1]
      ],
      [
        [5753, 2537],
        [-4, 4]
      ],
      [
        [5749, 2541],
        [-38, 58]
      ],
      [
        [5711, 2599],
        [-12, 61],
        [15, 126],
        [45, 135],
        [-50, 64],
        [-114, 50],
        [64, 102],
        [-39, 64],
        [8, 53]
      ],
      [
        [7132, 3122],
        [-18, -64],
        [16, -56]
      ],
      [
        [7130, 3002],
        [-38, -3],
        [-50, -46],
        [3, -88]
      ],
      [
        [7045, 2865],
        [-75, -38],
        [-86, 37],
        [-50, -13],
        [-60, -54],
        [30, -171]
      ],
      [
        [6804, 2626],
        [-37, 24],
        [-46, -72]
      ],
      [
        [6721, 2578],
        [-29, -7]
      ],
      [
        [6692, 2571],
        [-35, 52],
        [23, 49],
        [-71, 25],
        [-5, 53]
      ],
      [
        [6604, 2750],
        [29, 5],
        [32, 108],
        [56, 17],
        [28, -40],
        [95, 51],
        [8, 80],
        [-115, 80],
        [-128, -2],
        [-28, 40]
      ],
      [
        [7238, 3355],
        [130, 29],
        [14, -37],
        [71, -39],
        [8, -62],
        [-34, -57]
      ],
      [
        [7427, 3189],
        [-39, -61],
        [-70, -38],
        [-45, -49],
        [-143, -39]
      ],
      [
        [6328, 3122],
        [-11, -113],
        [47, -47],
        [-16, -115]
      ],
      [
        [6348, 2847],
        [-57, -36],
        [-88, 38],
        [-47, -56],
        [-63, 14],
        [-32, -54],
        [10, -74],
        [-40, -1],
        [4, -128],
        [-27, -29]
      ],
      [
        [6008, 2521],
        [-70, 91],
        [-59, -31]
      ],
      [
        [7427, 3189],
        [45, 24]
      ],
      [
        [7472, 3213],
        [17, -39],
        [-24, -116]
      ],
      [
        [7465, 3058],
        [-40, -77],
        [-101, 52],
        [-21, -35],
        [25, -46],
        [-2, -59],
        [28, -110],
        [89, -75],
        [12, -87]
      ],
      [
        [7455, 2621],
        [-19, -39]
      ],
      [
        [7436, 2582],
        [-55, 1],
        [-79, -64],
        [-26, -67]
      ],
      [
        [7276, 2452],
        [-73, 71],
        [24, 83],
        [-13, 108],
        [35, 33],
        [-35, 65],
        [-41, 29],
        [-99, -1],
        [-29, 25]
      ],
      [
        [6604, 2750],
        [-39, 11],
        [9, 133],
        [18, 48],
        [-100, -22],
        [-35, -102],
        [-109, 29]
      ],
      [
        [7465, 3058],
        [88, 31],
        [64, -12]
      ],
      [
        [7617, 3077],
        [-16, -49]
      ],
      [
        [7601, 3028],
        [-36, -11],
        [-11, -65],
        [21, -67],
        [-11, -115],
        [31, -35],
        [-55, -108],
        [-85, -6]
      ],
      [
        [6692, 2571],
        [-3, -53],
        [-32, -72],
        [-44, -39],
        [-46, 78],
        [-80, 1],
        [-70, -80],
        [-71, -5],
        [-60, -30]
      ],
      [
        [6286, 2371],
        [-14, 87],
        [-48, 50],
        [-100, -61],
        [-69, 15],
        [-60, -21]
      ],
      [
        [5995, 2441],
        [13, 80]
      ],
      [
        [6721, 2578],
        [48, -139],
        [3, -110],
        [-91, -30],
        [-5, -45],
        [-103, 7],
        [-10, -82]
      ],
      [
        [6563, 2179],
        [-49, -15],
        [-31, -74],
        [-157, 2],
        [-42, 46],
        [-43, -1],
        [-70, -32],
        [-40, -71]
      ],
      [
        [6131, 2034],
        [93, 215],
        [40, 54],
        [22, 68]
      ],
      [
        [6131, 2034],
        [-48, -27]
      ],
      [
        [6083, 2007],
        [-55, 56],
        [-32, -22],
        [-67, 29],
        [52, 136],
        [-22, 57],
        [33, 110],
        [3, 68]
      ],
      [
        [6563, 2179],
        [47, 14],
        [67, -43],
        [19, -46],
        [58, -36]
      ],
      [
        [6754, 2068],
        [-33, -23],
        [-31, -84],
        [-73, -11],
        [16, -48],
        [78, -23],
        [-54, -47]
      ],
      [
        [6657, 1832],
        [-45, 15],
        [-28, 46],
        [-73, -4],
        [-91, -117],
        [-46, 31]
      ],
      [
        [6374, 1803],
        [-91, 33],
        [-131, 30],
        [-48, 43],
        [-62, 21]
      ],
      [
        [6042, 1930],
        [41, 77]
      ],
      [
        [6657, 1832],
        [-4, -99],
        [72, -40]
      ],
      [
        [6725, 1693],
        [-102, -87],
        [-37, -66],
        [-7, -57],
        [22, -39],
        [-37, -52],
        [3, -130],
        [-56, -89],
        [-57, -32]
      ],
      [
        [6454, 1141],
        [-78, 16],
        [-23, 150],
        [4, 157],
        [-11, 72],
        [-76, 89],
        [9, 46]
      ],
      [
        [6279, 1671],
        [-18, 54],
        [121, 44],
        [-8, 34]
      ],
      [
        [6205, 999],
        [-22, -46],
        [-72, 13],
        [-139, 63],
        [-88, 81]
      ],
      [
        [5884, 1110],
        [107, 156],
        [5, 52]
      ],
      [
        [5996, 1318],
        [111, -52],
        [33, -86],
        [48, -82],
        [-15, -84],
        [32, -15]
      ],
      [
        [7546, 4058],
        [104, -6],
        [49, -68],
        [88, 8]
      ],
      [
        [7787, 3992],
        [-81, -138],
        [-18, -11]
      ],
      [
        [7688, 3843],
        [0, -31]
      ],
      [
        [7688, 3812],
        [-11, -37]
      ],
      [
        [7677, 3775],
        [-36, 3],
        [-65, -58]
      ],
      [
        [7576, 3720],
        [2, -52]
      ],
      [
        [7578, 3668],
        [-5, -9]
      ],
      [
        [7573, 3659],
        [-139, 55],
        [-24, -65]
      ],
      [
        [7410, 3649],
        [-84, 67],
        [-55, 0],
        [12, 56],
        [-43, 57]
      ],
      [
        [7048, 3449],
        [30, 43],
        [62, 20],
        [108, -6],
        [42, 46],
        [31, -10],
        [58, 33],
        [39, -11],
        [-8, 85]
      ],
      [
        [7573, 3659],
        [5, 9]
      ],
      [
        [7576, 3720],
        [80, -26]
      ],
      [
        [7656, 3694],
        [-1, -8]
      ],
      [
        [7655, 3686],
        [-7, -35]
      ],
      [
        [7648, 3651],
        [-23, -118],
        [4, -74],
        [30, -71]
      ],
      [
        [7659, 3388],
        [-111, -102],
        [-29, -48],
        [-47, -25]
      ],
      [
        [7276, 2452],
        [16, -63],
        [-83, -122]
      ],
      [
        [7209, 2267],
        [-2, -2]
      ],
      [
        [7207, 2265],
        [-1, -20]
      ],
      [
        [7206, 2245],
        [-2, -2]
      ],
      [
        [7204, 2243],
        [-50, 11],
        [-32, 57]
      ],
      [
        [7122, 2311],
        [-40, 57],
        [19, 54],
        [-30, 35],
        [-134, 23],
        [-37, 56],
        [-85, 54],
        [-11, 36]
      ],
      [
        [7122, 2311],
        [-104, -79],
        [-69, 26],
        [-1, -116],
        [48, -11],
        [15, -70],
        [-62, -8],
        [-46, -31],
        [-149, 46]
      ],
      [
        [7209, 2267],
        [-2, -2]
      ],
      [
        [7206, 2245],
        [-2, -2]
      ],
      [
        [7204, 2243],
        [-89, -117],
        [-33, -68],
        [-20, -92],
        [55, -80],
        [53, -44],
        [61, -10],
        [116, 19],
        [-21, -48],
        [-65, 24],
        [-75, -13],
        [-70, 10],
        [-72, -12],
        [-192, -92],
        [-101, -10],
        [-26, -17]
      ],
      [
        [7601, 3028],
        [62, -36],
        [20, -38]
      ],
      [
        [7683, 2954],
        [15, -340],
        [-8, -56],
        [-60, -8],
        [-194, 32]
      ],
      [
        [7659, 3388],
        [29, -180],
        [-4, -139]
      ],
      [
        [7684, 3069],
        [-67, 8]
      ],
      [
        [6279, 1671],
        [-51, -5],
        [-37, -195],
        [-65, 17],
        [-15, -51],
        [-55, 6],
        [-38, 30],
        [-31, 64]
      ],
      [
        [5987, 1537],
        [-41, 34],
        [-29, 61],
        [36, 44]
      ],
      [
        [5953, 1676],
        [42, 60],
        [9, 106]
      ],
      [
        [6004, 1842],
        [38, 88]
      ],
      [
        [6454, 1141],
        [-84, -61],
        [-31, -64],
        [-134, -17]
      ],
      [
        [5996, 1318],
        [-65, 119],
        [19, 21]
      ],
      [
        [5950, 1458],
        [37, 79]
      ],
      [
        [7035, 4268],
        [-59, 34],
        [26, 91],
        [-17, 30],
        [-80, 13],
        [-37, -15]
      ],
      [
        [6868, 4421],
        [12, 107],
        [85, 46],
        [92, 30],
        [67, -7],
        [110, -48],
        [47, 62],
        [-4, 38]
      ],
      [
        [7277, 4649],
        [43, -77],
        [-18, -48],
        [-51, -53],
        [13, -93]
      ],
      [
        [7644, 4552],
        [-145, -91],
        [-5, -33]
      ],
      [
        [7277, 4649],
        [36, -25]
      ],
      [
        [6743, 4263],
        [118, 113],
        [7, 45]
      ],
      [
        [7834, 4546],
        [16, -44],
        [-34, -85],
        [-63, -35],
        [-31, 6],
        [10, -121],
        [-66, -9],
        [-52, -64]
      ],
      [
        [7945, 4431],
        [3, -57],
        [-58, -182],
        [-18, -86],
        [-85, -114]
      ],
      [
        [5677, 10760],
        [1, -69],
        [-106, -96],
        [27, -37]
      ],
      [
        [5599, 10558],
        [-26, -70],
        [-87, 5],
        [-8, -32],
        [-62, -52]
      ],
      [
        [5416, 10409],
        [-141, 2],
        [-5, 128],
        [-42, 85],
        [-71, -2]
      ],
      [
        [5157, 10622],
        [15, 73],
        [-38, 57],
        [82, 18]
      ],
      [
        [5216, 10770],
        [65, -22],
        [131, 41],
        [89, -27],
        [65, 9],
        [111, -11]
      ],
      [
        [8214, 10596],
        [-31, -78],
        [-98, -37],
        [-16, -57],
        [16, -122],
        [54, 4],
        [10, -81]
      ],
      [
        [8149, 10225],
        [-112, -12],
        [-38, 10],
        [-16, -67],
        [-43, -53],
        [-121, 41],
        [-49, -25]
      ],
      [
        [7770, 10119],
        [8, 52],
        [-86, 24],
        [50, 127],
        [86, 0],
        [-5, 178],
        [-83, 39],
        [-73, 13],
        [-19, 75],
        [55, 37],
        [25, 71]
      ],
      [
        [7728, 10735],
        [97, 22],
        [36, 41],
        [96, 5],
        [70, -68],
        [31, -61],
        [69, -33],
        [61, -54],
        [26, 9]
      ],
      [
        [7770, 10119],
        [-32, -3]
      ],
      [
        [7738, 10116],
        [-120, 12],
        [-58, -17],
        [-93, 35]
      ],
      [
        [7467, 10146],
        [7, 44],
        [82, 138],
        [-37, 78],
        [-68, 48],
        [37, 24],
        [16, 77],
        [-65, 110],
        [0, 46],
        [41, 36]
      ],
      [
        [7480, 10747],
        [131, 45],
        [117, -57]
      ],
      [
        [5416, 10409],
        [10, -32],
        [-34, -59],
        [-119, 62],
        [-56, -93],
        [23, -12],
        [-84, -95],
        [14, -83]
      ],
      [
        [5170, 10097],
        [-49, -53],
        [-70, -14],
        [-46, 42],
        [-143, -5],
        [-5, -37],
        [-86, -25],
        [-5, 41],
        [-86, -1],
        [-20, -59],
        [-44, -13],
        [-35, -47],
        [13, -45],
        [-86, -10],
        [-39, -48]
      ],
      [
        [4469, 9823],
        [-46, 47],
        [-41, 80],
        [7, 136]
      ],
      [
        [4389, 10086],
        [79, 18],
        [35, 59],
        [-16, 119],
        [-32, 19],
        [-2, 75],
        [-34, 21],
        [24, 65],
        [45, 33],
        [48, -2],
        [62, 63],
        [-7, 47],
        [59, 50]
      ],
      [
        [4650, 10653],
        [112, -23],
        [148, 7]
      ],
      [
        [4910, 10637],
        [247, -15]
      ],
      [
        [9919, 10628],
        [-50, -173],
        [-75, -20],
        [-73, 46],
        [-213, -15],
        [-1, -48]
      ],
      [
        [9507, 10418],
        [-51, -103],
        [-47, -28],
        [-19, -60],
        [-79, 35]
      ],
      [
        [9311, 10262],
        [-92, 47],
        [-24, 56],
        [-113, 49]
      ],
      [
        [9082, 10414],
        [26, 109],
        [77, 57],
        [31, 49]
      ],
      [
        [9216, 10629],
        [38, -44],
        [90, -41],
        [54, 48],
        [147, 2],
        [-4, 112],
        [122, 52],
        [37, -43]
      ],
      [
        [9700, 10715],
        [82, -44],
        [137, -43]
      ],
      [
        [9921, 10628],
        [2, 0]
      ],
      [
        [9923, 10628],
        [-2, 0]
      ],
      [
        [6638, 10594],
        [52, -59],
        [75, -9],
        [101, -93],
        [34, -55],
        [49, -21],
        [4, -42],
        [62, -39],
        [75, -91],
        [71, -22],
        [60, -43],
        [51, -70]
      ],
      [
        [7272, 10050],
        [-58, -91],
        [-52, 6],
        [-154, -50],
        [-12, -71]
      ],
      [
        [6996, 9844],
        [-39, -4],
        [-61, 91],
        [-55, 15],
        [-35, 62],
        [-64, -9],
        [-97, 48],
        [8, 83]
      ],
      [
        [6653, 10130],
        [25, 32],
        [-36, 109],
        [-75, 49],
        [1, 135],
        [-60, 84],
        [17, 73],
        [113, -18]
      ],
      [
        [5599, 10558],
        [40, 6],
        [39, -70]
      ],
      [
        [5678, 10494],
        [-6, -79],
        [15, -59],
        [-21, -107],
        [6, -59],
        [-27, -87],
        [33, -38],
        [-9, -62],
        [-40, -13],
        [23, -118],
        [50, -42]
      ],
      [
        [5702, 9830],
        [-48, -54],
        [7, -57],
        [-58, -1],
        [-7, -91],
        [-33, -56],
        [21, -42]
      ],
      [
        [5584, 9529],
        [-67, -13]
      ],
      [
        [5517, 9516],
        [-28, 52],
        [-56, 0],
        [-73, -37],
        [-130, -9],
        [-12, 41],
        [-76, 62],
        [86, 71],
        [30, 149],
        [-36, 48],
        [-36, -45],
        [-42, 47],
        [-17, 96],
        [23, 22]
      ],
      [
        [5150, 10013],
        [39, 17],
        [-19, 67]
      ],
      [
        [3057, 9722],
        [-23, 81],
        [25, 68],
        [33, 23]
      ],
      [
        [3092, 9894],
        [38, 68]
      ],
      [
        [3130, 9962],
        [11, 83],
        [-32, 127]
      ],
      [
        [3109, 10172],
        [77, -4],
        [49, -33],
        [17, -72],
        [95, 1],
        [26, -16],
        [97, 32]
      ],
      [
        [3470, 10080],
        [43, -29],
        [-3, -64],
        [-42, -80],
        [8, -132],
        [-76, 4],
        [-33, -64]
      ],
      [
        [3367, 9715],
        [-25, -1]
      ],
      [
        [3342, 9714],
        [-50, 57],
        [21, 65],
        [-81, 27],
        [-72, -22],
        [19, -63]
      ],
      [
        [3179, 9778],
        [-58, 13],
        [-64, -69]
      ],
      [
        [5678, 10494],
        [141, 2],
        [110, 34],
        [6, -124],
        [-31, -152],
        [103, -12],
        [159, 2],
        [53, -36],
        [0, -59]
      ],
      [
        [6219, 10149],
        [-86, -41],
        [-13, -33],
        [-78, -30],
        [0, -67],
        [-72, -7],
        [-31, -55],
        [-110, 10],
        [-127, -96]
      ],
      [
        [12112, 10205],
        [-15, 43],
        [-68, 9],
        [-88, -14],
        [-52, 44],
        [3, 78]
      ],
      [
        [11892, 10365],
        [53, 161]
      ],
      [
        [11945, 10526],
        [97, -74],
        [90, -20],
        [13, 45],
        [84, 44],
        [38, -12]
      ],
      [
        [12267, 10509],
        [-4, -87],
        [81, -170],
        [-6, -50],
        [-67, -6],
        [-39, -35]
      ],
      [
        [12232, 10161],
        [-30, 23],
        [-90, 21]
      ],
      [
        [11517, 10454],
        [25, -106],
        [62, -43],
        [47, -4],
        [-12, -59],
        [86, -27],
        [-75, -79]
      ],
      [
        [11650, 10136],
        [-18, -31],
        [-66, 10],
        [-53, -35],
        [-33, -54],
        [-46, -26],
        [-53, 16],
        [-31, -37],
        [-134, 24],
        [-82, 71]
      ],
      [
        [11134, 10074],
        [-8, 49],
        [49, 13],
        [43, 69],
        [-16, 201],
        [27, 75],
        [80, 6]
      ],
      [
        [11309, 10487],
        [68, -50],
        [31, 38],
        [105, 1],
        [4, -22]
      ],
      [
        [12112, 10205],
        [-38, -15],
        [-25, -63],
        [-48, -10],
        [-49, -59],
        [-64, -9]
      ],
      [
        [11888, 10049],
        [-88, 44],
        [-68, -36],
        [-82, 79]
      ],
      [
        [11517, 10454],
        [72, -34],
        [62, 1],
        [72, 33],
        [15, -85],
        [55, 40],
        [99, -44]
      ],
      [
        [10580, 10297],
        [-8, -30]
      ],
      [
        [10572, 10267],
        [-49, 6],
        [-99, -50],
        [-68, 16],
        [-65, -12],
        [-49, -33],
        [-3, -46],
        [-48, -115],
        [-54, -21]
      ],
      [
        [10137, 10012],
        [-5, 55],
        [46, 72],
        [-58, 122],
        [41, 79],
        [-84, -1],
        [-35, 57]
      ],
      [
        [10042, 10396],
        [60, 13],
        [37, 38],
        [71, -7],
        [46, 24],
        [37, -42],
        [35, 59]
      ],
      [
        [10328, 10481],
        [59, -32],
        [22, -58],
        [82, -13],
        [62, -81],
        [27, 0]
      ],
      [
        [9507, 10418],
        [36, -50],
        [-8, -98],
        [13, -114]
      ],
      [
        [9548, 10156],
        [27, -72],
        [-38, -123],
        [30, -57],
        [54, -41],
        [32, -70],
        [-27, -46]
      ],
      [
        [9626, 9747],
        [-67, -129]
      ],
      [
        [9559, 9618],
        [-209, 49],
        [-8, 65],
        [23, 43],
        [-14, 99],
        [25, 68],
        [-69, 93],
        [29, 51],
        [-16, 50],
        [-9, 126]
      ],
      [
        [10137, 10012],
        [-12, -31],
        [54, -48]
      ],
      [
        [10179, 9933],
        [-10, -24]
      ],
      [
        [10169, 9909],
        [-21, -27],
        [-78, 47],
        [-51, -10],
        [-39, -62],
        [-81, -44],
        [-8, -38],
        [-53, -26],
        [-35, 23],
        [-49, -21],
        [-128, -4]
      ],
      [
        [9548, 10156],
        [123, 130],
        [60, -45],
        [98, 9],
        [56, 53],
        [45, -56],
        [78, 26],
        [-12, 73],
        [46, 50]
      ],
      [
        [4469, 9823],
        [-25, -66],
        [-51, 51],
        [-68, -84],
        [14, -39],
        [-43, -98]
      ],
      [
        [4296, 9587],
        [-230, 28],
        [-29, -57],
        [58, -25],
        [7, -51],
        [-135, -52],
        [-31, -65],
        [-64, 24],
        [-63, -1],
        [-56, 50],
        [-41, -73],
        [-48, -32],
        [-57, -8]
      ],
      [
        [3607, 9325],
        [-86, 101]
      ],
      [
        [3521, 9426],
        [-22, 29],
        [-29, 185],
        [-64, 27],
        [-39, 48]
      ],
      [
        [3470, 10080],
        [44, 70]
      ],
      [
        [3514, 10150],
        [92, -69],
        [25, -44],
        [60, 0],
        [61, 41],
        [24, 79],
        [28, -4],
        [16, 84]
      ],
      [
        [3820, 10237],
        [51, -4],
        [90, 20],
        [146, -16],
        [36, -27],
        [67, 25],
        [83, -45],
        [-10, -59],
        [106, -45]
      ],
      [
        [10572, 10267],
        [53, -35],
        [8, -49],
        [131, -55],
        [51, -48],
        [84, -15]
      ],
      [
        [10899, 10065],
        [-56, -124],
        [-112, -27]
      ],
      [
        [10731, 9914],
        [-80, 98],
        [-12, 88],
        [-61, 15],
        [-33, -66],
        [-230, 1],
        [-51, -54],
        [12, -53],
        [-97, -10]
      ],
      [
        [8149, 10225],
        [12, -109],
        [-39, -68],
        [63, 4],
        [-17, -140],
        [23, -44],
        [-151, -64],
        [24, -79],
        [48, 6],
        [26, -32]
      ],
      [
        [8138, 9699],
        [-10, -117],
        [-40, -82],
        [51, -6],
        [11, -43],
        [71, -41]
      ],
      [
        [8221, 9410],
        [28, -63],
        [118, -70],
        [-28, -113]
      ],
      [
        [8339, 9164],
        [-66, -56],
        [-91, 16],
        [-23, 64],
        [-62, -44],
        [-58, -109],
        [-40, -31],
        [-2, -54],
        [-38, -93],
        [51, -69],
        [-49, -60],
        [1, -33]
      ],
      [
        [7962, 8695],
        [-103, -29],
        [-65, 66],
        [-69, 40]
      ],
      [
        [7725, 8772],
        [31, 29],
        [-14, 123],
        [-53, 49],
        [46, 41]
      ],
      [
        [7735, 9014],
        [32, 175],
        [-22, 52],
        [-52, 29],
        [-38, 50]
      ],
      [
        [7655, 9320],
        [-16, 108],
        [-29, 64],
        [43, 56],
        [-13, 85],
        [45, 15],
        [41, -44],
        [49, 55],
        [-15, 53],
        [13, 70],
        [-29, 55],
        [19, 46],
        [-31, 147],
        [6, 86]
      ],
      [
        [6219, 10149],
        [30, -58],
        [-4, -54]
      ],
      [
        [6245, 10037],
        [15, -19],
        [-65, -101],
        [24, -99],
        [36, -12],
        [3, -106],
        [-59, -53],
        [-36, 50],
        [-100, -37],
        [-57, -100]
      ],
      [
        [6006, 9560],
        [-46, 47],
        [-73, -30],
        [-44, 55],
        [-172, -53],
        [-21, -45],
        [-66, -5]
      ],
      [
        [11888, 10049],
        [-20, -31],
        [16, -110],
        [-16, -16]
      ],
      [
        [11868, 9892],
        [-156, 9],
        [19, -66],
        [73, -53],
        [-6, -51],
        [26, -66]
      ],
      [
        [11824, 9665],
        [-37, -12],
        [-29, 49]
      ],
      [
        [11758, 9702],
        [-132, 184],
        [-61, 56],
        [-45, -22],
        [-61, -81],
        [-65, 10],
        [-127, -20]
      ],
      [
        [11267, 9829],
        [24, 64],
        [-136, 9],
        [-203, 108]
      ],
      [
        [10952, 10010],
        [32, 40],
        [116, -1],
        [34, 25]
      ],
      [
        [7655, 9320],
        [-41, 22],
        [-178, -79],
        [-69, 55],
        [-74, 12],
        [-41, -97],
        [-61, 53],
        [-105, 13]
      ],
      [
        [7086, 9299],
        [13, 77],
        [-63, 24],
        [-12, 53]
      ],
      [
        [7024, 9453],
        [41, -18],
        [44, 51],
        [66, 8],
        [23, 139],
        [-101, 118],
        [-21, 60],
        [-69, -2],
        [-11, 35]
      ],
      [
        [7272, 10050],
        [65, 2],
        [22, 49],
        [54, 6],
        [54, 39]
      ],
      [
        [7024, 9453],
        [-174, 41],
        [-94, -3],
        [-33, 48],
        [-49, 23]
      ],
      [
        [6674, 9562],
        [-66, -10],
        [-165, 8],
        [-68, -82],
        [9, -37],
        [110, -39],
        [38, -40],
        [59, 10],
        [6, -67],
        [-79, -73],
        [-105, 55],
        [-71, -61],
        [-32, 43],
        [-66, 35],
        [-28, 66],
        [-97, 25]
      ],
      [
        [6119, 9395],
        [-63, 129],
        [-50, 36]
      ],
      [
        [6245, 10037],
        [84, -18],
        [127, 35],
        [42, 56],
        [60, -13],
        [95, 33]
      ],
      [
        [10731, 9914],
        [21, -105],
        [29, -56]
      ],
      [
        [10781, 9753],
        [-65, -24],
        [-22, 19],
        [-59, -103],
        [17, -51],
        [48, -2],
        [-1, -70],
        [-54, -8],
        [-68, 25],
        [-59, -14],
        [-16, -89],
        [52, -53],
        [-4, -67]
      ],
      [
        [10550, 9316],
        [-68, 41],
        [-124, 4]
      ],
      [
        [10358, 9361],
        [-62, 54],
        [-51, 5],
        [-78, -43],
        [-19, 114],
        [-59, 30],
        [21, 54],
        [-42, 22]
      ],
      [
        [10068, 9597],
        [60, 101],
        [80, 2],
        [47, 81],
        [-41, 18],
        [-9, 95],
        [-36, 15]
      ],
      [
        [5517, 9516],
        [-16, -17]
      ],
      [
        [5501, 9499],
        [-18, -20],
        [2, -88],
        [-25, -11],
        [-5, -88],
        [-44, -2],
        [-7, -49],
        [-50, -27],
        [-16, -73],
        [-36, -43]
      ],
      [
        [5302, 9098],
        [-68, 25],
        [-105, -12],
        [-21, 73],
        [-105, -25],
        [-95, 20]
      ],
      [
        [4908, 9179],
        [32, 134],
        [-37, 22],
        [22, 50],
        [-5, 74],
        [20, 100],
        [-7, 72],
        [-34, 0],
        [34, 130],
        [79, 194],
        [48, 4],
        [28, 75],
        [62, -21]
      ],
      [
        [10899, 10065],
        [53, -55]
      ],
      [
        [11267, 9829],
        [-5, -36],
        [-65, -6],
        [-7, -65],
        [98, 41],
        [12, -85],
        [49, -73],
        [-24, -34],
        [-168, -14],
        [-25, 21],
        [-120, -26]
      ],
      [
        [11012, 9552],
        [-25, 68],
        [-68, 72],
        [22, 92],
        [-83, 45],
        [-77, -76]
      ],
      [
        [8138, 9699],
        [26, 56],
        [45, 36],
        [40, -26],
        [23, 73],
        [52, 13],
        [20, 57],
        [86, 52]
      ],
      [
        [8430, 9960],
        [103, -60],
        [48, 31],
        [67, 105],
        [56, -7]
      ],
      [
        [8704, 10029],
        [30, -29],
        [92, 4],
        [62, -28],
        [67, -112],
        [-13, -69],
        [26, -47]
      ],
      [
        [8968, 9748],
        [-88, -27],
        [-62, 47],
        [-88, -35],
        [-41, -72],
        [-63, -19],
        [23, -60],
        [52, -43],
        [-21, -73]
      ],
      [
        [8680, 9466],
        [-141, -18],
        [-48, -35],
        [-50, 77],
        [-39, 13],
        [-40, 78],
        [-29, 7],
        [-62, -69],
        [-50, -109]
      ],
      [
        [11758, 9702],
        [-119, 4],
        [-8, 54],
        [-120, -30],
        [-16, -55],
        [-83, -76],
        [8, -80],
        [-82, 22],
        [-71, -71],
        [-51, -13],
        [-45, -69]
      ],
      [
        [11171, 9388],
        [-30, 48],
        [-87, 48],
        [-42, 68]
      ],
      [
        [10068, 9597],
        [-60, -28],
        [32, -134],
        [-55, -85],
        [-69, -53],
        [-51, -66],
        [-76, 76],
        [-59, -81],
        [-40, -154],
        [-31, -31]
      ],
      [
        [9659, 9041],
        [-10, 7]
      ],
      [
        [9649, 9048],
        [-22, 85],
        [-43, 4],
        [-44, 67],
        [-80, 91],
        [-13, 49],
        [31, 119]
      ],
      [
        [9478, 9463],
        [67, 40],
        [14, 115]
      ],
      [
        [11868, 9892],
        [95, 0],
        [38, -26],
        [99, 8],
        [78, -31],
        [35, 27]
      ],
      [
        [12213, 9870],
        [-63, -52],
        [-96, -60],
        [-107, -145]
      ],
      [
        [11947, 9613],
        [-65, 43],
        [-58, 9]
      ],
      [
        [11947, 9613],
        [-93, -59],
        [-224, -64],
        [-135, -49],
        [-213, -114],
        [-118, -88]
      ],
      [
        [11164, 9239],
        [7, 149]
      ],
      [
        [4296, 9587],
        [-51, -120],
        [82, -1],
        [86, -97],
        [23, 7],
        [176, -49],
        [67, -48],
        [48, -13],
        [24, -78],
        [72, 21]
      ],
      [
        [4823, 9209],
        [36, -37],
        [-7, -71],
        [-76, -58],
        [30, -84],
        [-92, 11],
        [-16, -46],
        [-64, 43],
        [-14, -41],
        [-62, 13],
        [-84, 57],
        [-18, -70],
        [-59, -76],
        [141, -123],
        [76, -89],
        [34, 71],
        [45, -7],
        [34, 55],
        [34, -26],
        [133, -53]
      ],
      [
        [4894, 8678],
        [-80, -66],
        [-31, -54],
        [-67, -8]
      ],
      [
        [4716, 8550],
        [-46, 14],
        [-89, -36],
        [-10, -43],
        [-115, -38],
        [-54, -32]
      ],
      [
        [4402, 8415],
        [-15, 34],
        [-172, 92],
        [21, 30],
        [-70, 67],
        [3, 33],
        [-60, 85],
        [-137, 166],
        [39, 66],
        [-10, 58],
        [-123, 35],
        [-21, 79],
        [-41, -15],
        [-102, 35]
      ],
      [
        [3714, 9180],
        [-57, 35],
        [14, 36],
        [-60, 42],
        [-4, 32]
      ],
      [
        [9649, 9048],
        [-34, -39],
        [-67, 29],
        [-56, -24],
        [-64, 32],
        [-76, -27],
        [-32, 14],
        [-96, -46]
      ],
      [
        [9224, 8987],
        [-29, 59],
        [18, 164],
        [-41, 1],
        [-17, 64],
        [-47, -7]
      ],
      [
        [9108, 9268],
        [20, 88],
        [4, 118],
        [-52, 8],
        [-11, 42],
        [-65, 31],
        [-16, 36],
        [20, 72]
      ],
      [
        [9008, 9663],
        [0, 1]
      ],
      [
        [9008, 9664],
        [46, 39],
        [47, -41]
      ],
      [
        [9101, 9662],
        [34, 6],
        [75, -53],
        [55, -7],
        [50, -101],
        [66, 54],
        [56, -23],
        [41, -75]
      ],
      [
        [6119, 9395],
        [8, -138],
        [-59, -112],
        [-44, 12],
        [-87, -92],
        [-14, -105],
        [-48, 18]
      ],
      [
        [5875, 8978],
        [-71, 152],
        [-57, 27],
        [-26, 112],
        [41, 97],
        [-79, 21],
        [-69, 63],
        [-113, 49]
      ],
      [
        [10358, 9361],
        [26, -76],
        [-21, -98],
        [44, -14],
        [4, -63],
        [-27, -56],
        [35, -59],
        [-54, -98],
        [-103, 15]
      ],
      [
        [10262, 8912],
        [-30, -18],
        [6, -60]
      ],
      [
        [10238, 8834],
        [-61, 137],
        [-36, -2],
        [-83, -45],
        [-14, -57],
        [-73, 45]
      ],
      [
        [9971, 8912],
        [-45, 76],
        [-29, -70],
        [-65, 80],
        [-74, -55],
        [-11, 44],
        [-88, 54]
      ],
      [
        [6674, 9562],
        [38, -95],
        [-14, -49],
        [-44, -16],
        [20, -62],
        [2, -91],
        [-64, -39],
        [-12, -81]
      ],
      [
        [6600, 9129],
        [-12, -57],
        [-87, 24],
        [-64, 52],
        [-53, -28],
        [-2, -90],
        [-41, -78],
        [30, -120],
        [69, -47]
      ],
      [
        [6440, 8785],
        [-71, -28],
        [-34, -89],
        [-38, -12],
        [6, -80]
      ],
      [
        [6303, 8576],
        [-93, -5],
        [-8, -75],
        [-39, -54],
        [17, -58]
      ],
      [
        [6180, 8384],
        [-56, -22],
        [-37, 29],
        [3, 66],
        [-63, 36],
        [-34, -14]
      ],
      [
        [5993, 8479],
        [21, 90],
        [-19, 48],
        [-75, 25],
        [-1, 39],
        [-69, -13],
        [5, 63],
        [-42, 43]
      ],
      [
        [5813, 8774],
        [-22, 76],
        [44, -1],
        [40, 129]
      ],
      [
        [8680, 9466],
        [0, -36],
        [73, -31],
        [-38, -151],
        [32, -6],
        [-4, -69],
        [-83, -42]
      ],
      [
        [8660, 9131],
        [-30, 12],
        [-110, -58]
      ],
      [
        [8520, 9085],
        [-114, -14],
        [-2, 54],
        [-65, 39]
      ],
      [
        [5813, 8774],
        [-78, 2],
        [-97, -59]
      ],
      [
        [5638, 8717],
        [-89, 89],
        [0, 51],
        [-71, 8],
        [-76, 148],
        [2, 55],
        [-102, 30]
      ],
      [
        [4402, 8415],
        [7, -65],
        [69, 14],
        [48, -55],
        [59, 6],
        [-12, -94],
        [-29, -34],
        [41, -60],
        [-39, -25],
        [-123, 35],
        [-101, 56]
      ],
      [
        [4322, 8193],
        [-36, 28],
        [-127, -16],
        [-70, 37],
        [-35, -22],
        [-118, 48],
        [-140, 19],
        [-31, -93],
        [-131, -1]
      ],
      [
        [3634, 8193],
        [-42, 57],
        [39, 47],
        [-73, 25],
        [-3, 26],
        [-76, 44],
        [-14, 71],
        [6, 72],
        [-56, 42],
        [43, 70],
        [-22, 49],
        [9, 54],
        [40, 57],
        [20, 66],
        [47, 48],
        [-4, 72]
      ],
      [
        [3548, 8993],
        [5, 35],
        [63, 19],
        [98, 133]
      ],
      [
        [5638, 8717],
        [8, -37],
        [-92, -19],
        [-64, -44],
        [-145, -39]
      ],
      [
        [5345, 8578],
        [-113, 21],
        [-29, -12],
        [-77, 51],
        [-232, 40]
      ],
      [
        [4823, 9209],
        [85, -30]
      ],
      [
        [3099, 8934],
        [36, -49]
      ],
      [
        [3135, 8885],
        [11, -24],
        [-49, -61]
      ],
      [
        [3097, 8800],
        [-22, 30],
        [24, 104]
      ],
      [
        [9971, 8912],
        [-20, -32],
        [62, -73],
        [-136, -88],
        [-45, 24],
        [-89, -129],
        [29, -46],
        [-16, -64],
        [38, -39]
      ],
      [
        [9794, 8465],
        [-71, -31],
        [-49, 15],
        [-57, 51],
        [-22, -80],
        [-122, -47],
        [13, 65],
        [-79, 118],
        [-38, -31]
      ],
      [
        [9369, 8525],
        [-8, 56],
        [-34, 44],
        [-33, -35],
        [-93, 46],
        [-52, 72]
      ],
      [
        [9149, 8708],
        [44, 37],
        [12, 83],
        [45, 12],
        [-26, 147]
      ],
      [
        [10262, 8912],
        [64, -147],
        [95, 1],
        [35, -43],
        [88, 30],
        [62, -8],
        [76, 99],
        [-8, 18]
      ],
      [
        [10674, 8862],
        [60, 73],
        [50, -19],
        [21, 45],
        [51, 24]
      ],
      [
        [10856, 8985],
        [41, -32],
        [-105, -134],
        [-34, -73],
        [-38, -36],
        [-91, -135],
        [-135, -132],
        [-13, -44],
        [-126, -76],
        [-178, -94]
      ],
      [
        [10177, 8229],
        [-39, 57],
        [46, 91],
        [-58, 52],
        [-3, 106],
        [34, 41],
        [-55, 29],
        [-7, 83],
        [99, 70],
        [81, 22],
        [-37, 54]
      ],
      [
        [10177, 8229],
        [-94, -94]
      ],
      [
        [10083, 8135],
        [-74, 10],
        [-2, 68],
        [-85, -36],
        [-44, -117],
        [-39, -1],
        [-23, 68],
        [-68, 28],
        [0, 42],
        [95, 113],
        [75, 19],
        [-124, 136]
      ],
      [
        [5993, 8479],
        [-12, -38],
        [-119, -160],
        [-74, 27],
        [-20, -51],
        [21, -56],
        [-31, -23],
        [9, -68],
        [-94, -28],
        [-23, 16]
      ],
      [
        [5650, 8098],
        [-43, 14],
        [3, 56],
        [-53, 26],
        [-113, 2],
        [-30, 39],
        [-66, 16],
        [25, 160],
        [-32, 67],
        [4, 100]
      ],
      [
        [5650, 8098],
        [33, -53],
        [-50, -33],
        [-19, -72]
      ],
      [
        [5614, 7940],
        [-19, 26],
        [-87, 31],
        [-22, -73],
        [-40, -12]
      ],
      [
        [5446, 7912],
        [-104, 61],
        [-68, -20],
        [-24, 49],
        [-82, -12],
        [10, 56],
        [-94, 13],
        [-23, 98],
        [45, 17],
        [47, -23],
        [25, 51],
        [-53, 61],
        [6, 76],
        [-33, 93],
        [-125, 27],
        [-89, -116],
        [-26, -74],
        [-60, 51],
        [-32, 89],
        [-56, 79],
        [6, 62]
      ],
      [
        [9369, 8525],
        [-43, -47],
        [14, -39],
        [-45, -133],
        [24, -9],
        [-21, -93],
        [-45, -38],
        [-54, 44],
        [-89, 12],
        [-34, -41]
      ],
      [
        [9076, 8181],
        [-111, -41],
        [-61, -59],
        [-65, -38],
        [-144, -4]
      ],
      [
        [8695, 8039],
        [2, 55],
        [54, 61],
        [-1, 54],
        [29, 74],
        [3, 63],
        [84, 78],
        [60, 5],
        [13, 47],
        [92, 110],
        [-7, 66]
      ],
      [
        [9024, 8652],
        [125, 56]
      ],
      [
        [5446, 7912],
        [-63, -34],
        [-1, -92],
        [27, -25],
        [7, -88],
        [-100, 37],
        [-101, -21]
      ],
      [
        [5215, 7689],
        [-94, -10],
        [-24, 57],
        [-53, -21],
        [-118, 76],
        [-39, -68],
        [20, -57]
      ],
      [
        [4907, 7666],
        [-57, -47],
        [-63, 18],
        [-119, -36],
        [-104, 22],
        [-104, -58],
        [-23, 40],
        [48, 52],
        [50, 92],
        [-64, 66],
        [31, 25],
        [-51, 60]
      ],
      [
        [4451, 7900],
        [-25, 72],
        [-118, 57],
        [-34, 50],
        [48, 114]
      ],
      [
        [10083, 8135],
        [-65, -68],
        [-48, -95],
        [-121, -121],
        [-92, -38],
        [-19, -25],
        [-189, -94],
        [-105, -69]
      ],
      [
        [9444, 7625],
        [-16, 36],
        [56, 114],
        [-90, 45],
        [-36, -36],
        [-43, 20],
        [-27, 69],
        [-49, 36],
        [-148, 0],
        [9, 83],
        [-36, 47],
        [45, 88],
        [-33, 54]
      ],
      [
        [6180, 8384],
        [33, -12]
      ],
      [
        [6213, 8372],
        [-25, -58],
        [23, -75],
        [-33, -27],
        [71, -63],
        [-46, -45],
        [-32, -93],
        [-55, -62],
        [-6, -80]
      ],
      [
        [6110, 7869],
        [-87, 8],
        [-24, 23],
        [-123, 23],
        [-122, -10],
        [-140, 27]
      ],
      [
        [4451, 7900],
        [-31, -84],
        [-35, -42],
        [-73, 19],
        [-6, -62],
        [-103, 18],
        [-20, -26],
        [-139, 27],
        [-19, -93],
        [19, -64],
        [-25, -46],
        [-141, -37],
        [-59, 31],
        [-70, 68],
        [-91, 25]
      ],
      [
        [3658, 7634],
        [-18, 95],
        [18, 69],
        [33, 50],
        [-38, 95],
        [-77, 28],
        [22, 51],
        [-20, 59]
      ],
      [
        [3578, 8081],
        [56, 112]
      ],
      [
        [3658, 7634],
        [8, -66]
      ],
      [
        [3666, 7568],
        [65, -63],
        [17, -43],
        [-24, -70],
        [-56, -72],
        [67, -44],
        [26, -88]
      ],
      [
        [3761, 7188],
        [-55, -33],
        [-96, -15],
        [-14, -28],
        [-86, -36],
        [-79, 26]
      ],
      [
        [3431, 7102],
        [3, 62],
        [-30, 84],
        [8, 54],
        [-27, 63],
        [13, 68],
        [-5, 95],
        [-43, 109],
        [14, 41],
        [-40, 46],
        [-4, 144],
        [-87, 290]
      ],
      [
        [3233, 8158],
        [46, -1],
        [38, 57],
        [75, 9],
        [56, -106],
        [87, -54],
        [43, 18]
      ],
      [
        [6110, 7869],
        [15, -5]
      ],
      [
        [6125, 7864],
        [18, -8]
      ],
      [
        [6143, 7856],
        [125, -40]
      ],
      [
        [6268, 7816],
        [-113, -59],
        [-19, -55],
        [-68, -96],
        [-10, -47],
        [65, -35],
        [22, -49],
        [-20, -64]
      ],
      [
        [6125, 7411],
        [-5, -51]
      ],
      [
        [6120, 7360],
        [-77, 36],
        [-115, 4],
        [-97, -30],
        [-23, -65],
        [-47, 6],
        [-26, 57],
        [-89, -85],
        [-90, -10],
        [-88, -39]
      ],
      [
        [5468, 7234],
        [-60, 42],
        [3, 65],
        [43, 101],
        [-51, 86],
        [4, 37],
        [-83, -11],
        [-75, 68],
        [-34, 67]
      ],
      [
        [4907, 7666],
        [33, -23],
        [-19, -73],
        [31, -42],
        [-5, -99],
        [-89, -7],
        [-42, 14],
        [-81, -24]
      ],
      [
        [4735, 7412],
        [-40, 0],
        [-10, -68],
        [-54, -14],
        [-61, 79],
        [-122, -65],
        [11, -65],
        [-45, 0],
        [-101, -42]
      ],
      [
        [4313, 7237],
        [-45, 53],
        [-100, 58],
        [-44, -16],
        [-75, 37],
        [-148, 4],
        [-28, 60],
        [-114, 121],
        [-93, 14]
      ],
      [
        [4313, 7237],
        [-43, -96],
        [-39, -21],
        [-17, 59],
        [-150, -59],
        [11, -73],
        [-10, -93],
        [37, -47],
        [70, -9],
        [0, -74],
        [-71, -50],
        [60, -29],
        [-50, -98],
        [-27, -102],
        [-70, -14],
        [-19, 26]
      ],
      [
        [3995, 6557],
        [-66, 30],
        [-23, 92],
        [14, 43],
        [-63, 23],
        [-4, 39],
        [-55, 32],
        [21, 78],
        [-33, 9],
        [-38, 64],
        [36, 76],
        [-37, 73],
        [14, 72]
      ],
      [
        [8325, 6503],
        [42, 157],
        [-9, 106],
        [-54, 156],
        [-82, 103],
        [-6, 35],
        [-126, 85],
        [-67, -1],
        [-150, 48],
        [-8, 108],
        [-36, 11]
      ],
      [
        [7829, 7311],
        [-22, 73],
        [11, 39]
      ],
      [
        [7818, 7423],
        [86, 36],
        [78, -34],
        [10, -69],
        [162, -81],
        [-4, 47],
        [25, 63],
        [-44, 31],
        [-112, 11],
        [93, 67],
        [49, 61],
        [78, -50],
        [95, -32],
        [21, 22]
      ],
      [
        [8355, 7495],
        [53, -14],
        [-15, -67],
        [40, -95],
        [-15, -147],
        [29, -47],
        [112, 44],
        [32, -22],
        [60, 71],
        [9, -116],
        [62, -95],
        [75, -38]
      ],
      [
        [8797, 6969],
        [-105, -3],
        [-83, -47],
        [-34, -51],
        [-43, -170],
        [-87, -90],
        [-4, -70],
        [-46, -28],
        [-70, -7]
      ],
      [
        [4735, 7412],
        [-4, -63],
        [39, -5],
        [-7, -72]
      ],
      [
        [4763, 7272],
        [-14, -36],
        [-63, -16],
        [-5, -62],
        [-66, -17],
        [-28, -56],
        [-70, 23],
        [-13, -62],
        [36, -98],
        [57, 9],
        [12, -35],
        [56, -17],
        [34, -42],
        [-7, -59],
        [107, -3],
        [-13, -46],
        [21, -121]
      ],
      [
        [4807, 6634],
        [-57, -59],
        [-40, 5],
        [-9, -88]
      ],
      [
        [4701, 6492],
        [-57, -31],
        [-61, 17],
        [-34, -29],
        [-59, 16],
        [-89, -32],
        [-11, -77],
        [-49, -65]
      ],
      [
        [4341, 6291],
        [-82, -41],
        [-45, 42],
        [-77, -13],
        [-3, 47],
        [-52, 40],
        [-42, 3]
      ],
      [
        [4040, 6369],
        [-27, 106],
        [-78, -12]
      ],
      [
        [3935, 6463],
        [3, 50],
        [57, 44]
      ],
      [
        [6120, 7360],
        [11, -70],
        [-33, -49],
        [18, -76],
        [-24, -72],
        [-114, -32],
        [30, -47]
      ],
      [
        [6008, 7014],
        [-75, 17],
        [-11, 29],
        [-96, 53],
        [-25, -30],
        [-66, -11],
        [-19, -42],
        [-64, -16],
        [-172, -85],
        [-97, -71]
      ],
      [
        [5383, 6858],
        [-21, 65],
        [21, 104],
        [67, 8],
        [-19, 149],
        [37, 50]
      ],
      [
        [4763, 7272],
        [72, -124],
        [3, -101],
        [88, -8],
        [211, -106],
        [46, 2],
        [27, -67],
        [112, -31]
      ],
      [
        [5322, 6837],
        [42, -67],
        [16, -102],
        [-30, -22]
      ],
      [
        [5350, 6646],
        [-36, 28],
        [-53, -34],
        [-57, 9],
        [13, 75],
        [-68, -17],
        [0, -91],
        [-64, 51],
        [-19, -68]
      ],
      [
        [5066, 6599],
        [-72, -18],
        [-62, 20],
        [-74, -5],
        [-51, 38]
      ],
      [
        [3935, 6463],
        [-83, -29],
        [-34, 95],
        [-42, 6],
        [-124, -16]
      ],
      [
        [3652, 6519],
        [-63, 132],
        [-51, 20],
        [-65, 244],
        [-28, 66],
        [-14, 121]
      ],
      [
        [8325, 6503],
        [-37, 117],
        [-62, 13],
        [-94, -24],
        [-77, -39]
      ],
      [
        [8055, 6570],
        [-26, 71],
        [1, 56],
        [-51, 60],
        [-47, -17],
        [-61, 10],
        [-89, 68],
        [-80, 11],
        [-6, -90],
        [28, -46],
        [-28, -37],
        [-51, 17],
        [-29, -59],
        [-60, 45],
        [-63, 20],
        [9, 41],
        [-23, 115],
        [19, 82],
        [-78, 20],
        [-50, -51],
        [-102, -5]
      ],
      [
        [7268, 6881],
        [-3, 95]
      ],
      [
        [7265, 6976],
        [6, 113],
        [25, 39],
        [105, 11],
        [19, 28],
        [62, 10],
        [90, 44]
      ],
      [
        [7572, 7221],
        [74, 23],
        [55, -20],
        [47, -45],
        [70, 79],
        [11, 53]
      ],
      [
        [9444, 7625],
        [-146, -139],
        [-46, -89],
        [0, -43],
        [74, -15],
        [-29, -141],
        [-2, -75],
        [-53, -12],
        [-181, -106],
        [-70, -17],
        [-88, -45]
      ],
      [
        [8903, 6943],
        [-10, 81],
        [37, 1],
        [59, 52],
        [8, 75],
        [-75, 142],
        [-13, 88],
        [14, 36],
        [-69, 177],
        [26, 69],
        [-42, 21],
        [-34, 79],
        [-41, 30],
        [-61, -12],
        [-61, 17],
        [-39, 56],
        [-77, 12],
        [-85, 47],
        [-63, -6]
      ],
      [
        [8377, 7908],
        [-16, 71],
        [57, 32],
        [56, -34],
        [17, 47]
      ],
      [
        [8491, 8024],
        [53, 44],
        [65, -34],
        [86, 5]
      ],
      [
        [9211, 7253],
        [9, -12],
        [26, -3],
        [18, -16],
        [2, 20],
        [-55, 11]
      ],
      [
        [6008, 7014],
        [83, -30],
        [49, 13],
        [68, -31]
      ],
      [
        [6208, 6966],
        [-61, -88],
        [9, -214]
      ],
      [
        [6156, 6664],
        [-174, 27],
        [-115, -40],
        [-30, -53]
      ],
      [
        [5837, 6598],
        [-55, -55],
        [-17, -45],
        [-54, -52],
        [-15, -59]
      ],
      [
        [5696, 6387],
        [-80, 36],
        [1, 38],
        [-61, 37],
        [-98, 25],
        [-13, 114],
        [-95, 9]
      ],
      [
        [5322, 6837],
        [61, 21]
      ],
      [
        [8055, 6570],
        [-67, -55],
        [-42, -65],
        [-30, -116],
        [-54, -77],
        [-54, -261]
      ],
      [
        [7808, 5996],
        [-51, 9],
        [-120, -30],
        [-29, 37],
        [-112, 9],
        [-198, 46],
        [-86, -5],
        [-26, -38]
      ],
      [
        [7186, 6024],
        [-4, 91],
        [-200, 19],
        [-12, -11]
      ],
      [
        [6970, 6123],
        [-15, 103],
        [23, 69],
        [0, 178],
        [25, 147],
        [66, 73],
        [8, 113]
      ],
      [
        [7077, 6806],
        [-12, 44],
        [82, 42],
        [84, -23],
        [37, 12]
      ],
      [
        [6156, 6664],
        [95, -31],
        [94, -8],
        [55, 23],
        [128, -47],
        [60, 12],
        [48, 83]
      ],
      [
        [6636, 6696],
        [5, 27]
      ],
      [
        [6641, 6723],
        [101, 48],
        [92, -23],
        [33, 30],
        [91, -55],
        [119, 83]
      ],
      [
        [6970, 6123],
        [2, -94],
        [-86, -94],
        [-73, 21],
        [-22, 60],
        [-43, -4],
        [-85, 29],
        [-45, -84],
        [-57, 4]
      ],
      [
        [6561, 5961],
        [-65, 28],
        [-13, 82],
        [-130, 22],
        [-44, -9],
        [-55, 76],
        [-54, -34],
        [-36, 26],
        [-107, -1],
        [-46, -67],
        [-89, 7]
      ],
      [
        [5922, 6091],
        [-20, 63],
        [17, 48],
        [-58, 26],
        [-20, 78],
        [-1, 145],
        [34, 18],
        [-37, 129]
      ],
      [
        [5696, 6387],
        [-13, -34],
        [-117, -42],
        [-78, -71],
        [-84, -12],
        [-48, -77],
        [-68, 9],
        [-61, -52],
        [-93, -18]
      ],
      [
        [5134, 6090],
        [-41, 110],
        [-15, 86],
        [-27, 32],
        [48, 113],
        [-18, 78],
        [63, -26],
        [47, 65],
        [-72, 16],
        [-53, 35]
      ],
      [
        [5134, 6090],
        [-28, -45],
        [-136, -93]
      ],
      [
        [4970, 5952],
        [-45, 31],
        [-59, -9],
        [-6, 40],
        [-76, 37]
      ],
      [
        [4784, 6051],
        [11, 83],
        [-13, 73],
        [52, 50],
        [-7, 119],
        [31, 4],
        [16, 80],
        [-43, 40],
        [-49, -34],
        [-81, 26]
      ],
      [
        [4040, 6369],
        [-18, -22]
      ],
      [
        [4022, 6347],
        [-47, -40],
        [-81, -21],
        [-16, 51],
        [-45, 45],
        [-18, -78]
      ],
      [
        [3815, 6304],
        [-110, 45],
        [-53, 170]
      ],
      [
        [5922, 6091],
        [-28, -77],
        [-84, -14],
        [-121, 59],
        [-26, -78]
      ],
      [
        [5663, 5981],
        [-54, -74],
        [23, -16],
        [-45, -111],
        [-50, -91],
        [-37, -20]
      ],
      [
        [5500, 5669],
        [-57, 16],
        [-59, 77],
        [-98, 9],
        [-36, 123],
        [-106, 29],
        [-108, -29],
        [15, -66],
        [-43, -32]
      ],
      [
        [5008, 5796],
        [-62, 53],
        [24, 103]
      ],
      [
        [4784, 6051],
        [-116, 17],
        [-102, -24]
      ],
      [
        [4566, 6044],
        [-127, -18],
        [-37, 62],
        [51, 84],
        [-14, 41],
        [-98, 78]
      ],
      [
        [4566, 6044],
        [13, -103],
        [-40, -116],
        [6, -91]
      ],
      [
        [4545, 5734],
        [-18, -59],
        [-80, -28],
        [-14, -68],
        [45, -27],
        [-38, -133],
        [-64, 8],
        [-83, -31],
        [-18, -65],
        [19, -79]
      ],
      [
        [4294, 5252],
        [-55, -44]
      ],
      [
        [4239, 5208],
        [-44, 44],
        [-30, 147],
        [-18, 26],
        [-31, 141],
        [-26, 66],
        [-56, 86],
        [-4, 67],
        [-95, 48],
        [-21, 84]
      ],
      [
        [3914, 5917],
        [76, 18],
        [62, 84],
        [-16, 41],
        [29, 65],
        [-37, 40],
        [43, 30],
        [-2, 62],
        [-31, 17],
        [-16, 73]
      ],
      [
        [3914, 5917],
        [-68, 112],
        [-64, 218],
        [33, 57]
      ],
      [
        [5008, 5796],
        [26, -39],
        [13, -84],
        [-14, -40],
        [-70, -13],
        [-31, -45],
        [-26, -100],
        [-46, -11]
      ],
      [
        [4860, 5464],
        [-120, 80],
        [-2, 71],
        [-53, 69],
        [-50, 31],
        [-90, 19]
      ],
      [
        [6561, 5961],
        [-57, -136],
        [58, -58],
        [-88, -150],
        [69, -69],
        [117, -74],
        [89, -6],
        [-10, -60],
        [36, -68],
        [3, -82]
      ],
      [
        [6778, 5258],
        [-51, -41],
        [-75, -32],
        [-23, -84],
        [-73, 6]
      ],
      [
        [6556, 5107],
        [-7, 55],
        [-75, 7],
        [-20, 63],
        [-102, -32],
        [-21, -70],
        [-105, -37],
        [-108, -62]
      ],
      [
        [6118, 5031],
        [9, 55],
        [-24, 62],
        [-70, -7],
        [-95, 26],
        [-15, -46],
        [-61, -46],
        [-57, 61],
        [42, 77],
        [-72, 71],
        [11, 47]
      ],
      [
        [5786, 5331],
        [-35, 53],
        [71, 22]
      ],
      [
        [5822, 5406],
        [16, -99],
        [95, -36],
        [97, 13],
        [50, -90],
        [24, 30],
        [-29, 50],
        [2, 115],
        [72, -13],
        [-16, 98],
        [-46, 33],
        [-29, -45],
        [-148, 45],
        [-14, -81],
        [-73, 7]
      ],
      [
        [5823, 5433],
        [-79, 82],
        [11, 103],
        [-62, 30],
        [-27, 52],
        [7, 57],
        [40, 80],
        [20, 130],
        [-70, 14]
      ],
      [
        [7806, 4926],
        [-53, 123],
        [-57, -1],
        [-12, 46],
        [-159, 61],
        [-10, 51],
        [-96, -23]
      ],
      [
        [7419, 5183],
        [-6, 96],
        [12, 56],
        [-13, 104],
        [-93, 175],
        [-33, 79],
        [-35, 17],
        [-1, 69],
        [-69, 197],
        [5, 48]
      ],
      [
        [7808, 5996],
        [45, -197],
        [57, -111],
        [-18, -171],
        [-25, -89],
        [10, -136],
        [71, -188],
        [-14, -92],
        [23, -67]
      ],
      [
        [5823, 5433],
        [-1, -27]
      ],
      [
        [5786, 5331],
        [-39, -34],
        [-25, -62],
        [-84, -47],
        [28, -85],
        [-94, -35],
        [-109, -104],
        [-66, -8]
      ],
      [
        [5397, 4956],
        [-53, 19],
        [-35, 78],
        [-46, 14],
        [-33, 96],
        [-45, 25]
      ],
      [
        [5185, 5188],
        [10, 32],
        [11, 204],
        [48, 24],
        [14, 47],
        [-13, 77],
        [47, 23],
        [48, -39],
        [116, 34],
        [34, 79]
      ],
      [
        [5185, 5188],
        [-50, -60],
        [-49, -4]
      ],
      [
        [5086, 5124],
        [-47, 209],
        [-132, -30],
        [-74, 35],
        [-60, 9],
        [87, 117]
      ],
      [
        [5086, 5124],
        [-220, -60],
        [-23, 27],
        [-57, -43],
        [-3, -39],
        [-46, -52],
        [-65, 18],
        [-12, -57],
        [-56, -48]
      ],
      [
        [4604, 4870],
        [-69, 77],
        [-24, 124],
        [-46, 23],
        [-13, 64],
        [-45, 29],
        [-84, 6],
        [-29, 59]
      ],
      [
        [4604, 4870],
        [-19, -76],
        [36, -112],
        [25, -19]
      ],
      [
        [4646, 4663],
        [-36, -38],
        [-102, 24],
        [-76, -45],
        [-34, 25],
        [-32, -43]
      ],
      [
        [4366, 4586],
        [-39, 177],
        [-31, 233],
        [-57, 212]
      ],
      [
        [5397, 4956],
        [7, -24]
      ],
      [
        [5404, 4932],
        [-87, -57],
        [-45, 1],
        [-15, -46],
        [-64, -23],
        [-18, -83],
        [-75, 4],
        [-112, -60],
        [17, -35],
        [-29, -71],
        [-44, -5],
        [-55, -84]
      ],
      [
        [4877, 4473],
        [-29, 46],
        [1, 63],
        [-71, 34],
        [-18, 49],
        [-56, -40],
        [-58, 38]
      ],
      [
        [6556, 5107],
        [-3, -52],
        [54, -63],
        [-5, -44]
      ],
      [
        [6602, 4948],
        [9, -71],
        [-49, -48],
        [-1, -85],
        [-113, -3],
        [-17, -28]
      ],
      [
        [6431, 4713],
        [-82, 12],
        [12, 47],
        [-111, 52],
        [-147, 48],
        [-31, 36]
      ],
      [
        [6072, 4908],
        [-14, 84],
        [60, 39]
      ],
      [
        [5404, 4932],
        [36, -71],
        [-47, -65],
        [15, -116],
        [67, -37],
        [0, -41],
        [86, -16],
        [18, -49]
      ],
      [
        [5579, 4537],
        [-35, -114],
        [-58, -29],
        [-68, 28],
        [-24, -44],
        [-4, -94]
      ],
      [
        [5390, 4284],
        [-24, -33],
        [-57, 25],
        [-69, -86],
        [-62, 32]
      ],
      [
        [5178, 4222],
        [-54, 43],
        [19, 59],
        [-56, 90],
        [-30, -119],
        [-109, 19]
      ],
      [
        [4948, 4314],
        [-34, 73],
        [4, 42],
        [-41, 44]
      ],
      [
        [6386, 4440],
        [-1, 75],
        [24, 94],
        [36, 20],
        [-14, 84]
      ],
      [
        [6602, 4948],
        [85, 19],
        [49, -5],
        [-18, -57],
        [-6, -107],
        [52, -39],
        [93, -24],
        [-47, -156],
        [-31, -63],
        [-73, -25],
        [-28, -59],
        [-39, 1],
        [-14, -73]
      ],
      [
        [6363, 4437],
        [-43, 56],
        [10, 66],
        [-36, 116],
        [-118, 28],
        [-42, -6],
        [-34, -100],
        [-64, -81]
      ],
      [
        [6036, 4516],
        [-11, 96],
        [-72, 57]
      ],
      [
        [5953, 4669],
        [-14, 32],
        [30, 61],
        [72, 12],
        [7, 93],
        [24, 41]
      ],
      [
        [4948, 4314],
        [-16, -47],
        [18, -59],
        [-36, -30],
        [-80, -19],
        [-50, 11]
      ],
      [
        [4784, 4170],
        [-89, 18],
        [-110, 114],
        [-85, 42],
        [-74, 15]
      ],
      [
        [4426, 4359],
        [-30, 64],
        [-30, 163]
      ],
      [
        [6213, 4293],
        [9, 30],
        [-47, 48],
        [-81, 37],
        [-50, 45],
        [-8, 63]
      ],
      [
        [4784, 4170],
        [-33, -63],
        [37, -29],
        [-5, -60]
      ],
      [
        [4783, 4018],
        [-138, -72],
        [-25, -74]
      ],
      [
        [4620, 3872],
        [-81, 218],
        [-17, 21],
        [-96, 248]
      ],
      [
        [5178, 4222],
        [-72, -125],
        [61, -50],
        [15, -59],
        [71, -42],
        [37, -103],
        [-50, -51]
      ],
      [
        [5240, 3792],
        [-72, -35],
        [-44, 7]
      ],
      [
        [5124, 3764],
        [-43, 8],
        [-50, 76],
        [-103, 67],
        [-39, 6],
        [-60, 97],
        [-46, 0]
      ],
      [
        [5439, 3568],
        [-3, 63]
      ],
      [
        [5436, 3631],
        [107, 120],
        [1, 47],
        [141, -1],
        [79, 29],
        [65, 100],
        [71, 24],
        [-9, 32]
      ],
      [
        [5891, 3982],
        [38, 51],
        [104, -2]
      ],
      [
        [6033, 4031],
        [68, -15],
        [27, -32]
      ],
      [
        [5319, 3463],
        [-60, -56]
      ],
      [
        [5259, 3407],
        [-69, 38],
        [-84, 71],
        [-6, 55],
        [-65, 56],
        [-4, 27]
      ],
      [
        [5031, 3654],
        [10, 48],
        [77, -10],
        [6, 72]
      ],
      [
        [5240, 3792],
        [0, -88],
        [61, 2],
        [73, -80],
        [62, 5]
      ],
      [
        [5259, 3407],
        [-39, -104],
        [-148, -75],
        [-20, -59]
      ],
      [
        [5052, 3169],
        [-84, 220],
        [-52, 38],
        [-42, 163]
      ],
      [
        [4874, 3590],
        [73, 41],
        [84, 23]
      ],
      [
        [5211, 2883],
        [-73, -32]
      ],
      [
        [5138, 2851],
        [-31, 78],
        [-55, 240]
      ],
      [
        [5455, 3226],
        [-22, -60],
        [-42, -22],
        [-16, -111],
        [-57, -37],
        [-41, 21],
        [-82, -48],
        [16, -86]
      ],
      [
        [5711, 2599],
        [-138, 29],
        [-22, 41],
        [-75, 37],
        [-40, 79],
        [36, 114],
        [-75, -7],
        [-97, 19],
        [-28, -45],
        [-61, 17]
      ],
      [
        [5749, 2541],
        [-54, 19],
        [-74, -16],
        [-184, 22],
        [-67, -82],
        [-64, 9]
      ],
      [
        [5306, 2493],
        [-34, -7],
        [-40, 144],
        [-94, 221]
      ],
      [
        [5754, 2536],
        [-1, 1]
      ],
      [
        [6004, 1842],
        [-47, 109],
        [-36, 16],
        [-61, -17],
        [-58, 14]
      ],
      [
        [5802, 1964],
        [-57, 53],
        [1, 129],
        [-52, 52],
        [-117, 48]
      ],
      [
        [5577, 2246],
        [101, 132],
        [54, 43],
        [40, 61],
        [96, -1],
        [-15, 62]
      ],
      [
        [5577, 2246],
        [-32, -24],
        [-80, 19],
        [-55, -8]
      ],
      [
        [5410, 2233],
        [-50, 38],
        [-11, -72]
      ],
      [
        [5349, 2199],
        [-74, 285],
        [31, 9]
      ],
      [
        [5410, 2233],
        [12, -210],
        [49, 10],
        [31, -117]
      ],
      [
        [5502, 1916],
        [2, -35],
        [81, -9],
        [32, -119],
        [-37, -27]
      ],
      [
        [5580, 1726],
        [-49, -22],
        [-52, 10]
      ],
      [
        [5479, 1714],
        [-85, 192],
        [-19, 70],
        [-26, 223]
      ],
      [
        [5802, 1964],
        [-32, -37],
        [-46, 30],
        [-138, 16],
        [-84, -57]
      ],
      [
        [5953, 1676],
        [-63, 17],
        [-116, 58],
        [-58, -59],
        [-98, -2],
        [-38, 36]
      ],
      [
        [5950, 1458],
        [-97, 55],
        [-17, -52],
        [-59, -11],
        [-78, 72],
        [-36, -49],
        [-51, -11]
      ],
      [
        [5612, 1462],
        [-88, 92],
        [-45, 160]
      ],
      [
        [5884, 1110],
        [-91, 94],
        [-170, 231],
        [-11, 27]
      ],
      [
        [8355, 7495],
        [2, 66],
        [40, 42]
      ],
      [
        [8397, 7603],
        [35, -20],
        [117, 29],
        [11, 68],
        [55, -5],
        [23, 67],
        [-189, 80],
        [-72, 86]
      ],
      [
        [8903, 6943],
        [-106, 26]
      ],
      [
        [8660, 9131],
        [21, -10]
      ],
      [
        [8681, 9121],
        [-21, -54],
        [38, -29],
        [66, 9],
        [-8, -86],
        [26, -35],
        [-42, -66],
        [59, -25],
        [47, -72],
        [55, 18],
        [43, -47],
        [-68, -88]
      ],
      [
        [8876, 8646],
        [-30, 60],
        [-38, 4],
        [-17, -97],
        [-36, 12],
        [-78, -139],
        [-72, 34],
        [-50, 45]
      ],
      [
        [8555, 8565],
        [-15, 109],
        [25, 42],
        [25, 159],
        [-17, 157],
        [-43, -1],
        [-10, 54]
      ],
      [
        [9024, 8652],
        [-87, -49],
        [-61, 43]
      ],
      [
        [8681, 9121],
        [105, -60],
        [47, 36],
        [38, 68],
        [84, -10],
        [-2, 74],
        [47, 71],
        [108, -32]
      ],
      [
        [8968, 9748],
        [40, -84]
      ],
      [
        [9008, 9664],
        [0, -1]
      ],
      [
        [9101, 9662],
        [54, 41],
        [52, 110],
        [-47, 25],
        [-15, 87],
        [-42, 85],
        [-26, 143],
        [-38, 20],
        [-37, 153]
      ],
      [
        [9002, 10326],
        [80, 88]
      ],
      [
        [9002, 10326],
        [-34, -12],
        [-43, 48],
        [-89, 8]
      ],
      [
        [8836, 10370],
        [-21, 72],
        [30, 29],
        [-55, 62],
        [8, 62]
      ],
      [
        [8798, 10595],
        [55, 52],
        [3, 104],
        [34, 40]
      ],
      [
        [8890, 10791],
        [37, -13],
        [98, 12],
        [19, -78],
        [172, -83]
      ],
      [
        [8836, 10370],
        [-15, -60],
        [-77, -51]
      ],
      [
        [8744, 10259],
        [-36, -15],
        [2, 114],
        [-173, 51]
      ],
      [
        [8537, 10409],
        [34, 20],
        [-6, 86],
        [-32, -7],
        [28, 128],
        [8, 94]
      ],
      [
        [8569, 10730],
        [99, 19],
        [56, -41],
        [36, -97],
        [38, -16]
      ],
      [
        [3548, 8993],
        [-113, 1],
        [-67, -51],
        [-49, 35],
        [-84, -8],
        [-2, -58],
        [-58, -22]
      ],
      [
        [3175, 8890],
        [16, 121],
        [-49, 68],
        [-79, 12]
      ],
      [
        [3063, 9091],
        [9, 29]
      ],
      [
        [3072, 9120],
        [66, -12],
        [38, 82],
        [65, 57],
        [101, 60],
        [49, 96],
        [130, 23]
      ],
      [
        [7086, 9299],
        [-6, -64],
        [-48, -11],
        [1, -123]
      ],
      [
        [7033, 9101],
        [-63, 0],
        [-55, 28],
        [-68, -22],
        [-40, -52],
        [-79, -28],
        [-58, 60],
        [-70, 42]
      ],
      [
        [6819, 7716],
        [-50, -37],
        [-37, 46],
        [8, 38]
      ],
      [
        [6740, 7763],
        [72, 2],
        [7, -49]
      ],
      [
        [7325, 8765],
        [-47, -48],
        [-44, 4],
        [-34, -69]
      ],
      [
        [7200, 8652],
        [-81, 5],
        [-19, -66]
      ],
      [
        [7100, 8591],
        [-70, 8],
        [-95, 38],
        [-23, -12]
      ],
      [
        [6912, 8625],
        [-58, 72],
        [-26, 67],
        [-4, 97]
      ],
      [
        [6824, 8861],
        [66, 22],
        [38, 39],
        [44, -15],
        [54, 43],
        [67, 2]
      ],
      [
        [7093, 8952],
        [49, 2],
        [41, -38],
        [19, -61],
        [45, -52],
        [78, -38]
      ],
      [
        [7464, 8022],
        [-16, -96],
        [54, -30]
      ],
      [
        [7502, 7896],
        [-40, -25],
        [18, -46]
      ],
      [
        [7480, 7825],
        [-102, -9],
        [-8, -21]
      ],
      [
        [7370, 7795],
        [-75, -8],
        [-68, 84],
        [-14, 62],
        [-69, 30],
        [-22, 58],
        [-81, 23]
      ],
      [
        [7041, 8044],
        [35, 29],
        [112, 6],
        [40, 87],
        [49, -1]
      ],
      [
        [7277, 8165],
        [26, -28],
        [154, -64],
        [7, -51]
      ],
      [
        [8025, 8616],
        [54, 14],
        [119, -78],
        [45, -61],
        [28, -95],
        [5, -101]
      ],
      [
        [8276, 8295],
        [-140, -39],
        [-72, -41],
        [-26, 16],
        [-80, -101]
      ],
      [
        [7958, 8130],
        [-79, 102],
        [-46, -9],
        [-57, 27]
      ],
      [
        [7776, 8250],
        [-36, -18],
        [-63, 36]
      ],
      [
        [7677, 8268],
        [9, 92],
        [45, 107],
        [192, -12],
        [10, 121],
        [92, 40]
      ],
      [
        [6208, 6966],
        [44, 14]
      ],
      [
        [6252, 6980],
        [75, -40],
        [102, -83],
        [10, -54],
        [138, -122],
        [59, 15]
      ],
      [
        [6303, 8576],
        [33, -43],
        [97, -4],
        [55, -40],
        [11, 59],
        [145, -47],
        [80, 0],
        [41, 22],
        [55, -13]
      ],
      [
        [6820, 8510],
        [13, -94],
        [-18, -42],
        [30, -41]
      ],
      [
        [6845, 8333],
        [0, -28]
      ],
      [
        [6845, 8305],
        [-88, -15],
        [-32, -29],
        [-46, 41],
        [-88, -60],
        [-71, -27],
        [-62, 40],
        [-51, -17]
      ],
      [
        [6407, 8238],
        [-19, 71],
        [-65, -1],
        [-31, 51],
        [-79, 13]
      ],
      [
        [7200, 8652],
        [78, -68],
        [4, -87],
        [46, 24],
        [117, -69],
        [53, 28]
      ],
      [
        [7498, 8480],
        [-2, -117]
      ],
      [
        [7496, 8363],
        [-59, -24],
        [-7, -48],
        [-105, -25]
      ],
      [
        [7325, 8266],
        [-37, 39],
        [-54, -19],
        [-36, 46],
        [17, 37],
        [-75, 33]
      ],
      [
        [7140, 8402],
        [4, 36],
        [-67, 79],
        [23, 74]
      ],
      [
        [7818, 7423],
        [-10, 58],
        [-104, 89],
        [13, 59],
        [-64, 50]
      ],
      [
        [7653, 7679],
        [123, 55],
        [40, -38],
        [37, 9],
        [78, 125],
        [-17, 20]
      ],
      [
        [7914, 7850],
        [109, 7],
        [41, -51],
        [10, -63],
        [35, -32],
        [60, 11],
        [59, -62],
        [115, 49],
        [12, -72],
        [42, -34]
      ],
      [
        [7735, 9014],
        [-165, 30],
        [-41, 56],
        [-63, 7],
        [20, -61],
        [-56, -22],
        [-73, 28],
        [-23, -86],
        [-32, -43],
        [-76, 43],
        [-61, 85],
        [-68, 29]
      ],
      [
        [7097, 9080],
        [-64, 21]
      ],
      [
        [7502, 7896],
        [53, 5],
        [25, 42],
        [132, 32],
        [11, 61],
        [55, 55],
        [-2, 159]
      ],
      [
        [7958, 8130],
        [-14, -86],
        [7, -54],
        [-37, -140]
      ],
      [
        [7653, 7679],
        [-34, 85],
        [-139, 61]
      ],
      [
        [6311, 7010],
        [24, 124],
        [-40, 201],
        [22, 111]
      ],
      [
        [6317, 7446],
        [101, -59],
        [55, 42]
      ],
      [
        [6473, 7429],
        [17, 22],
        [164, -63],
        [48, -104]
      ],
      [
        [6702, 7284],
        [0, -71],
        [-75, 43],
        [-74, -108]
      ],
      [
        [6553, 7148],
        [-75, 12],
        [-16, -78],
        [-43, -44],
        [-108, -28]
      ],
      [
        [7725, 8772],
        [-31, 7],
        [-37, -96]
      ],
      [
        [7657, 8683],
        [-85, -22],
        [-31, 41],
        [-132, 86],
        [-84, -23]
      ],
      [
        [7093, 8952],
        [-45, 63],
        [49, 65]
      ],
      [
        [6845, 8305],
        [7, -56],
        [-31, -113],
        [6, -83],
        [-27, -110]
      ],
      [
        [6800, 7943],
        [-33, 13]
      ],
      [
        [6767, 7956],
        [-85, 29],
        [1, -46],
        [-112, 91],
        [-32, 7],
        [-14, 65],
        [-93, -11],
        [-73, 71],
        [48, 76]
      ],
      [
        [6740, 7763],
        [-39, 61]
      ],
      [
        [6701, 7824],
        [22, 87],
        [44, 45]
      ],
      [
        [6800, 7943],
        [111, 9],
        [36, -22]
      ],
      [
        [6947, 7930],
        [-31, -67],
        [49, -76],
        [-9, -62]
      ],
      [
        [6956, 7725],
        [-137, -9]
      ],
      [
        [6641, 6723],
        [-35, 33],
        [16, 88],
        [-20, 24],
        [77, 125],
        [-140, 78],
        [14, 77]
      ],
      [
        [6702, 7284],
        [123, 30],
        [75, -40],
        [67, -12]
      ],
      [
        [6967, 7262],
        [-37, -95],
        [17, -58],
        [50, -19],
        [36, 27],
        [194, -110],
        [38, -31]
      ],
      [
        [6967, 7262],
        [31, 56],
        [-47, 27],
        [73, 151]
      ],
      [
        [7024, 7496],
        [32, -20],
        [40, 64],
        [20, 107],
        [79, -27],
        [67, 15],
        [30, 70],
        [130, -10]
      ],
      [
        [7422, 7695],
        [49, -116],
        [44, -74],
        [16, -117],
        [33, -59],
        [8, -108]
      ],
      [
        [6824, 8861],
        [-52, 5],
        [-30, 36],
        [-63, -39],
        [-48, 48],
        [-123, -56],
        [-10, -45],
        [-58, -25]
      ],
      [
        [6912, 8625],
        [-76, -68],
        [-16, -47]
      ],
      [
        [7657, 8683],
        [14, -35],
        [-26, -60],
        [-43, 1],
        [-36, -68],
        [-68, -41]
      ],
      [
        [7140, 8402],
        [-20, -42],
        [-156, -28],
        [-70, 26],
        [-49, -25]
      ],
      [
        [6956, 7725],
        [10, -91],
        [43, -21],
        [-28, -59],
        [43, -58]
      ],
      [
        [6473, 7429],
        [-50, 61],
        [44, 29],
        [52, 93],
        [-42, 71],
        [38, 88]
      ],
      [
        [6515, 7771],
        [5, 34],
        [96, -42],
        [46, -5],
        [39, 66]
      ],
      [
        [6515, 7771],
        [-54, 25],
        [-33, 62],
        [-70, 46],
        [-90, -88]
      ],
      [
        [6143, 7856],
        [-18, 8]
      ],
      [
        [7041, 8044],
        [-34, -89],
        [-60, -25]
      ],
      [
        [7325, 8266],
        [-48, -101]
      ],
      [
        [7422, 7695],
        [-52, 100]
      ],
      [
        [6317, 7446],
        [-30, 27],
        [-52, -22],
        [-25, -69],
        [-85, 29]
      ],
      [
        [6252, 6980],
        [59, 30]
      ],
      [
        [7464, 8022],
        [70, 25],
        [33, 144],
        [-45, 51],
        [6, 66],
        [-22, 40]
      ],
      [
        [7506, 8348],
        [77, 25],
        [18, -60],
        [76, -45]
      ],
      [
        [7496, 8363],
        [10, -15]
      ],
      [
        [13095, 10844],
        [-61, 10],
        [47, 112],
        [41, -14],
        [3, -62],
        [-30, -46]
      ],
      [
        [13677, 10920],
        [51, -92],
        [-36, -30],
        [-15, 122]
      ],
      [
        [13067, 11271],
        [5, 74],
        [52, 87],
        [45, 45]
      ],
      [
        [13169, 11477],
        [68, -29],
        [47, 38]
      ],
      [
        [13284, 11486],
        [70, 4],
        [26, 45],
        [41, -32],
        [52, -106],
        [78, -46],
        [-12, -31],
        [164, -146]
      ],
      [
        [13703, 11174],
        [9, -130],
        [-40, -34],
        [-49, 29],
        [-52, -14],
        [-59, 23],
        [0, 44],
        [-85, -44],
        [-66, -74],
        [-57, 47],
        [-35, -15],
        [-21, -67],
        [-60, -56],
        [23, -42],
        [-28, -83],
        [-31, 165],
        [-44, 125],
        [41, 52],
        [7, 56],
        [-23, 61],
        [-66, 54]
      ],
      [
        [13521, 10985],
        [21, -145],
        [-41, -5],
        [-36, 65],
        [16, 112],
        [40, -27]
      ],
      [
        [13630, 11019],
        [3, -106],
        [-83, 115],
        [40, -10],
        [40, 1]
      ],
      [
        [1751, 10835],
        [-23, -15]
      ],
      [
        [1728, 10820],
        [23, 15]
      ],
      [
        [2153, 11067],
        [48, -38],
        [-8, -42],
        [89, -133]
      ],
      [
        [2282, 10854],
        [-29, -94],
        [-44, -56],
        [89, -30],
        [7, -82],
        [-61, -28],
        [-4, -75],
        [63, -53],
        [36, -85]
      ],
      [
        [2339, 10351],
        [-109, -38],
        [-48, -55],
        [-76, -16],
        [-75, -37]
      ],
      [
        [2031, 10205],
        [-18, 62],
        [27, 55],
        [-63, 5],
        [7, 76],
        [-84, 71],
        [-99, 1]
      ],
      [
        [1801, 10475],
        [-33, 49],
        [91, 56],
        [-13, 110],
        [-60, -4],
        [21, 103],
        [-46, 49]
      ],
      [
        [1761, 10838],
        [5, 55],
        [116, -11],
        [45, 21],
        [-11, 86],
        [64, 54],
        [132, 61],
        [41, -37]
      ],
      [
        [10580, 10297],
        [62, 24],
        [70, 91],
        [68, -14],
        [54, 23],
        [50, 56]
      ],
      [
        [10884, 10477],
        [87, -4],
        [41, 23],
        [-28, 47],
        [75, 27],
        [-13, 83],
        [22, 26],
        [84, 11],
        [32, 43],
        [-38, 53]
      ],
      [
        [11146, 10786],
        [30, 48]
      ],
      [
        [11176, 10834],
        [42, 10],
        [52, -140],
        [-20, -48],
        [25, -36],
        [-38, -49],
        [72, -84]
      ],
      [
        [3759, 10353],
        [0, -1]
      ],
      [
        [3759, 10352],
        [-27, 8]
      ],
      [
        [3732, 10360],
        [27, -7]
      ],
      [
        [3514, 10150],
        [14, 72]
      ],
      [
        [3528, 10222],
        [-4, 69],
        [49, 70],
        [123, -3],
        [29, -35],
        [60, -18]
      ],
      [
        [3785, 10305],
        [35, -68]
      ],
      [
        [3728, 10375],
        [-42, 36]
      ],
      [
        [3686, 10411],
        [42, -36]
      ],
      [
        [8704, 10029],
        [57, 41],
        [12, 75],
        [-25, 46],
        [-4, 68]
      ],
      [
        [12232, 10161],
        [36, 29],
        [106, -3],
        [22, -41],
        [-175, -131],
        [-34, -53],
        [26, -92]
      ],
      [
        [3342, 9714],
        [-48, -25],
        [-113, 30],
        [-2, 59]
      ],
      [
        [3072, 9120],
        [-52, 171],
        [-2, 78],
        [-40, 138],
        [6, 71],
        [45, 28],
        [-16, 74],
        [44, 42]
      ],
      [
        [11164, 9239],
        [-61, -67],
        [-64, -43],
        [-111, -116],
        [-30, -58],
        [-42, 30]
      ],
      [
        [10674, 8862],
        [-45, 43],
        [21, 82],
        [-17, 49],
        [43, 52],
        [-3, 64],
        [-28, 27],
        [-3, 75],
        [18, 63],
        [-43, 14],
        [-67, -15]
      ],
      [
        [7419, 5183],
        [7, -66],
        [-98, -56],
        [-53, 25],
        [-6, 40],
        [-44, 38],
        [-173, 25],
        [-158, -23],
        [-29, 67],
        [-87, 25]
      ],
      [
        [5953, 4669],
        [-27, 5],
        [-58, -49],
        [-3, -61],
        [58, -60],
        [-18, -72],
        [13, -53],
        [-48, -27]
      ],
      [
        [5870, 4352],
        [-100, 40],
        [-46, 127],
        [-56, 40],
        [-89, -22]
      ],
      [
        [6033, 4031],
        [-37, 114],
        [-94, 13],
        [2, 64],
        [-36, 80],
        [2, 50]
      ],
      [
        [5891, 3982],
        [-74, 1],
        [1, 52],
        [-39, 63],
        [-55, 6],
        [-33, -39],
        [-47, -9],
        [-183, 103],
        [-71, 125]
      ],
      [
        [4874, 3590],
        [-11, 3]
      ],
      [
        [4863, 3593],
        [-3, 0]
      ],
      [
        [4860, 3593],
        [-96, 110],
        [-19, 2],
        [-69, 108],
        [-33, -1],
        [-23, 60]
      ],
      [
        [4875, 3605],
        [-9, 12],
        [-3, -14],
        [12, 2]
      ],
      [
        [7655, 3686],
        [-7, -35]
      ],
      [
        [7677, 3775],
        [-21, -81]
      ],
      [
        [7688, 3843],
        [0, -31]
      ],
      [
        [8430, 9960],
        [-25, 60],
        [3, 65],
        [-92, 42],
        [1, 52],
        [67, 16],
        [29, 92],
        [-8, 69],
        [109, 1],
        [23, 52]
      ],
      [
        [8276, 8295],
        [63, 26],
        [9, -48],
        [74, 19]
      ],
      [
        [8422, 8292],
        [-6, -86],
        [30, -184],
        [45, 2]
      ],
      [
        [3572, 11321],
        [-38, -95],
        [17, -108]
      ],
      [
        [3551, 11118],
        [-18, -64],
        [-130, -55]
      ],
      [
        [3403, 10999],
        [-63, -46],
        [-54, 39],
        [-43, 3],
        [-7, 69],
        [-94, 66],
        [-25, 107]
      ],
      [
        [3117, 11237],
        [52, 57]
      ],
      [
        [3169, 11294],
        [74, 15],
        [-8, 36],
        [71, 164],
        [41, 29]
      ],
      [
        [3347, 11538],
        [33, 28],
        [4, 84],
        [49, 7]
      ],
      [
        [3433, 11657],
        [44, -95],
        [2, -169],
        [29, -50],
        [64, -22]
      ],
      [
        [12701, 11756],
        [-8, -22],
        [78, -62],
        [73, -26],
        [47, -118],
        [26, -14]
      ],
      [
        [12917, 11514],
        [26, -55]
      ],
      [
        [12943, 11459],
        [-161, -61],
        [0, -75],
        [50, -10],
        [-14, -140],
        [-107, -32],
        [-51, -54],
        [11, -79],
        [-23, -96]
      ],
      [
        [12648, 10912],
        [-104, 26],
        [-22, 37],
        [-4, 80]
      ],
      [
        [12518, 11055],
        [-69, 118],
        [29, 47],
        [15, 82],
        [-28, 88],
        [-52, 34],
        [11, 162],
        [-15, 23]
      ],
      [
        [12409, 11609],
        [-8, 91],
        [135, 38],
        [57, 37],
        [65, -30],
        [43, 11]
      ],
      [
        [7758, 11701],
        [66, -66],
        [141, 16],
        [6, -42],
        [-89, -92],
        [-77, 6],
        [9, -110],
        [33, -88]
      ],
      [
        [7847, 11325],
        [-1, -65],
        [-43, -47],
        [22, -76],
        [-87, -6],
        [-7, -69],
        [-40, -6],
        [-60, -114],
        [-52, -6],
        [-11, -76],
        [-107, -73]
      ],
      [
        [7461, 10787],
        [-9, 57],
        [-68, 0],
        [-103, 32]
      ],
      [
        [7281, 10876],
        [69, 172],
        [39, 31],
        [-4, 77],
        [-26, 20],
        [-43, 143],
        [37, 114],
        [-11, 96]
      ],
      [
        [7342, 11529],
        [55, 77],
        [50, 6],
        [58, 75],
        [34, 85]
      ],
      [
        [7539, 11772],
        [78, -21],
        [24, -54],
        [117, 4]
      ],
      [
        [4343, 11488],
        [-33, -139],
        [-28, -69],
        [-80, -27],
        [-36, -90],
        [20, -49]
      ],
      [
        [4186, 11114],
        [-45, -11]
      ],
      [
        [4141, 11103],
        [-99, -70],
        [-88, 12]
      ],
      [
        [3954, 11045],
        [-34, 48],
        [19, 59],
        [-1, 83],
        [-45, 63],
        [10, 42],
        [79, -26],
        [17, 88],
        [-63, -16],
        [-40, 95]
      ],
      [
        [3896, 11481],
        [60, -21],
        [74, 89],
        [76, -6]
      ],
      [
        [4106, 11543],
        [41, -38],
        [109, -18],
        [87, 1]
      ],
      [
        [7281, 10876],
        [-7, -51],
        [-96, -31],
        [-67, 9],
        [-38, -20],
        [-11, -65],
        [-206, -10],
        [-48, 30],
        [-51, -23]
      ],
      [
        [6757, 10715],
        [-9, 54],
        [-50, 13]
      ],
      [
        [6698, 10782],
        [33, 60],
        [43, 34],
        [5, 69],
        [54, 44],
        [-23, 46],
        [-155, 112],
        [-21, 167],
        [16, 59]
      ],
      [
        [6650, 11373],
        [73, 14],
        [58, -33],
        [59, 32],
        [-8, 85],
        [-33, 41],
        [16, 53],
        [59, -12],
        [51, 41]
      ],
      [
        [6925, 11594],
        [22, -44],
        [127, 20],
        [61, -21],
        [20, 84],
        [130, 32],
        [2, -61],
        [55, -75]
      ],
      [
        [6075, 11243],
        [54, -43],
        [-9, -58],
        [30, -39],
        [-149, -48],
        [-37, -42]
      ],
      [
        [5964, 11013],
        [-54, 64],
        [-106, 6],
        [-58, -14],
        [-31, 56],
        [-9, 70],
        [31, 93],
        [-60, 43]
      ],
      [
        [5677, 11331],
        [8, 60],
        [82, 45],
        [104, 15],
        [34, 34]
      ],
      [
        [5905, 11485],
        [59, 10]
      ],
      [
        [5964, 11495],
        [40, -77],
        [71, -175]
      ],
      [
        [4910, 10637],
        [-17, 62],
        [-55, 9],
        [-22, 50],
        [24, 42],
        [-72, 49],
        [-65, -34],
        [-49, 44],
        [38, 32],
        [49, 177],
        [41, 56],
        [-63, 54]
      ],
      [
        [4719, 11178],
        [114, 15],
        [29, 58],
        [-11, 67],
        [28, 37]
      ],
      [
        [4879, 11355],
        [35, -28],
        [95, 18],
        [48, 33],
        [105, 4],
        [58, 90]
      ],
      [
        [5220, 11472],
        [12, -49],
        [73, -38],
        [-1, -66]
      ],
      [
        [5304, 11319],
        [-84, -103],
        [36, -55],
        [57, -28],
        [-54, -69],
        [17, -66],
        [-44, -23],
        [4, -119],
        [-25, -20],
        [5, -66]
      ],
      [
        [12943, 11459],
        [29, -71],
        [10, -106],
        [30, -23]
      ],
      [
        [13012, 11259],
        [11, -31],
        [79, -12],
        [33, -59],
        [-80, -63],
        [-71, -136],
        [-109, -96],
        [-75, -35],
        [-124, -26]
      ],
      [
        [12676, 10801],
        [-28, 111]
      ],
      [
        [12181, 11238],
        [72, -86],
        [83, -9],
        [42, -34],
        [-18, -91],
        [65, -36]
      ],
      [
        [12425, 10982],
        [38, -67],
        [-74, -42],
        [-26, -82],
        [-174, 3],
        [-60, -18],
        [-43, -42],
        [-34, -70],
        [-111, -90]
      ],
      [
        [11941, 10574],
        [-60, 56],
        [-39, -72],
        [-61, -6],
        [-6, 56],
        [38, 54],
        [-22, 34],
        [-80, 46],
        [47, 69],
        [-36, 48],
        [-98, 73],
        [-42, 11],
        [-10, 102],
        [-82, 46],
        [8, 32]
      ],
      [
        [11498, 11123],
        [43, 12],
        [23, -65],
        [74, -1],
        [73, 96],
        [15, 54],
        [-38, 42],
        [36, 63],
        [-7, 67],
        [-36, 43]
      ],
      [
        [11681, 11434],
        [68, 52]
      ],
      [
        [11749, 11486],
        [34, -51],
        [107, -28],
        [50, -72],
        [46, -24],
        [44, 22],
        [38, -35],
        [113, -60]
      ],
      [
        [3403, 10999],
        [3, -26],
        [125, -124],
        [-31, -111]
      ],
      [
        [3500, 10738],
        [-132, -25],
        [-202, 13],
        [-23, -60],
        [-78, -6],
        [-34, 39]
      ],
      [
        [3031, 10699],
        [-19, 38],
        [-63, 39],
        [59, 47],
        [-103, 64],
        [52, 55],
        [-74, 98],
        [38, 173],
        [53, 25],
        [68, -31],
        [75, 30]
      ],
      [
        [11146, 10786],
        [-63, -3],
        [-15, 60],
        [-154, -3],
        [-65, 30],
        [-19, 37]
      ],
      [
        [10830, 10907],
        [-48, -2],
        [-41, 41],
        [-10, 177],
        [-22, 96],
        [-137, -62],
        [2, -65]
      ],
      [
        [10574, 11092],
        [-131, -19],
        [-60, -61],
        [-53, 29],
        [-116, -116],
        [-84, 29]
      ],
      [
        [10130, 10954],
        [-34, 102],
        [-1, 58],
        [59, 115],
        [114, 66]
      ],
      [
        [10268, 11295],
        [40, 36],
        [96, 20],
        [24, 71],
        [-23, 43]
      ],
      [
        [10405, 11465],
        [65, -37],
        [56, -72],
        [62, -26],
        [90, 7],
        [69, 55],
        [141, -6],
        [39, 25],
        [97, -6],
        [73, 33]
      ],
      [
        [11097, 11438],
        [5, -170],
        [-32, -98],
        [99, -36],
        [38, -46]
      ],
      [
        [11207, 11088],
        [27, -37],
        [64, -17],
        [-24, -80],
        [-33, 9],
        [-59, -55],
        [-6, -74]
      ],
      [
        [8746, 11437],
        [24, -79],
        [29, -27],
        [-26, -138],
        [-10, -109]
      ],
      [
        [8763, 11084],
        [-30, -66],
        [-88, -60],
        [-17, -45],
        [-80, -47]
      ],
      [
        [8548, 10866],
        [-46, 22],
        [-67, -5],
        [-45, 70],
        [-55, 8]
      ],
      [
        [8335, 10961],
        [-9, 45],
        [49, 155],
        [63, -37],
        [27, 132]
      ],
      [
        [8465, 11256],
        [48, 37],
        [-5, 105],
        [54, 40]
      ],
      [
        [8562, 11438],
        [36, -23],
        [52, 48],
        [96, -26]
      ],
      [
        [5304, 11319],
        [75, -21],
        [112, 82],
        [70, -4],
        [51, -79],
        [65, 34]
      ],
      [
        [5964, 11013],
        [-36, -28],
        [-10, -70],
        [-58, -43]
      ],
      [
        [5860, 10872],
        [-14, -11]
      ],
      [
        [5846, 10861],
        [-11, -7]
      ],
      [
        [5835, 10854],
        [-11, -7]
      ],
      [
        [5824, 10847],
        [-5, 10]
      ],
      [
        [5819, 10857],
        [-63, -69],
        [-31, 12],
        [-48, -40]
      ],
      [
        [1121, 10951],
        [2, -58],
        [114, 48],
        [53, -50]
      ],
      [
        [1290, 10891],
        [49, -54]
      ],
      [
        [1339, 10837],
        [-18, 12],
        [-85, -74],
        [4, -76],
        [-34, -56],
        [24, -124]
      ],
      [
        [1230, 10519],
        [-179, 224],
        [-220, 214],
        [16, 43]
      ],
      [
        [847, 11000],
        [34, -26],
        [73, 64],
        [70, -11],
        [-7, -64],
        [104, -12]
      ],
      [
        [7480, 10747],
        [-19, 40]
      ],
      [
        [7847, 11325],
        [154, -27],
        [42, 4],
        [118, -56],
        [82, -18],
        [-1, 50],
        [106, 79],
        [32, -73],
        [60, 3],
        [25, -31]
      ],
      [
        [8335, 10961],
        [-19, -53],
        [-40, 0],
        [-27, -73],
        [15, -137],
        [-50, -102]
      ],
      [
        [3551, 11118],
        [77, 15],
        [37, -69],
        [98, -18],
        [55, -57]
      ],
      [
        [3818, 10989],
        [-80, -24],
        [5, -58],
        [37, -34],
        [-44, -51],
        [14, -90],
        [96, 1]
      ],
      [
        [3846, 10733],
        [-7, -44],
        [-110, -36],
        [-68, -9]
      ],
      [
        [3661, 10644],
        [-15, 53],
        [-119, 10],
        [-27, 31]
      ],
      [
        [3846, 10734],
        [0, -1]
      ],
      [
        [3846, 10733],
        [0, 1]
      ],
      [
        [4650, 10653],
        [-68, 37],
        [-36, 76],
        [-124, 49],
        [-57, -14]
      ],
      [
        [4365, 10801],
        [-126, 36],
        [-51, 45],
        [13, 135],
        [-47, 36],
        [-13, 50]
      ],
      [
        [4186, 11114],
        [40, -16],
        [76, 9],
        [65, 31],
        [268, 19],
        [84, 21]
      ],
      [
        [9702, 11170],
        [51, -34],
        [-7, -80],
        [57, 7],
        [63, -35],
        [-6, -56],
        [56, -98],
        [-206, 6]
      ],
      [
        [9710, 10880],
        [-51, -22],
        [-53, 22],
        [-84, -10],
        [-141, 25]
      ],
      [
        [9381, 10895],
        [-41, 12],
        [-51, 107],
        [19, 144],
        [57, 23],
        [24, 56]
      ],
      [
        [9389, 11237],
        [89, 35],
        [46, -54],
        [3, -78],
        [126, 66],
        [49, -36]
      ],
      [
        [3732, 10360],
        [-4, 15]
      ],
      [
        [3686, 10411],
        [-46, 55],
        [97, 14],
        [5, 70],
        [78, 22],
        [11, 69],
        [57, 37],
        [107, 12],
        [73, 26],
        [-30, 46],
        [-73, 5],
        [-119, -33]
      ],
      [
        [3818, 10989],
        [136, 56]
      ],
      [
        [4365, 10801],
        [-15, -99],
        [-42, -50],
        [-122, 4],
        [-13, -78],
        [-94, -58],
        [-60, 14],
        [-83, -25],
        [-112, -95],
        [0, -37],
        [-65, -24]
      ],
      [
        [11207, 11088],
        [24, 53],
        [80, 59],
        [187, -77]
      ],
      [
        [11941, 10574],
        [4, -48]
      ],
      [
        [12425, 10982],
        [5, 44],
        [88, 29]
      ],
      [
        [12676, 10801],
        [-50, -51],
        [-123, -7],
        [-47, -19],
        [-130, -110],
        [-59, -105]
      ],
      [
        [10574, 11092],
        [58, 16],
        [10, -59],
        [-56, -134],
        [-33, 25],
        [-97, -26],
        [-71, 7],
        [-9, -145],
        [-110, -13]
      ],
      [
        [10266, 10763],
        [-67, 99],
        [-85, 32],
        [-52, -72]
      ],
      [
        [10062, 10822],
        [-17, 39],
        [85, 93]
      ],
      [
        [8569, 10730],
        [-21, 136]
      ],
      [
        [8763, 11084],
        [165, -32],
        [120, -106]
      ],
      [
        [9048, 10946],
        [-58, -40],
        [-98, -8],
        [16, -45],
        [-18, -62]
      ],
      [
        [5819, 10857],
        [5, -10]
      ],
      [
        [5835, 10854],
        [11, 7]
      ],
      [
        [5860, 10872],
        [97, -17],
        [46, 50],
        [130, 9],
        [42, -48],
        [21, -129],
        [-79, 19],
        [22, -130],
        [48, 16],
        [157, 9],
        [54, -18],
        [95, 27],
        [96, 57],
        [31, 38],
        [78, 27]
      ],
      [
        [6757, 10715],
        [9, -68],
        [-54, -7],
        [-74, -46]
      ],
      [
        [3661, 10644],
        [-71, -24],
        [-89, 13],
        [-52, -116],
        [-115, -107],
        [7, -87],
        [52, -19],
        [18, -38]
      ],
      [
        [3411, 10266],
        [-11, -46],
        [-114, 59],
        [-66, 89],
        [-47, 36],
        [-29, -20],
        [-103, 15]
      ],
      [
        [3041, 10399],
        [-85, 27],
        [11, 81],
        [-26, 77],
        [37, 21],
        [25, 84],
        [28, 10]
      ],
      [
        [3785, 10305],
        [-26, 47]
      ],
      [
        [3528, 10222],
        [-75, 4],
        [-42, 40]
      ],
      [
        [9919, 10628],
        [2, 0]
      ],
      [
        [9923, 10628],
        [77, -25],
        [4, 45],
        [-40, 70],
        [30, 87],
        [68, 17]
      ],
      [
        [10266, 10763],
        [57, -91],
        [-9, -97],
        [25, -48],
        [-11, -46]
      ],
      [
        [9048, 10946],
        [66, 50]
      ],
      [
        [9114, 10996],
        [107, -89],
        [125, -35],
        [35, 23]
      ],
      [
        [9710, 10880],
        [24, -55],
        [-41, -73],
        [7, -37]
      ],
      [
        [8746, 11437],
        [96, 35],
        [18, 56],
        [52, 40]
      ],
      [
        [8912, 11568],
        [12, -57],
        [150, -168],
        [-52, -40],
        [-87, -11],
        [1, -35],
        [146, -180],
        [32, -81]
      ],
      [
        [2153, 11067],
        [70, 53],
        [-9, 97],
        [-32, 54]
      ],
      [
        [2182, 11271],
        [62, 59],
        [216, 21]
      ],
      [
        [2460, 11351],
        [-18, -76],
        [147, -14],
        [47, -35],
        [-46, -71]
      ],
      [
        [2590, 11155],
        [-92, 21],
        [-37, -53],
        [-84, -34],
        [-34, -102],
        [-43, -27],
        [-18, -106]
      ],
      [
        [3572, 11321],
        [60, 5],
        [50, -36],
        [-1, 166],
        [48, 24]
      ],
      [
        [3729, 11480],
        [48, -33],
        [91, 41],
        [28, -7]
      ],
      [
        [2031, 10205],
        [-102, -47],
        [-33, 8]
      ],
      [
        [1896, 10166],
        [-52, 0]
      ],
      [
        [1844, 10166],
        [-61, -38],
        [-248, 115],
        [-136, 105]
      ],
      [
        [1399, 10348],
        [105, 44],
        [59, 66],
        [67, 100],
        [101, -31],
        [-1, -77],
        [71, 25]
      ],
      [
        [12181, 11238],
        [69, 80],
        [8, 54],
        [-53, 19],
        [24, 45],
        [-23, 64],
        [-70, 0],
        [-11, 59],
        [-54, 41]
      ],
      [
        [12071, 11600],
        [33, 62]
      ],
      [
        [12104, 11662],
        [56, -22],
        [130, -85],
        [79, -1],
        [40, 55]
      ],
      [
        [1728, 10820],
        [-126, -5],
        [-74, 18],
        [-87, -50],
        [-102, 54]
      ],
      [
        [1290, 10891],
        [-28, 40],
        [122, 82],
        [32, 69],
        [42, 36],
        [143, -3],
        [22, 38],
        [-2, 102],
        [-39, 4],
        [-30, 47],
        [-5, 117],
        [79, 15],
        [-24, 48],
        [20, 34]
      ],
      [
        [1622, 11520],
        [74, -121],
        [66, 28],
        [122, -44]
      ],
      [
        [1884, 11383],
        [24, -59],
        [92, -123],
        [50, 81],
        [132, -11]
      ],
      [
        [1761, 10838],
        [-10, -3]
      ],
      [
        [2783, 10934],
        [-30, 31],
        [-12, 92],
        [54, 45],
        [41, -74],
        [-53, -94]
      ],
      [
        [2590, 11155],
        [71, -78],
        [49, 0]
      ],
      [
        [2710, 11077],
        [-26, -75],
        [24, -49],
        [-31, -54],
        [75, -91],
        [-48, -123],
        [-83, -112],
        [3, -75],
        [-190, -86],
        [-95, -61]
      ],
      [
        [6075, 11243],
        [41, -4],
        [62, 98],
        [89, -22],
        [112, 34],
        [116, -28],
        [101, 50],
        [54, 2]
      ],
      [
        [1399, 10348],
        [-97, 89],
        [-72, 82]
      ],
      [
        [10884, 10477],
        [11, 78],
        [-33, 30],
        [-94, -50],
        [-13, 90],
        [-94, 4],
        [4, 71],
        [83, 66],
        [-22, 84],
        [84, 11],
        [20, 46]
      ],
      [
        [1121, 10951],
        [62, 14],
        [4, 63],
        [-37, 117],
        [-31, 29],
        [-52, 131],
        [14, 80]
      ],
      [
        [1081, 11385],
        [72, 33],
        [73, 58],
        [98, 7],
        [64, 79],
        [-3, 41],
        [48, 35],
        [70, 101]
      ],
      [
        [1503, 11739],
        [33, -44],
        [31, 65]
      ],
      [
        [1567, 11760],
        [54, -12],
        [43, -39],
        [0, -114],
        [-42, -75]
      ],
      [
        [847, 11000],
        [-29, -36],
        [-88, 86],
        [-164, 201],
        [-19, 56],
        [45, 94],
        [103, -67],
        [10, -98],
        [106, 72],
        [98, 18],
        [33, 29],
        [52, -4],
        [87, 34]
      ],
      [
        [8555, 8565],
        [-97, -5],
        [-8, -50],
        [-70, -61],
        [82, -29],
        [23, -109],
        [-63, -19]
      ],
      [
        [8025, 8616],
        [-63, 79]
      ],
      [
        [3233, 8158],
        [-47, 104],
        [-2, 86],
        [39, 16],
        [-75, 65],
        [-13, 79],
        [26, 57],
        [-51, 115],
        [8, 73],
        [-21, 47]
      ],
      [
        [3135, 8885],
        [40, 5]
      ],
      [
        [9702, 11170],
        [61, 34],
        [0, 51],
        [33, 52],
        [22, 81],
        [-18, 35],
        [16, 146]
      ],
      [
        [9816, 11569],
        [31, 75],
        [39, 10],
        [87, -42],
        [38, -65]
      ],
      [
        [10011, 11547],
        [-6, -63],
        [115, -69],
        [48, -49],
        [58, -10],
        [42, -61]
      ],
      [
        [8912, 11568],
        [2, 5]
      ],
      [
        [8914, 11573],
        [41, 65],
        [-12, 79],
        [56, 11],
        [58, 68],
        [-5, 70],
        [118, 18]
      ],
      [
        [9170, 11884],
        [61, -116]
      ],
      [
        [9231, 11768],
        [-54, -66],
        [26, -133],
        [43, -13],
        [-54, -79],
        [-12, -65],
        [29, -33],
        [14, -71],
        [96, 11],
        [70, -82]
      ],
      [
        [7684, 3069],
        [-1, -115]
      ],
      [
        [4863, 3593],
        [-3, 0]
      ],
      [
        [3109, 10172],
        [-87, 217],
        [19, 10]
      ],
      [
        [3239, 1096],
        [-7, -7],
        [-16, 9],
        [23, -2]
      ],
      [
        [3092, 9894],
        [5, 62],
        [33, 6]
      ],
      [
        [1896, 10166],
        [-15, -29],
        [-37, 29]
      ],
      [
        [3099, 8934],
        [-35, 59],
        [-1, 98]
      ],
      [
        [17199, 15692],
        [-29, -102],
        [23, -84],
        [61, -45]
      ],
      [
        [17254, 15461],
        [72, -110]
      ],
      [
        [17326, 15351],
        [-181, -71]
      ],
      [
        [17145, 15280],
        [-82, 28],
        [-29, 40],
        [-49, -12],
        [-4, 65],
        [-69, 29]
      ],
      [
        [16912, 15430],
        [-70, 75],
        [24, 34],
        [-34, 79],
        [-105, 62],
        [-44, -37],
        [-102, 0]
      ],
      [
        [16581, 15643],
        [-78, 59],
        [-74, -8]
      ],
      [
        [16429, 15694],
        [-27, 66],
        [63, 52],
        [40, 99],
        [100, 32],
        [85, -20],
        [146, 37],
        [76, 4]
      ],
      [
        [16912, 15964],
        [40, -45],
        [-14, -53],
        [70, -41],
        [26, -60],
        [61, 5],
        [57, -64],
        [47, -14]
      ],
      [
        [18808, 15177],
        [-106, 21]
      ],
      [
        [18702, 15198],
        [-46, 18],
        [2, 92],
        [-68, 65],
        [-73, 17],
        [-84, 100],
        [31, 81],
        [-26, 56],
        [6, 87]
      ],
      [
        [18444, 15714],
        [6, 10]
      ],
      [
        [18450, 15724],
        [127, 22],
        [46, 32],
        [55, 2],
        [77, -70],
        [76, 12],
        [64, -51],
        [62, 38],
        [53, -51],
        [33, 0],
        [98, -54],
        [-28, -46],
        [0, -71],
        [39, -39],
        [-8, -69],
        [-80, -6],
        [-63, -63],
        [-82, -47],
        [-84, -99],
        [-27, 13]
      ],
      [
        [18097, 15251],
        [4, -81],
        [61, -56]
      ],
      [
        [18162, 15114],
        [6, -79],
        [38, 1],
        [49, -50],
        [-37, -42],
        [-67, -29],
        [-75, -3],
        [-71, -26]
      ],
      [
        [18005, 14886],
        [-65, 24],
        [-33, -16]
      ],
      [
        [17907, 14894],
        [-25, 38],
        [19, 53],
        [-108, 16],
        [-58, 40],
        [5, 40],
        [59, 64],
        [-32, 68]
      ],
      [
        [17767, 15213],
        [80, 34],
        [80, 111]
      ],
      [
        [17927, 15358],
        [3, 3]
      ],
      [
        [17930, 15361],
        [57, 52],
        [139, 12],
        [99, -9]
      ],
      [
        [18225, 15416],
        [-128, -165]
      ],
      [
        [17767, 15213],
        [-48, 17],
        [-68, -32],
        [-63, -1],
        [-163, -161],
        [-35, -11],
        [-44, -62]
      ],
      [
        [17346, 14963],
        [-22, 30],
        [-61, -35],
        [-71, 15],
        [-53, -23],
        [-1, 85],
        [-27, 61]
      ],
      [
        [17111, 15096],
        [-35, 63]
      ],
      [
        [17076, 15159],
        [16, 19],
        [83, -42],
        [64, -14],
        [255, 125],
        [186, 64]
      ],
      [
        [17680, 15311],
        [113, 38],
        [46, -21],
        [88, 30]
      ],
      [
        [18808, 15177],
        [48, -89],
        [-21, -41],
        [39, -37],
        [84, -137],
        [48, -52],
        [-66, -36],
        [-52, 45],
        [-81, 26],
        [16, 51],
        [-57, 63],
        [-125, 14],
        [-64, -49],
        [-132, -3],
        [-142, -52],
        [-44, -31],
        [-50, -94],
        [-94, -26],
        [-37, -87],
        [-40, 6]
      ],
      [
        [18038, 14648],
        [-2, 59],
        [-34, 31],
        [25, 105],
        [-22, 43]
      ],
      [
        [18162, 15114],
        [84, 9],
        [39, 36],
        [107, -28],
        [56, 2]
      ],
      [
        [18448, 15133],
        [40, 54],
        [176, -12],
        [38, 23]
      ],
      [
        [17907, 14894],
        [-23, -80],
        [-47, -26]
      ],
      [
        [17837, 14788],
        [-5, 10]
      ],
      [
        [17832, 14798],
        [-7, 41],
        [-49, 23],
        [-85, -54],
        [-110, 33],
        [-11, 40],
        [-87, -96]
      ],
      [
        [17483, 14785],
        [-49, 27],
        [6, 79],
        [-84, 6],
        [-31, -73]
      ],
      [
        [17325, 14824],
        [-20, 26]
      ],
      [
        [17305, 14850],
        [41, 113]
      ],
      [
        [15638, 15074],
        [-48, -21],
        [-187, 16],
        [-59, 74],
        [-3, 36],
        [43, 52],
        [3, 70],
        [128, 6],
        [36, -64],
        [69, 35],
        [46, -8],
        [66, 57],
        [65, 18],
        [34, -60],
        [104, 26]
      ],
      [
        [15935, 15311],
        [-5, -24]
      ],
      [
        [15930, 15287],
        [-44, -80],
        [-112, -33],
        [-72, -74],
        [-64, -26]
      ],
      [
        [16899, 15090],
        [107, -13],
        [74, 8]
      ],
      [
        [17080, 15085],
        [-149, -128],
        [-121, -131],
        [15, -59],
        [-86, -53]
      ],
      [
        [16739, 14714],
        [-21, -19],
        [-127, -23],
        [-48, 15]
      ],
      [
        [16543, 14687],
        [-38, 26],
        [-18, 63],
        [-64, 42],
        [64, 26],
        [-57, 57],
        [69, 75]
      ],
      [
        [16499, 14976],
        [26, 44],
        [-92, 137]
      ],
      [
        [16433, 15157],
        [65, 48],
        [121, -14]
      ],
      [
        [16619, 15191],
        [19, -21]
      ],
      [
        [16638, 15170],
        [49, -65],
        [-33, -44],
        [21, -76],
        [43, -22],
        [111, 19],
        [11, 74],
        [59, 34]
      ],
      [
        [17305, 14850],
        [-37, -44],
        [-127, -36],
        [-51, 0],
        [-30, -49],
        [-147, -58]
      ],
      [
        [16913, 14663],
        [-47, -43],
        [-80, -15]
      ],
      [
        [16786, 14605],
        [7, 30],
        [-54, 79]
      ],
      [
        [17080, 15085],
        [31, 11]
      ],
      [
        [18038, 14648],
        [-50, -66],
        [-73, 3]
      ],
      [
        [17915, 14585],
        [-84, 86],
        [6, 117]
      ],
      [
        [17483, 14785],
        [-4, -55],
        [-62, -61],
        [124, 12]
      ],
      [
        [17541, 14681],
        [-38, -29],
        [-49, -82]
      ],
      [
        [17454, 14570],
        [-36, -34]
      ],
      [
        [17418, 14536],
        [-98, -18]
      ],
      [
        [17320, 14518],
        [-48, 34],
        [-25, 119],
        [-51, 11]
      ],
      [
        [17196, 14682],
        [97, 92],
        [32, 50]
      ],
      [
        [17320, 14518],
        [-120, -83],
        [-1, -56],
        [-57, -53]
      ],
      [
        [17142, 14326],
        [-19, 73],
        [-66, -77],
        [-13, -76]
      ],
      [
        [17044, 14246],
        [-44, 97],
        [1, 115],
        [-82, 91],
        [18, 72]
      ],
      [
        [16937, 14621],
        [136, 44],
        [63, -13],
        [60, 30]
      ],
      [
        [17541, 14681],
        [38, -26],
        [78, 35],
        [62, 53]
      ],
      [
        [17719, 14743],
        [22, -81],
        [-18, -56],
        [21, -119]
      ],
      [
        [17744, 14487],
        [-113, -169],
        [40, -74]
      ],
      [
        [17671, 14244],
        [-80, -40],
        [-38, 9],
        [-19, 54]
      ],
      [
        [17534, 14267],
        [-22, 143],
        [-66, 60],
        [36, 43],
        [-28, 57]
      ],
      [
        [16323, 14661],
        [4, -127],
        [50, -111]
      ],
      [
        [16377, 14423],
        [-31, -13],
        [-95, 32],
        [-150, -61],
        [-96, -27],
        [-102, 11]
      ],
      [
        [15903, 14365],
        [-51, -9]
      ],
      [
        [15852, 14356],
        [12, 59]
      ],
      [
        [15864, 14415],
        [-21, 167],
        [21, 82]
      ],
      [
        [15864, 14664],
        [57, 24],
        [76, -1],
        [61, 37]
      ],
      [
        [16058, 14724],
        [11, 17],
        [140, -23],
        [88, -63],
        [26, 6]
      ],
      [
        [16913, 14663],
        [24, -42]
      ],
      [
        [17044, 14246],
        [-39, -23],
        [-68, -107],
        [-30, -148]
      ],
      [
        [16907, 13968],
        [16, -38],
        [-64, -53],
        [-68, 4],
        [-1, 87]
      ],
      [
        [16790, 13968],
        [7, 62],
        [70, 231],
        [-65, 50],
        [-61, 121],
        [-134, 3],
        [-25, -25],
        [-105, -1]
      ],
      [
        [16477, 14409],
        [6, 89]
      ],
      [
        [16483, 14498],
        [59, 39],
        [71, 4],
        [95, -37],
        [-1, 60],
        [79, 41]
      ],
      [
        [17534, 14267],
        [-43, 2],
        [-53, 56],
        [-37, -10]
      ],
      [
        [17401, 14315],
        [-14, 54],
        [29, 59],
        [2, 108]
      ],
      [
        [17401, 14315],
        [-39, -78],
        [-56, -37],
        [12, -50]
      ],
      [
        [17318, 14150],
        [-138, -17]
      ],
      [
        [17180, 14133],
        [-4, 102],
        [-34, 91]
      ],
      [
        [15864, 14415],
        [-77, 14],
        [-42, 35],
        [-69, -3],
        [-45, -75],
        [-115, 1],
        [-32, -23]
      ],
      [
        [15484, 14364],
        [-27, 67],
        [5, 60],
        [-27, 91]
      ],
      [
        [15435, 14582],
        [124, 77],
        [59, -44],
        [48, -9],
        [37, 34]
      ],
      [
        [15703, 14640],
        [53, -2],
        [108, 26]
      ],
      [
        [14893, 14400],
        [-18, -25]
      ],
      [
        [14875, 14375],
        [-67, -46],
        [-41, 25],
        [-106, 7],
        [-10, -60],
        [-69, 11]
      ],
      [
        [14582, 14312],
        [-29, 93],
        [15, 108],
        [-27, 105]
      ],
      [
        [14541, 14618],
        [53, 31],
        [84, -64],
        [112, -35],
        [153, 6]
      ],
      [
        [14943, 14556],
        [-34, -64],
        [-16, -92]
      ],
      [
        [15484, 14364],
        [1, -25]
      ],
      [
        [15485, 14339],
        [-36, 18],
        [-65, -41],
        [-31, 59]
      ],
      [
        [15353, 14375],
        [0, 32],
        [-174, -40],
        [-41, 4]
      ],
      [
        [15138, 14371],
        [-10, 62],
        [-54, 22],
        [-27, -56],
        [-78, -27],
        [-1, 48],
        [-75, -20]
      ],
      [
        [14943, 14556],
        [67, 3],
        [29, 30],
        [91, -8],
        [65, -23],
        [47, 44],
        [57, -36],
        [85, 22],
        [51, -6]
      ],
      [
        [16377, 14423],
        [106, 75]
      ],
      [
        [16477, 14409],
        [-69, -6],
        [-117, -43],
        [-46, -129],
        [-84, -49],
        [-8, -45]
      ],
      [
        [16153, 14137],
        [-64, -55],
        [32, -52]
      ],
      [
        [16121, 14030],
        [-64, -39],
        [-71, -21],
        [32, 79],
        [-43, 51],
        [-88, -27]
      ],
      [
        [15887, 14073],
        [24, 56],
        [-8, 58],
        [56, 2],
        [41, 47],
        [-11, 33],
        [-72, -9],
        [-14, 105]
      ],
      [
        [14582, 14312],
        [17, -57]
      ],
      [
        [14599, 14255],
        [-90, -81],
        [-13, 57],
        [-99, 6],
        [13, -90],
        [-73, -64],
        [-93, 6],
        [-15, 62],
        [29, 85],
        [-40, 33]
      ],
      [
        [14218, 14269],
        [-5, 23]
      ],
      [
        [14213, 14292],
        [23, 145],
        [-12, 61]
      ],
      [
        [14224, 14498],
        [5, 27],
        [124, -3],
        [95, 31],
        [24, 62],
        [69, 3]
      ],
      [
        [15852, 14356],
        [-80, -63],
        [-40, -3],
        [-77, -101],
        [-39, 1]
      ],
      [
        [15616, 14190],
        [-66, -42],
        [-86, -5]
      ],
      [
        [15464, 14143],
        [49, 117],
        [-28, 79]
      ],
      [
        [17671, 14244],
        [-4, -175],
        [45, -25],
        [-39, -63],
        [-73, -70]
      ],
      [
        [17600, 13911],
        [-27, -6],
        [-83, 116],
        [-116, -16]
      ],
      [
        [17374, 14005],
        [24, 21],
        [0, 90],
        [-80, 34]
      ],
      [
        [15138, 14371],
        [-12, -61],
        [30, -71],
        [-40, -54],
        [5, -64]
      ],
      [
        [15121, 14121],
        [-93, -13],
        [-90, -49]
      ],
      [
        [14938, 14059],
        [-150, 26],
        [-29, 53]
      ],
      [
        [14759, 14138],
        [-11, 25],
        [89, 67],
        [47, 74],
        [-9, 71]
      ],
      [
        [15353, 14375],
        [-35, -140],
        [-73, -51],
        [-39, -72],
        [-85, 9]
      ],
      [
        [15887, 14073],
        [-79, -35]
      ],
      [
        [15808, 14038],
        [-66, 8]
      ],
      [
        [15742, 14046],
        [-4, 64],
        [-70, 23],
        [-52, 57]
      ],
      [
        [15464, 14143],
        [-117, -43],
        [-3, -34],
        [104, -50]
      ],
      [
        [15448, 14016],
        [-1, -50],
        [-93, 49],
        [-88, -141],
        [-72, 1]
      ],
      [
        [15194, 13875],
        [-74, -86],
        [-49, 93],
        [-91, -19]
      ],
      [
        [14980, 13863],
        [12, 45]
      ],
      [
        [14992, 13908],
        [48, 90],
        [-102, 61]
      ],
      [
        [14759, 14138],
        [-97, -2],
        [-34, -23],
        [-52, 26]
      ],
      [
        [14576, 14139],
        [61, 67],
        [-38, 49]
      ],
      [
        [14576, 14139],
        [-82, -15],
        [-59, -58],
        [3, -40]
      ],
      [
        [14438, 14026],
        [-63, -6],
        [-157, -115]
      ],
      [
        [14218, 13905],
        [29, 46],
        [-103, 164]
      ],
      [
        [14144, 14115],
        [-19, 34],
        [53, 98],
        [40, 22]
      ],
      [
        [15742, 14046],
        [-26, -23],
        [-174, -2],
        [-27, 56],
        [-67, -61]
      ],
      [
        [17600, 13911],
        [17, -108],
        [-68, -54],
        [-35, -59]
      ],
      [
        [17514, 13690],
        [-17, 95],
        [-25, 34],
        [-69, -4]
      ],
      [
        [17403, 13815],
        [-67, 43],
        [-27, 52],
        [65, 95]
      ],
      [
        [14992, 13908],
        [-51, 45],
        [-151, 5],
        [-56, -26],
        [-129, 52]
      ],
      [
        [14605, 13984],
        [-162, -34],
        [-42, 11]
      ],
      [
        [14401, 13961],
        [37, 65]
      ],
      [
        [15808, 14038],
        [-72, -69],
        [25, -46],
        [-33, -66],
        [0, -105]
      ],
      [
        [15728, 13752],
        [-13, -23]
      ],
      [
        [15715, 13729],
        [-195, 3],
        [-3, 21]
      ],
      [
        [15517, 13753],
        [-27, 85],
        [-131, 16],
        [-84, -17],
        [-81, 38]
      ],
      [
        [16325, 13827],
        [51, -41]
      ],
      [
        [16376, 13786],
        [43, -128],
        [79, 0]
      ],
      [
        [16498, 13658],
        [83, -79],
        [9, -93]
      ],
      [
        [16590, 13486],
        [-58, -48],
        [-24, -85],
        [-64, -110]
      ],
      [
        [16444, 13243],
        [-44, 21],
        [-77, 1],
        [-31, 43],
        [-76, 13],
        [-41, -20],
        [-74, 44],
        [-119, -10]
      ],
      [
        [15982, 13335],
        [53, 12],
        [28, 45],
        [52, 22],
        [32, 55],
        [-91, 110],
        [-55, 23]
      ],
      [
        [16001, 13602],
        [60, 77]
      ],
      [
        [16061, 13679],
        [48, 16],
        [57, 107],
        [129, 44],
        [30, -19]
      ],
      [
        [17050, 12995],
        [9, 62],
        [-31, 112],
        [18, 41]
      ],
      [
        [17046, 13210],
        [108, 43],
        [130, 35],
        [80, 59]
      ],
      [
        [17364, 13347],
        [54, -1],
        [5, -56],
        [-37, -107],
        [-36, -37],
        [-2, -60],
        [-55, -33],
        [-7, -50],
        [-104, -108]
      ],
      [
        [17182, 12895],
        [-61, 78],
        [-71, 22]
      ],
      [
        [15517, 13753],
        [-19, -46],
        [-169, -72],
        [3, -21]
      ],
      [
        [15332, 13614],
        [-19, -19],
        [-136, -9],
        [-92, 16],
        [-20, -48],
        [-74, -45],
        [-66, 10],
        [-55, -32]
      ],
      [
        [14870, 13487],
        [-60, 52],
        [28, 93],
        [-19, 33]
      ],
      [
        [14819, 13665],
        [74, 40],
        [71, 99],
        [-27, 8]
      ],
      [
        [14937, 13812],
        [43, 51]
      ],
      [
        [16498, 13658],
        [64, 65],
        [56, 31]
      ],
      [
        [16618, 13754],
        [96, -18],
        [176, 15]
      ],
      [
        [16890, 13751],
        [5, -81]
      ],
      [
        [16895, 13670],
        [-112, -15],
        [26, -55]
      ],
      [
        [16809, 13600],
        [-90, -111],
        [-40, -81],
        [-68, 32],
        [-21, 46]
      ],
      [
        [16895, 13670],
        [46, 6],
        [66, -33],
        [54, 19]
      ],
      [
        [17061, 13662],
        [12, -38],
        [74, 5],
        [62, 24],
        [47, 50]
      ],
      [
        [17256, 13703],
        [-71, -143],
        [-1, -37],
        [-107, -132]
      ],
      [
        [17077, 13391],
        [-93, -4],
        [-49, 16],
        [-17, 73],
        [11, 60],
        [-44, 15]
      ],
      [
        [16885, 13551],
        [-76, 49]
      ],
      [
        [15982, 13335],
        [-39, 7],
        [-36, -57]
      ],
      [
        [15907, 13285],
        [-148, 69]
      ],
      [
        [15759, 13354],
        [4, 74],
        [-20, 93],
        [62, 30],
        [68, 7],
        [128, 44]
      ],
      [
        [15715, 13729],
        [-24, -138],
        [11, -105],
        [-81, -18],
        [19, -67]
      ],
      [
        [15640, 13401],
        [-177, -13],
        [-68, -34],
        [-26, 36],
        [-72, -29],
        [-74, 31],
        [-16, 41]
      ],
      [
        [15207, 13433],
        [126, 39],
        [-15, 45],
        [14, 97]
      ],
      [
        [16885, 13551],
        [-12, -90],
        [-85, -86],
        [29, -95],
        [-38, -84],
        [-1, -84]
      ],
      [
        [16778, 13112],
        [-229, 24],
        [-84, -121],
        [-42, 28]
      ],
      [
        [16423, 13043],
        [-26, 73]
      ],
      [
        [16397, 13116],
        [48, 85],
        [-1, 42]
      ],
      [
        [14870, 13487],
        [78, -44],
        [7, -54]
      ],
      [
        [14955, 13389],
        [-75, -10],
        [-49, 18],
        [-57, -18],
        [-119, 7],
        [-43, -18],
        [-74, 35],
        [-64, 8]
      ],
      [
        [14474, 13411],
        [18, 86],
        [31, 32],
        [7, 72]
      ],
      [
        [14530, 13601],
        [80, -3],
        [132, -32],
        [77, 99]
      ],
      [
        [16127, 12909],
        [-61, 57],
        [-26, 192],
        [-32, 12]
      ],
      [
        [16008, 13170],
        [-42, 6]
      ],
      [
        [15966, 13176],
        [-59, 109]
      ],
      [
        [16397, 13116],
        [-43, 10],
        [-15, -74],
        [1, -100]
      ],
      [
        [16340, 12952],
        [-25, -20],
        [-26, -96]
      ],
      [
        [16881, 13198],
        [20, -58],
        [-2, -81]
      ],
      [
        [16899, 13059],
        [-35, -75],
        [16, -45]
      ],
      [
        [16880, 12939],
        [-29, -20]
      ],
      [
        [16851, 12919],
        [-41, 66],
        [-24, 85]
      ],
      [
        [16786, 13070],
        [24, 95],
        [47, 89],
        [24, -56]
      ],
      [
        [16008, 13170],
        [-48, -151],
        [2, -152],
        [-30, -113],
        [-27, -36]
      ],
      [
        [15822, 12714],
        [-50, 30],
        [27, 53],
        [-30, 109]
      ],
      [
        [15769, 12906],
        [26, 123],
        [27, 43],
        [-40, 118],
        [42, 12],
        [57, -47],
        [85, 21]
      ],
      [
        [16880, 12939],
        [72, -25]
      ],
      [
        [16952, 12914],
        [10, -52]
      ],
      [
        [16962, 12862],
        [-36, 27],
        [-60, -98],
        [7, -70],
        [-26, -34]
      ],
      [
        [16847, 12687],
        [5, 47]
      ],
      [
        [16852, 12734],
        [-2, 12]
      ],
      [
        [16850, 12746],
        [-1, 3]
      ],
      [
        [16849, 12749],
        [-18, 97],
        [20, 73]
      ],
      [
        [16849, 12749],
        [-35, 72],
        [-75, 24],
        [21, 44],
        [3, 96]
      ],
      [
        [16763, 12985],
        [2, 5]
      ],
      [
        [16765, 12990],
        [21, 80]
      ],
      [
        [16852, 12734],
        [-2, 12]
      ],
      [
        [16962, 12862],
        [71, -48],
        [4, -59],
        [38, -41],
        [-10, -81],
        [37, -14]
      ],
      [
        [17102, 12619],
        [-10, -57],
        [-44, -78],
        [-9, -59],
        [-91, 58],
        [-81, 19],
        [-56, -20],
        [-44, 58]
      ],
      [
        [16767, 12540],
        [26, 95],
        [54, 52]
      ],
      [
        [16767, 12540],
        [-76, 4],
        [-78, -50],
        [-58, 94],
        [-25, 12]
      ],
      [
        [16530, 12600],
        [11, 71],
        [55, 46],
        [8, 85],
        [-82, 13],
        [15, 134]
      ],
      [
        [16537, 12949],
        [39, -20],
        [78, 38],
        [109, 18]
      ],
      [
        [15802, 12337],
        [-58, -14]
      ],
      [
        [15744, 12323],
        [-14, 105],
        [-46, 100]
      ],
      [
        [15684, 12528],
        [38, 37],
        [40, 103],
        [-88, 65],
        [1, 77]
      ],
      [
        [15675, 12810],
        [45, 35],
        [11, 73],
        [38, -12]
      ],
      [
        [15744, 12323],
        [-37, 18],
        [-39, -65],
        [-80, 34],
        [24, -152],
        [-21, -39],
        [-50, 14],
        [-40, 50]
      ],
      [
        [15501, 12183],
        [-24, 126]
      ],
      [
        [15477, 12309],
        [11, 95],
        [-24, 128],
        [5, 107]
      ],
      [
        [15469, 12639],
        [-6, 75],
        [74, -45],
        [42, -54]
      ],
      [
        [15579, 12615],
        [30, -24],
        [68, 14],
        [7, -77]
      ],
      [
        [15250, 12081],
        [-66, -71]
      ],
      [
        [15184, 12010],
        [-42, 152],
        [-62, 79],
        [-3, 107],
        [46, -7]
      ],
      [
        [15123, 12341],
        [106, 29],
        [56, -18],
        [59, 29]
      ],
      [
        [15344, 12381],
        [3, -20]
      ],
      [
        [15347, 12361],
        [-112, -127],
        [-14, -102],
        [29, -51]
      ],
      [
        [15501, 12183],
        [22, -105],
        [-52, -76]
      ],
      [
        [15471, 12002],
        [-99, 100],
        [-122, -21]
      ],
      [
        [15347, 12361],
        [97, 6],
        [33, -58]
      ],
      [
        [17180, 14133],
        [10, -58],
        [-19, -69],
        [-54, -12]
      ],
      [
        [17117, 13994],
        [-179, -10]
      ],
      [
        [16938, 13984],
        [-31, -16]
      ],
      [
        [17403, 13815],
        [-69, 14],
        [-99, 55],
        [-120, -43]
      ],
      [
        [17115, 13841],
        [-38, 59],
        [45, 47],
        [-5, 47]
      ],
      [
        [17514, 13690],
        [-49, -68],
        [-87, -35]
      ],
      [
        [17378, 13587],
        [-79, 43],
        [-2, 55],
        [-41, 18]
      ],
      [
        [17061, 13662],
        [15, 90],
        [39, 89]
      ],
      [
        [14605, 13984],
        [-34, -89],
        [12, -80]
      ],
      [
        [14583, 13815],
        [8, -73],
        [-15, -81],
        [-46, -60]
      ],
      [
        [14474, 13411],
        [-80, 15],
        [-90, 55]
      ],
      [
        [14304, 13481],
        [40, 33],
        [76, 22],
        [13, 123],
        [-99, 46]
      ],
      [
        [14334, 13705],
        [-79, 87],
        [105, 136],
        [41, 33]
      ],
      [
        [14583, 13815],
        [65, -29],
        [28, 46],
        [53, -33],
        [36, 34],
        [100, 26],
        [72, -47]
      ],
      [
        [16890, 13751],
        [23, 17],
        [35, 110],
        [-26, 27],
        [16, 79]
      ],
      [
        [16618, 13754],
        [20, 41],
        [104, 88],
        [-14, 38],
        [62, 47]
      ],
      [
        [17680, 15311],
        [-45, 151]
      ],
      [
        [17635, 15462],
        [113, 18],
        [36, 53],
        [-44, 26]
      ],
      [
        [17740, 15559],
        [74, 64],
        [27, 49]
      ],
      [
        [17841, 15672],
        [54, -39],
        [64, -2],
        [-2, -148],
        [-39, -74],
        [12, -48]
      ],
      [
        [18448, 15133],
        [-33, 108],
        [8, 50],
        [-42, 65],
        [-121, -20],
        [-163, -85]
      ],
      [
        [18225, 15416],
        [66, 117],
        [94, 80],
        [59, 101]
      ],
      [
        [16581, 15643],
        [3, -115],
        [72, -41],
        [31, -75],
        [-17, -88],
        [-54, -66],
        [3, -67]
      ],
      [
        [16433, 15157],
        [-22, 52],
        [28, 92],
        [-41, 15],
        [-129, 1],
        [-31, 74],
        [-129, 37]
      ],
      [
        [16109, 15428],
        [-47, 66],
        [17, 43],
        [74, 55],
        [62, 2],
        [84, 72],
        [130, 28]
      ],
      [
        [16638, 15170],
        [22, -3],
        [125, 82],
        [0, 43],
        [80, 23]
      ],
      [
        [16865, 15315],
        [33, -133],
        [73, -22],
        [13, -67],
        [-85, -3]
      ],
      [
        [15935, 15311],
        [61, 4],
        [71, 57],
        [42, 56]
      ],
      [
        [16499, 14976],
        [-20, 33],
        [-69, -16],
        [-19, -48],
        [-107, -45],
        [7, -78],
        [-77, -6],
        [-56, 31]
      ],
      [
        [16158, 14847],
        [-6, 60],
        [15, 102],
        [-13, 35],
        [-93, 25],
        [-43, 108],
        [-42, -2],
        [-10, 77],
        [-36, 35]
      ],
      [
        [16158, 14847],
        [-37, 12],
        [-90, -37],
        [-11, -65],
        [38, -33]
      ],
      [
        [15703, 14640],
        [-6, 83],
        [-46, 42],
        [-6, 71],
        [30, 83],
        [-10, 90],
        [-27, 65]
      ],
      [
        [15728, 13752],
        [48, 32],
        [143, 3],
        [40, -75],
        [52, -48],
        [50, 15]
      ],
      [
        [15759, 13354],
        [-77, 43],
        [-42, 4]
      ],
      [
        [15207, 13433],
        [-67, -26],
        [-112, 3],
        [-73, -21]
      ],
      [
        [14304, 13481],
        [-91, -2],
        [-13, 67],
        [37, 64]
      ],
      [
        [14237, 13610],
        [4, 53],
        [93, 42]
      ],
      [
        [15344, 12381],
        [-9, 89],
        [-53, 111]
      ],
      [
        [15282, 12581],
        [105, 30],
        [17, 60],
        [65, -32]
      ],
      [
        [15123, 12341],
        [14, 71],
        [-19, 36],
        [53, 86],
        [48, 3],
        [63, 44]
      ],
      [
        [15471, 12002],
        [37, -88],
        [-6, -60],
        [-56, -55],
        [-94, -16],
        [-22, 25],
        [-23, 134],
        [-35, 56],
        [-88, 12]
      ],
      [
        [15579, 12615],
        [12, 112],
        [-13, 55],
        [32, 32],
        [65, -4]
      ],
      [
        [17832, 14798],
        [-72, -58],
        [-41, 3]
      ],
      [
        [16323, 14661],
        [220, 26]
      ],
      [
        [16153, 14137],
        [90, 1],
        [-5, -37],
        [116, -54],
        [48, -127],
        [38, -41],
        [-9, -87],
        [-55, -6]
      ],
      [
        [16325, 13827],
        [-54, 73],
        [-74, -5],
        [-69, 67],
        [-7, 68]
      ],
      [
        [14237, 13610],
        [-13, -8],
        [20, 110],
        [-36, 84],
        [10, 109]
      ],
      [
        [16912, 15430],
        [-47, -115]
      ],
      [
        [17915, 14585],
        [-45, -87],
        [-81, -34],
        [-45, 23]
      ],
      [
        [16881, 13198],
        [74, 39],
        [60, -32],
        [-34, -127],
        [8, -41]
      ],
      [
        [16989, 13037],
        [-70, -17],
        [-20, 39]
      ],
      [
        [16423, 13043],
        [2, -75],
        [-26, -42]
      ],
      [
        [16399, 12926],
        [-59, 26]
      ],
      [
        [17050, 12995],
        [-35, -4]
      ],
      [
        [17015, 12991],
        [-26, 46]
      ],
      [
        [16765, 12990],
        [-7, 89],
        [20, 33]
      ],
      [
        [17077, 13391],
        [-54, -42],
        [23, -139]
      ],
      [
        [17015, 12991],
        [-27, -60],
        [-36, -17]
      ],
      [
        [17182, 12895],
        [21, -41],
        [-76, -149],
        [-25, -86]
      ],
      [
        [17378, 13587],
        [-65, -168],
        [51, -72]
      ],
      [
        [16537, 12949],
        [-70, 0],
        [-68, -23]
      ],
      [
        [16530, 12600],
        [-82, -49]
      ],
      [
        [17740, 15559],
        [-80, 78],
        [3, 145],
        [-17, 46],
        [-63, 2],
        [-110, 29],
        [-40, -25],
        [-9, 111],
        [-82, 78],
        [-62, 13],
        [-85, 87]
      ],
      [
        [17195, 16123],
        [-34, 38],
        [-102, 40]
      ],
      [
        [17059, 16201],
        [68, 79],
        [45, 4],
        [48, 54],
        [83, 1],
        [13, 38],
        [65, 34],
        [74, -74],
        [53, -31],
        [248, -54],
        [11, -43]
      ],
      [
        [17767, 16209],
        [-16, -35],
        [54, -53],
        [-3, -62],
        [46, -74],
        [-26, -26],
        [27, -128]
      ],
      [
        [17849, 15831],
        [-37, -39],
        [0, -81],
        [29, -39]
      ],
      [
        [17326, 15351],
        [80, -33],
        [19, -38],
        [101, 37],
        [36, 114],
        [-41, 26]
      ],
      [
        [17521, 15457],
        [23, 26]
      ],
      [
        [17544, 15483],
        [91, -21]
      ],
      [
        [17076, 15159],
        [21, 31],
        [71, 54],
        [-23, 36]
      ],
      [
        [17767, 16209],
        [121, -11],
        [55, 129],
        [32, 3],
        [76, 60],
        [117, 66],
        [49, -6],
        [86, 57],
        [57, -71],
        [44, -94],
        [98, 15],
        [-31, -62],
        [-84, -24],
        [-44, -62],
        [64, -80],
        [64, 65],
        [59, 4],
        [54, -49],
        [12, -63],
        [46, -63],
        [-15, -56],
        [-74, -24],
        [14, -37],
        [-109, -89]
      ],
      [
        [18458, 15817],
        [-46, 19],
        [-100, -35],
        [-58, 14],
        [-43, -19],
        [-2, -58],
        [-62, -26],
        [-12, -67],
        [-102, 64],
        [-67, 6],
        [4, 67],
        [-121, 49]
      ],
      [
        [18458, 15817],
        [30, -21],
        [-38, -72]
      ],
      [
        [17544, 15483],
        [13, 56],
        [-35, 67],
        [-79, -25],
        [-105, 52],
        [-84, 100]
      ],
      [
        [17254, 15733],
        [48, 72],
        [-15, 69],
        [-44, 27],
        [11, 47],
        [-70, 146],
        [11, 29]
      ],
      [
        [16912, 15964],
        [23, 93],
        [105, 83],
        [19, 61]
      ],
      [
        [17254, 15733],
        [-55, -41]
      ],
      [
        [17521, 15457],
        [-48, -22],
        [-142, 55],
        [-77, -29]
      ],
      [
        [16123, 3934],
        [0, 2]
      ],
      [
        [16123, 3936],
        [0, -2]
      ],
      [
        [16195, 3978],
        [-7, -55],
        [-56, 17],
        [-19, 46],
        [46, 49],
        [14, -9],
        [26, 1],
        [-4, -49]
      ],
      [
        [16200, 4048],
        [-28, -21],
        [-14, 10],
        [-20, -2],
        [-39, -10],
        [-13, 21],
        [9, 157],
        [21, 130],
        [-10, 82],
        [42, 19],
        [-4, 115],
        [22, 67],
        [13, 203],
        [19, 59],
        [41, 19],
        [36, 55],
        [36, -33],
        [-8, -134],
        [22, -52],
        [-22, -69],
        [2, -70],
        [-49, -48],
        [-31, 28],
        [-35, -111],
        [43, -13],
        [29, -105],
        [-8, -84],
        [12, -59],
        [-66, -154]
      ],
      [
        [15969, 3005],
        [43, -80],
        [7, -77],
        [-43, -117],
        [-64, 22],
        [-32, 87],
        [-4, 81],
        [93, 84]
      ],
      [
        [16047, 3451],
        [33, -99],
        [-60, -20],
        [-8, 39],
        [35, 80]
      ],
      [
        [16123, 3934],
        [-14, -66],
        [31, -26],
        [-49, -54],
        [55, -64],
        [-24, -134],
        [-61, -35],
        [59, -32],
        [-56, -76],
        [-75, 156],
        [-10, 140],
        [43, -46],
        [14, 184],
        [25, 82],
        [62, -27]
      ],
      [
        [16830, 345],
        [21, -26],
        [30, -186],
        [-24, -113],
        [-51, -20],
        [-54, 164],
        [-33, 23],
        [-14, 75],
        [19, 47],
        [106, 36]
      ],
      [
        [16741, 494],
        [28, -50],
        [-20, -47],
        [-50, -49],
        [-18, 49],
        [60, 97]
      ],
      [
        [16147, 1798],
        [22, -71],
        [-64, -10],
        [-5, 67],
        [47, 14]
      ],
      [
        [6521, 16233],
        [93, -39],
        [112, -6],
        [96, 32]
      ],
      [
        [6822, 16220],
        [-3, -72],
        [56, -15],
        [30, -70],
        [-24, -31]
      ],
      [
        [6881, 16032],
        [-141, -18],
        [21, -140],
        [-18, -92],
        [-70, -18]
      ],
      [
        [6673, 15764],
        [-62, 66],
        [0, 71]
      ],
      [
        [6611, 15901],
        [-51, 113],
        [-7, 70]
      ],
      [
        [6553, 16084],
        [-29, 72],
        [-3, 77]
      ],
      [
        [4822, 16119],
        [30, -67],
        [27, -161],
        [40, -8],
        [31, -60]
      ],
      [
        [4950, 15823],
        [-111, -133],
        [-77, 1],
        [-88, 92],
        [-15, -50],
        [-52, -10],
        [1, -63],
        [-67, -29],
        [-13, -38]
      ],
      [
        [4528, 15593],
        [-90, -10],
        [-53, -92],
        [-14, -79],
        [-32, -46],
        [54, -65],
        [-50, -25],
        [-16, -65]
      ],
      [
        [4327, 15211],
        [-59, -21],
        [-89, 28],
        [-98, -4],
        [-57, -59],
        [-38, -74],
        [5, -56],
        [-80, 41],
        [-34, 41],
        [-79, -33],
        [-22, 35]
      ],
      [
        [3776, 15109],
        [13, 47],
        [-24, 42],
        [6, 87],
        [82, 23],
        [3, -56],
        [45, -2],
        [35, 48],
        [70, 14],
        [8, 133],
        [37, 33],
        [-1, 73],
        [42, 44],
        [-72, 30],
        [-33, 61],
        [-89, 1],
        [-22, 32],
        [17, 109],
        [36, 43],
        [-19, 62],
        [74, 28],
        [-21, 49]
      ],
      [
        [3963, 16010],
        [70, 15],
        [99, 64],
        [37, -51],
        [179, 28],
        [35, 55],
        [79, -27],
        [46, 13],
        [147, -32],
        [16, 48],
        [59, 37],
        [21, -49],
        [71, 8]
      ],
      [
        [6611, 15901],
        [-52, 7],
        [-110, 58],
        [-40, -60],
        [-30, 16],
        [-70, -70],
        [-42, -1]
      ],
      [
        [6267, 15851],
        [-77, 69]
      ],
      [
        [6190, 15920],
        [-13, 24],
        [94, 43]
      ],
      [
        [6271, 15987],
        [219, 96],
        [63, 1]
      ],
      [
        [5961, 16066],
        [4, -16]
      ],
      [
        [5965, 16050],
        [-9, -29]
      ],
      [
        [5956, 16021],
        [-11, -74]
      ],
      [
        [5945, 15947],
        [-108, 46],
        [-38, 43]
      ],
      [
        [5799, 16036],
        [100, 34],
        [62, -4]
      ],
      [
        [5744, 16034],
        [38, -8]
      ],
      [
        [5782, 16026],
        [19, -73]
      ],
      [
        [5801, 15953],
        [-12, -22]
      ],
      [
        [5789, 15931],
        [-42, -26],
        [-28, -59],
        [25, -35]
      ],
      [
        [5744, 15811],
        [-109, -48],
        [-32, -42]
      ],
      [
        [5603, 15721],
        [-27, 33],
        [-219, 32]
      ],
      [
        [5357, 15786],
        [53, 96],
        [60, 10],
        [-28, 64]
      ],
      [
        [5442, 15956],
        [32, 29],
        [70, -5],
        [17, 42],
        [100, -17],
        [83, 29]
      ],
      [
        [7574, 16067],
        [5, -74],
        [-45, -80],
        [105, -101],
        [-8, -51],
        [-48, -90],
        [4, -39]
      ],
      [
        [7587, 15632],
        [-66, -124],
        [-64, -51]
      ],
      [
        [7457, 15457],
        [-5, 77],
        [-47, 38],
        [-162, 9],
        [-49, 25],
        [-28, 118],
        [-57, 28]
      ],
      [
        [7109, 15752],
        [68, 63],
        [85, 46],
        [19, 64],
        [47, 61],
        [35, 7],
        [41, 105]
      ],
      [
        [7404, 16098],
        [106, -37],
        [64, 6]
      ],
      [
        [7574, 16067],
        [90, 24],
        [88, -120],
        [49, 19],
        [23, 64]
      ],
      [
        [7824, 16054],
        [36, -7],
        [103, -84],
        [24, -60]
      ],
      [
        [7987, 15903],
        [87, -81],
        [-60, -72],
        [2, -65]
      ],
      [
        [8016, 15685],
        [-89, -21],
        [-48, 33],
        [-87, 24],
        [-20, -71],
        [0, -127],
        [-63, 63],
        [-60, -25],
        [-62, 71]
      ],
      [
        [6015, 15961],
        [-29, -29]
      ],
      [
        [5986, 15932],
        [-17, 73]
      ],
      [
        [5969, 16005],
        [46, -44]
      ],
      [
        [5801, 15953],
        [131, -22]
      ],
      [
        [5932, 15931],
        [6, -32]
      ],
      [
        [5938, 15899],
        [-50, -7]
      ],
      [
        [5888, 15892],
        [-65, 8],
        [-34, 31]
      ],
      [
        [6673, 15764],
        [-17, -36],
        [22, -83],
        [109, -118]
      ],
      [
        [6787, 15527],
        [-44, -21],
        [-47, 46],
        [-105, -51],
        [-97, 38],
        [-24, -37],
        [-52, 16],
        [-48, 57],
        [-71, -36]
      ],
      [
        [6299, 15539],
        [-29, 110],
        [32, 28],
        [-68, 79],
        [33, 95]
      ],
      [
        [6014, 15858],
        [-26, 29]
      ],
      [
        [5988, 15887],
        [-8, 10]
      ],
      [
        [5980, 15897],
        [13, 22]
      ],
      [
        [5993, 15919],
        [34, -7]
      ],
      [
        [6027, 15912],
        [16, -23]
      ],
      [
        [6043, 15889],
        [-29, -31]
      ],
      [
        [5888, 15892],
        [-5, -76]
      ],
      [
        [5883, 15816],
        [-59, 23],
        [-80, -28]
      ],
      [
        [5956, 16021],
        [13, -16]
      ],
      [
        [5986, 15932],
        [7, -13]
      ],
      [
        [5980, 15897],
        [-42, 2]
      ],
      [
        [5932, 15931],
        [13, 16]
      ],
      [
        [6299, 15539],
        [-108, -30],
        [-60, -2]
      ],
      [
        [6131, 15507],
        [16, 88]
      ],
      [
        [6147, 15595],
        [3, 120],
        [-103, 109]
      ],
      [
        [6047, 15824],
        [-33, 34]
      ],
      [
        [6043, 15889],
        [147, 31]
      ],
      [
        [5988, 15887],
        [-34, -33]
      ],
      [
        [5954, 15854],
        [-56, -53]
      ],
      [
        [5898, 15801],
        [-15, 15]
      ],
      [
        [7987, 15903],
        [95, -3],
        [61, 48],
        [75, -35],
        [31, -54],
        [221, -119]
      ],
      [
        [8470, 15740],
        [-8, -87],
        [102, -133],
        [-1, -69],
        [72, -73],
        [-15, -164]
      ],
      [
        [8620, 15214],
        [-67, 75],
        [-124, 29],
        [-21, 54],
        [-86, -79],
        [-121, 35],
        [-24, -64],
        [-57, 43],
        [-44, -44],
        [-91, -50]
      ],
      [
        [7985, 15213],
        [-38, 56],
        [-106, 19],
        [-20, -17]
      ],
      [
        [7821, 15271],
        [-20, 103],
        [62, 73],
        [85, 64],
        [29, 53],
        [8, 83],
        [31, 38]
      ],
      [
        [5954, 15854],
        [32, -57]
      ],
      [
        [5986, 15797],
        [-52, -57]
      ],
      [
        [5934, 15740],
        [-36, 61]
      ],
      [
        [4950, 15823],
        [146, -94]
      ],
      [
        [5096, 15729],
        [106, -123],
        [-37, -71],
        [6, -47],
        [-23, -92],
        [-26, -3]
      ],
      [
        [5122, 15393],
        [-108, -71],
        [-53, -110],
        [-96, 24],
        [-73, -51],
        [-94, 56],
        [1, 74],
        [-28, 19],
        [-96, 164],
        [20, 47],
        [-67, 48]
      ],
      [
        [5934, 15740],
        [-12, -64],
        [44, -37]
      ],
      [
        [5966, 15639],
        [-21, -42]
      ],
      [
        [5945, 15597],
        [-111, 29],
        [-28, 63],
        [-79, -77]
      ],
      [
        [5727, 15612],
        [-118, 25],
        [-6, 84]
      ],
      [
        [6147, 15595],
        [-181, 44]
      ],
      [
        [5986, 15797],
        [61, 27]
      ],
      [
        [5096, 15729],
        [8, 31]
      ],
      [
        [5104, 15760],
        [51, 9],
        [22, -43],
        [61, 47],
        [114, -15]
      ],
      [
        [5352, 15758],
        [54, -78],
        [-36, -105]
      ],
      [
        [5370, 15575],
        [31, -39],
        [-27, -79],
        [-38, 37],
        [-66, -50],
        [6, -69],
        [37, -51]
      ],
      [
        [5313, 15324],
        [-32, -25],
        [-65, 31]
      ],
      [
        [5216, 15330],
        [-69, 8],
        [-25, 55]
      ],
      [
        [5727, 15612],
        [-3, -6]
      ],
      [
        [5724, 15606],
        [-38, -53],
        [-71, -44],
        [-12, -54],
        [-85, -28],
        [3, 43],
        [-151, 105]
      ],
      [
        [5352, 15758],
        [5, 28]
      ],
      [
        [7457, 15457],
        [-46, -125],
        [-49, -30],
        [-5, -105]
      ],
      [
        [7357, 15197],
        [-109, 40]
      ],
      [
        [7248, 15237],
        [-13, 61],
        [-44, 24],
        [-117, 14],
        [-20, 48],
        [-183, 75]
      ],
      [
        [6871, 15459],
        [-19, 32]
      ],
      [
        [6852, 15491],
        [48, 186],
        [93, 58],
        [51, 51]
      ],
      [
        [7044, 15786],
        [44, -6]
      ],
      [
        [7088, 15780],
        [21, -28]
      ],
      [
        [2472, 15383],
        [97, 27],
        [72, -52],
        [15, -64],
        [-44, -35],
        [78, -47],
        [81, 10],
        [-39, -102]
      ],
      [
        [2732, 15120],
        [-23, -47]
      ],
      [
        [2709, 15073],
        [0, -3]
      ],
      [
        [2709, 15070],
        [-45, -16],
        [-82, 112],
        [-157, -127],
        [5, -73],
        [45, -36],
        [50, -109],
        [52, -26],
        [-2, -124],
        [42, -35],
        [-31, -61],
        [21, -52],
        [-32, -37],
        [39, -57],
        [-46, -74],
        [32, -35],
        [-8, -74]
      ],
      [
        [2592, 14246],
        [-112, -39],
        [-36, 56],
        [-33, -20],
        [-100, 42],
        [-40, 74],
        [-56, -36],
        [-34, 29],
        [-71, -55],
        [-29, 33],
        [-46, -17],
        [-47, -98],
        [-43, 10],
        [-42, -31],
        [26, -102],
        [-72, -44],
        [-48, 38],
        [-82, 7],
        [-57, 40],
        [-146, -15],
        [-45, -24],
        [-145, 10]
      ],
      [
        [1334, 14104],
        [22, 69],
        [7, 90],
        [-7, 129],
        [-77, 35],
        [-111, -15],
        [-62, 14],
        [-47, 41],
        [-137, 64],
        [-17, 45],
        [19, 149],
        [48, 127],
        [181, 159],
        [46, 69],
        [60, 47],
        [70, 177],
        [61, 69],
        [95, 81],
        [89, 18],
        [53, -19],
        [58, -65],
        [4, -68],
        [49, -77],
        [97, -9],
        [195, 92],
        [116, 27],
        [186, 4],
        [136, 56],
        [4, -30]
      ],
      [
        [8470, 15740],
        [105, -34],
        [13, -50],
        [57, -67],
        [69, -19],
        [34, -64],
        [173, -95]
      ],
      [
        [8921, 15411],
        [-43, -63],
        [-21, -66],
        [34, -35],
        [-10, -113],
        [62, -34],
        [83, -9],
        [51, -57]
      ],
      [
        [9077, 15034],
        [-109, -123],
        [-47, 44],
        [-51, -67],
        [-15, -55],
        [-83, -54]
      ],
      [
        [8772, 14779],
        [-51, 69],
        [-16, 113]
      ],
      [
        [8705, 14961],
        [-96, 187],
        [11, 66]
      ],
      [
        [5945, 15597],
        [-46, -67],
        [24, -122],
        [122, -72]
      ],
      [
        [6045, 15336],
        [-40, -37]
      ],
      [
        [6005, 15299],
        [-156, 16],
        [-44, -121]
      ],
      [
        [5805, 15194],
        [-56, 57],
        [33, 80],
        [-8, 110],
        [26, 105],
        [-76, 60]
      ],
      [
        [7821, 15271],
        [-62, -20],
        [-68, -61],
        [-63, 47],
        [-52, -55],
        [34, -96],
        [-1, -44]
      ],
      [
        [7609, 15042],
        [-54, 43],
        [-41, 68],
        [-157, 44]
      ],
      [
        [5216, 15330],
        [-6, -54],
        [-83, -108],
        [8, -41],
        [-23, -81],
        [-79, -55],
        [-37, 18],
        [-92, -72],
        [-48, 25],
        [-34, -38],
        [-54, -3],
        [-42, -50],
        [-8, -48]
      ],
      [
        [4718, 14823],
        [-77, -13],
        [-84, 65],
        [60, 74],
        [-82, 27],
        [-89, -17],
        [-26, 86],
        [-90, 38],
        [26, 46],
        [-29, 82]
      ],
      [
        [6131, 15507],
        [43, -69],
        [-8, -46]
      ],
      [
        [6166, 15392],
        [-71, -52],
        [-50, -4]
      ],
      [
        [5805, 15194],
        [-28, -37],
        [66, -65],
        [-18, -86],
        [41, -1],
        [49, -54],
        [-60, -118],
        [-64, -11]
      ],
      [
        [5791, 14822],
        [-58, 63],
        [-29, -71],
        [-93, -13],
        [-23, 36],
        [-61, 6],
        [-64, -70],
        [-114, -8]
      ],
      [
        [5349, 14765],
        [-10, 87],
        [-58, 0],
        [-39, 36],
        [33, 55],
        [46, 120],
        [-29, 102],
        [33, 11],
        [-12, 148]
      ],
      [
        [13329, 14991],
        [-45, 32],
        [-38, 74],
        [-49, -6]
      ],
      [
        [13197, 15091],
        [-47, 50],
        [-62, 27]
      ],
      [
        [13088, 15168],
        [54, 124],
        [5, 111],
        [172, 55],
        [18, 27],
        [81, 32],
        [90, -16],
        [57, -61],
        [-5, -46],
        [34, -53],
        [-21, -29],
        [-5, -108],
        [-55, -75],
        [19, -108]
      ],
      [
        [13532, 15021],
        [-203, -30]
      ],
      [
        [6787, 15527],
        [65, -36]
      ],
      [
        [6871, 15459],
        [-87, -153]
      ],
      [
        [6784, 15306],
        [-45, 17],
        [-23, -61],
        [-85, -60],
        [-69, 78],
        [-73, -6],
        [0, -70],
        [-34, -53],
        [-47, -12]
      ],
      [
        [6408, 15139],
        [-65, 89],
        [9, 82],
        [-32, 65],
        [-80, 47],
        [-74, -30]
      ],
      [
        [7248, 15237],
        [-36, -57],
        [57, -41]
      ],
      [
        [7269, 15139],
        [-92, -15],
        [-52, 65],
        [-29, -53],
        [-43, 9],
        [-124, 72],
        [-6, 41],
        [-57, 21],
        [-58, -22]
      ],
      [
        [6808, 15257],
        [-24, 49]
      ],
      [
        [6408, 15139],
        [-8, -175],
        [62, -9]
      ],
      [
        [6462, 14955],
        [-35, -44],
        [-50, 23],
        [-73, -41],
        [-62, 1]
      ],
      [
        [6242, 14894],
        [-136, 156],
        [-64, 51],
        [8, 91],
        [-45, 107]
      ],
      [
        [5349, 14765],
        [-27, -37],
        [-14, -76],
        [28, -55],
        [-37, -24],
        [-39, -77],
        [25, -60],
        [-19, -66]
      ],
      [
        [5266, 14370],
        [-34, 12],
        [-61, -28],
        [-127, 15],
        [-69, -54],
        [-91, 2],
        [-75, 35],
        [-58, -6],
        [-25, 53],
        [-82, -32],
        [-23, -39]
      ],
      [
        [4621, 14328],
        [-69, 66],
        [2, 73],
        [-66, 21],
        [-33, 112],
        [40, 39]
      ],
      [
        [4495, 14639],
        [23, 40],
        [99, -10],
        [26, 31],
        [11, 77],
        [74, 8],
        [-10, 38]
      ],
      [
        [8921, 15411],
        [93, -70],
        [50, 49],
        [71, 0],
        [34, -42],
        [56, -16]
      ],
      [
        [9225, 15332],
        [-54, -79],
        [-26, -74],
        [-41, -39],
        [34, -130]
      ],
      [
        [9138, 15010],
        [-61, 24]
      ],
      [
        [2709, 15070],
        [203, 99],
        [67, -61],
        [111, 36],
        [0, -85],
        [100, -63],
        [62, 34],
        [34, -20],
        [5, -68]
      ],
      [
        [3291, 14942],
        [-21, -62],
        [13, -205],
        [54, -53],
        [79, -10],
        [56, 23],
        [120, -16],
        [56, -77],
        [-18, -31],
        [45, -128],
        [30, -3],
        [68, -77]
      ],
      [
        [3773, 14303],
        [-39, -53],
        [0, -179],
        [-102, -30],
        [-18, 55],
        [-107, -44],
        [-40, 56],
        [-41, -33],
        [-21, -62],
        [-75, 28],
        [-20, -27],
        [-72, -13],
        [-6, -36],
        [-55, -47],
        [-81, -26]
      ],
      [
        [3096, 13892],
        [-140, 80],
        [48, 46],
        [-3, 108],
        [-62, 67],
        [-89, 16],
        [-31, -46],
        [-45, 6],
        [-49, -35],
        [-133, 112]
      ],
      [
        [2732, 15120],
        [-23, -47]
      ],
      [
        [8705, 14961],
        [-35, -56],
        [-66, 57],
        [-49, -66],
        [-46, 22],
        [-30, -41],
        [-64, 15],
        [-25, -59]
      ],
      [
        [8390, 14833],
        [-68, -41]
      ],
      [
        [8322, 14792],
        [-19, 71],
        [-68, 12],
        [-60, 34],
        [-55, 4],
        [-43, 97],
        [-83, 88],
        [-9, 115]
      ],
      [
        [6242, 14894],
        [8, -52],
        [-70, -43],
        [72, -102],
        [-112, -51],
        [-60, -51],
        [37, -64]
      ],
      [
        [6117, 14531],
        [-70, -23]
      ],
      [
        [6047, 14508],
        [-36, 50],
        [-128, 60]
      ],
      [
        [5883, 14618],
        [-47, 57],
        [-9, 74],
        [-36, 73]
      ],
      [
        [6808, 15257],
        [3, -52],
        [-66, -65],
        [-54, 2],
        [-84, -59],
        [-4, -69]
      ],
      [
        [6603, 15014],
        [-41, -31],
        [-100, -28]
      ],
      [
        [4495, 14639],
        [4, 38],
        [-84, 26],
        [-50, -138],
        [-51, -11],
        [16, -54],
        [-34, -76],
        [-53, 25],
        [-83, -104],
        [-61, 0],
        [-51, -28]
      ],
      [
        [4048, 14317],
        [-35, 9],
        [-51, -37],
        [-189, 14]
      ],
      [
        [3291, 14942],
        [62, 20],
        [20, -55],
        [65, 0],
        [84, 71],
        [38, 100],
        [105, 18],
        [59, -16],
        [52, 29]
      ],
      [
        [7269, 15139],
        [37, -47],
        [-12, -135]
      ],
      [
        [7294, 14957],
        [-121, 65],
        [-86, 10],
        [-33, 30],
        [-35, -81],
        [-76, -13]
      ],
      [
        [6943, 14968],
        [-35, 94],
        [-44, 26],
        [-69, -88],
        [-68, -19],
        [-64, 18]
      ],
      [
        [6663, 14999],
        [-60, 15]
      ],
      [
        [8322, 14792],
        [-118, -17],
        [-63, -47]
      ],
      [
        [8141, 14728],
        [-122, -67],
        [-36, 76],
        [-85, -50],
        [-41, 27],
        [-47, -51]
      ],
      [
        [7810, 14663],
        [-20, 23]
      ],
      [
        [7790, 14686],
        [-55, 136],
        [-81, 21],
        [-54, 36]
      ],
      [
        [7600, 14879],
        [-23, 114],
        [32, 49]
      ],
      [
        [7600, 14879],
        [-35, -40],
        [-98, 31],
        [-82, -9]
      ],
      [
        [7385, 14861],
        [-51, 34],
        [-40, 62]
      ],
      [
        [13197, 15091],
        [-4, -78],
        [18, -129],
        [-14, -70]
      ],
      [
        [13197, 14814],
        [-83, -16],
        [-38, 17],
        [-38, 63]
      ],
      [
        [13038, 14878],
        [4, 188],
        [46, 102]
      ],
      [
        [13329, 14991],
        [-29, -81],
        [61, -64]
      ],
      [
        [13361, 14846],
        [-70, -76]
      ],
      [
        [13291, 14770],
        [-94, 44]
      ],
      [
        [13532, 15021],
        [82, -70],
        [-10, -35],
        [-66, -18],
        [-7, -45],
        [-46, -34]
      ],
      [
        [13485, 14819],
        [-81, 36],
        [-43, -9]
      ],
      [
        [6943, 14968],
        [5, -108],
        [58, -34],
        [-33, -70],
        [30, -69]
      ],
      [
        [7003, 14687],
        [-46, -27]
      ],
      [
        [6957, 14660],
        [-44, -29],
        [-143, 93],
        [-78, 66],
        [-69, -3],
        [-22, 70],
        [27, 89],
        [35, 53]
      ],
      [
        [10726, 14429],
        [-55, 21]
      ],
      [
        [10671, 14450],
        [-58, 38],
        [-46, 88],
        [-130, 60],
        [-7, 114],
        [-56, 29],
        [19, 66],
        [-56, 73]
      ],
      [
        [10337, 14918],
        [-30, 44]
      ],
      [
        [10307, 14962],
        [-20, 67],
        [121, 7],
        [53, 58],
        [105, -48],
        [14, -41],
        [223, -40],
        [45, -86],
        [-31, -126],
        [76, -33]
      ],
      [
        [10893, 14720],
        [-52, -65],
        [43, -71],
        [-11, -53],
        [-120, -65],
        [-27, -37]
      ],
      [
        [9840, 14801],
        [-18, -10]
      ],
      [
        [9822, 14791],
        [-141, -70]
      ],
      [
        [9681, 14721],
        [-73, 32],
        [-19, 46],
        [-117, -5],
        [-17, -16]
      ],
      [
        [9455, 14778],
        [-67, 50]
      ],
      [
        [9388, 14828],
        [36, 44],
        [-12, 107],
        [55, 46],
        [90, -15],
        [11, 62]
      ],
      [
        [9568, 15072],
        [129, 10],
        [69, -38],
        [101, 4],
        [67, -86]
      ],
      [
        [9934, 14962],
        [-82, -80],
        [-12, -81]
      ],
      [
        [7385, 14861],
        [13, -42],
        [-21, -110],
        [-37, -20]
      ],
      [
        [7340, 14689],
        [-95, 33],
        [-242, -35]
      ],
      [
        [10337, 14918],
        [-59, -25],
        [-11, -95],
        [-50, -115],
        [-65, 3],
        [-52, -49]
      ],
      [
        [10100, 14637],
        [-70, 51],
        [-75, 7],
        [43, 83],
        [-109, 6],
        [-49, 17]
      ],
      [
        [9934, 14962],
        [34, 0],
        [43, 57],
        [-9, 48],
        [143, -8],
        [142, -72],
        [20, -25]
      ],
      [
        [6957, 14660],
        [75, -79],
        [-48, -31]
      ],
      [
        [6984, 14550],
        [-154, -4]
      ],
      [
        [6830, 14546],
        [-98, 39],
        [-24, 38],
        [-89, -27]
      ],
      [
        [6619, 14596],
        [32, 64],
        [-80, 21],
        [-25, -39],
        [-81, -5],
        [-148, 32],
        [-25, -42],
        [-129, -41],
        [-46, -55]
      ],
      [
        [9138, 15010],
        [146, -112],
        [-45, -57],
        [63, -75],
        [63, 14],
        [23, 48]
      ],
      [
        [9455, 14778],
        [2, -86],
        [-48, -44],
        [-113, 54],
        [-56, -80],
        [-1, -41]
      ],
      [
        [9239, 14581],
        [-24, 18],
        [-141, -40],
        [-55, 33],
        [-94, 30]
      ],
      [
        [8925, 14622],
        [-17, 42],
        [-71, 77],
        [-65, 38]
      ],
      [
        [8925, 14622],
        [-70, -33],
        [-54, -132]
      ],
      [
        [8801, 14457],
        [-15, -71],
        [-101, 34],
        [-24, -34]
      ],
      [
        [8661, 14386],
        [-107, 46],
        [-13, -14]
      ],
      [
        [8541, 14418],
        [36, 87],
        [-160, 253],
        [26, 63],
        [-53, 12]
      ],
      [
        [13291, 14770],
        [-1, -84],
        [36, -55]
      ],
      [
        [13326, 14631],
        [-31, -44],
        [12, -85],
        [-32, -43]
      ],
      [
        [13275, 14459],
        [-44, -107]
      ],
      [
        [13231, 14352],
        [-61, -28]
      ],
      [
        [13170, 14324],
        [-85, 65]
      ],
      [
        [13085, 14389],
        [33, 65],
        [17, 98],
        [-43, 130],
        [-84, 115],
        [30, 81]
      ],
      [
        [5883, 14618],
        [-95, 7],
        [-33, 72],
        [-69, 10],
        [-15, -68],
        [-104, -79],
        [-51, -1],
        [-40, -47]
      ],
      [
        [5476, 14512],
        [-47, -110],
        [49, -48],
        [-43, -61],
        [-58, 30],
        [-97, 21]
      ],
      [
        [5280, 14344],
        [-14, 26]
      ],
      [
        [10671, 14450],
        [-90, -23],
        [-110, 22],
        [-40, -57]
      ],
      [
        [10431, 14392],
        [-138, 151],
        [-46, -43],
        [-93, -28]
      ],
      [
        [10154, 14472],
        [-4, 67],
        [-64, 72],
        [14, 26]
      ],
      [
        [7790, 14686],
        [-47, -12],
        [-29, -89]
      ],
      [
        [7714, 14585],
        [-36, -32],
        [-56, 15]
      ],
      [
        [7622, 14568],
        [-102, 72],
        [-68, -8],
        [-39, 43],
        [-59, -8]
      ],
      [
        [7354, 14667],
        [-14, 22]
      ],
      [
        [8541, 14418],
        [-74, -60],
        [-32, 20]
      ],
      [
        [8435, 14378],
        [-103, 97],
        [-32, -15],
        [-48, 41],
        [1, 72],
        [-61, 57],
        [-18, 78],
        [-33, 20]
      ],
      [
        [13326, 14631],
        [81, 0],
        [40, 33],
        [63, 0],
        [19, 48],
        [52, -19]
      ],
      [
        [13581, 14693],
        [34, 21],
        [110, -77],
        [1, -35]
      ],
      [
        [13726, 14602],
        [-31, -152],
        [41, -28],
        [9, -50]
      ],
      [
        [13745, 14372],
        [-103, 10],
        [-23, -62],
        [-109, -90]
      ],
      [
        [13510, 14230],
        [-38, 42],
        [-112, 67],
        [-72, 61],
        [-13, 59]
      ],
      [
        [9681, 14721],
        [-23, -47],
        [11, -117],
        [60, -52],
        [-55, -71],
        [-49, -30]
      ],
      [
        [9625, 14404],
        [-70, -10],
        [-32, 36],
        [-56, 0],
        [-68, 35]
      ],
      [
        [9399, 14465],
        [-53, 0],
        [-72, 62],
        [-35, 54]
      ],
      [
        [10154, 14472],
        [-18, -107],
        [-68, -16],
        [6, -55],
        [77, -70],
        [4, -74]
      ],
      [
        [10155, 14150],
        [-62, 40],
        [-44, 1]
      ],
      [
        [10049, 14191],
        [-32, -1],
        [-53, 55],
        [-71, 33],
        [-63, -7]
      ],
      [
        [9830, 14271],
        [-40, 18]
      ],
      [
        [9790, 14289],
        [55, 94],
        [-29, 58],
        [-9, 136],
        [36, 48],
        [42, 7],
        [5, 72],
        [-68, 87]
      ],
      [
        [9790, 14289],
        [-34, 47],
        [-78, 29],
        [-53, 39]
      ],
      [
        [6047, 14508],
        [19, -67],
        [-97, -65],
        [18, -71],
        [50, 0],
        [28, -49]
      ],
      [
        [6065, 14256],
        [-68, -71],
        [-99, -39]
      ],
      [
        [5898, 14146],
        [-79, -61],
        [-64, -27],
        [-32, -44]
      ],
      [
        [5723, 14014],
        [-98, 108],
        [-82, 25],
        [16, 88],
        [175, 126],
        [66, 31],
        [7, 37],
        [-42, 59],
        [-56, -23],
        [-48, -61],
        [-185, 108]
      ],
      [
        [10893, 14720],
        [43, 13],
        [90, -44],
        [45, -62],
        [106, -4],
        [-9, -52],
        [50, -32]
      ],
      [
        [11218, 14539],
        [7, -78]
      ],
      [
        [11225, 14461],
        [-3, -43],
        [-54, -73],
        [73, -97]
      ],
      [
        [11241, 14248],
        [-2, -1]
      ],
      [
        [11239, 14247],
        [-4, -2]
      ],
      [
        [11235, 14245],
        [-53, -47],
        [-101, 41],
        [-94, -11],
        [-24, -48]
      ],
      [
        [10963, 14180],
        [-140, 150],
        [-39, -21],
        [-53, 69],
        [-5, 51]
      ],
      [
        [8435, 14378],
        [7, -79],
        [26, -35],
        [-151, -127],
        [-82, -29],
        [-13, -28]
      ],
      [
        [8222, 14080],
        [-54, 39],
        [0, 40]
      ],
      [
        [8168, 14159],
        [-48, 92],
        [-136, 134],
        [-41, 106],
        [-54, 19],
        [-31, 46],
        [17, 60],
        [-65, 47]
      ],
      [
        [7354, 14667],
        [-18, -197],
        [-65, -69],
        [33, -61],
        [-36, -32]
      ],
      [
        [7268, 14308],
        [-52, 3]
      ],
      [
        [7216, 14311],
        [-95, 101],
        [11, 67],
        [-88, 19],
        [-60, 52]
      ],
      [
        [6619, 14596],
        [-72, -27],
        [-15, -87],
        [-58, 14],
        [-63, -26],
        [-53, -79],
        [-51, -9],
        [-135, -92],
        [-66, -6],
        [-41, -28]
      ],
      [
        [8168, 14159],
        [-174, -85],
        [-46, -50],
        [-12, -87]
      ],
      [
        [7936, 13937],
        [-99, 52],
        [18, 35],
        [-102, 23],
        [4, 52]
      ],
      [
        [7757, 14099],
        [30, 81],
        [110, 61],
        [-37, 88],
        [36, 28],
        [-27, 49],
        [-73, 28],
        [-12, 64],
        [-70, 87]
      ],
      [
        [7622, 14568],
        [-25, -99],
        [-51, -37],
        [-27, -102],
        [-60, -74]
      ],
      [
        [7459, 14256],
        [-22, 49],
        [-97, -25],
        [-72, 28]
      ],
      [
        [6830, 14546],
        [-33, -68],
        [-83, -72],
        [-99, -30],
        [50, -91],
        [-23, -55]
      ],
      [
        [6642, 14230],
        [-70, 9],
        [-80, -24],
        [-11, -26],
        [-128, -13],
        [-47, -68],
        [-10, -84],
        [-39, -57],
        [18, -48]
      ],
      [
        [6275, 13919],
        [-35, -2]
      ],
      [
        [6240, 13917],
        [4, 46],
        [-146, 117],
        [-73, 14],
        [-40, -40],
        [-87, 92]
      ],
      [
        [3096, 13892],
        [-37, -44]
      ],
      [
        [3059, 13848],
        [-12, -58],
        [-48, -40],
        [-7, -41],
        [-56, -3],
        [-19, -57],
        [-91, -66],
        [-56, 0],
        [-10, -37],
        [-189, 62],
        [-76, -93],
        [20, -22],
        [-66, -85],
        [-36, -88],
        [-35, -7],
        [-36, -60],
        [-31, 35],
        [-52, -38],
        [-33, 20],
        [-108, -51],
        [-8, -70],
        [-91, -140]
      ],
      [
        [2019, 13009],
        [-50, 18]
      ],
      [
        [1969, 13027],
        [-114, 192],
        [-32, 152],
        [-90, 94],
        [-56, 87],
        [6, 203],
        [-43, 28],
        [-51, -23],
        [-94, -7],
        [-77, 29],
        [-111, 164],
        [-10, 105],
        [37, 53]
      ],
      [
        [9399, 14465],
        [-30, -77],
        [-60, 23],
        [-54, -114],
        [-20, -8]
      ],
      [
        [9235, 14289],
        [-82, 49],
        [-103, 22]
      ],
      [
        [9050, 14360],
        [-158, 26],
        [-37, 70],
        [-54, 1]
      ],
      [
        [7757, 14099],
        [-30, -43]
      ],
      [
        [7727, 14056],
        [-88, 15],
        [-13, 53],
        [-74, 20],
        [-63, 43],
        [-30, 69]
      ],
      [
        [7216, 14311],
        [2, -74],
        [-94, -103],
        [11, -83],
        [-41, -40],
        [-7, -55]
      ],
      [
        [7087, 13956],
        [-34, -29]
      ],
      [
        [7053, 13927],
        [-53, 23],
        [-21, 54],
        [47, 68],
        [-36, 81],
        [-61, -4],
        [-45, -44]
      ],
      [
        [6884, 14105],
        [-141, 101],
        [-79, 38],
        [-22, -14]
      ],
      [
        [5723, 14014],
        [-42, -64],
        [-47, -31],
        [-48, 5],
        [-63, -51]
      ],
      [
        [5523, 13873],
        [-45, 2],
        [-23, -49],
        [-56, -24]
      ],
      [
        [5399, 13802],
        [-29, 53]
      ],
      [
        [5370, 13855],
        [-67, 34],
        [20, 118],
        [-95, -16],
        [-5, 75],
        [-61, 9],
        [-3, 77],
        [73, 14],
        [48, 178]
      ],
      [
        [10431, 14392],
        [-89, -36],
        [-5, -40],
        [163, -52]
      ],
      [
        [10500, 14264],
        [13, -81],
        [-59, -33],
        [-20, -87]
      ],
      [
        [10434, 14063],
        [-98, 17],
        [-31, 45]
      ],
      [
        [10305, 14125],
        [-16, 35],
        [-60, 24],
        [-74, -34]
      ],
      [
        [11218, 14539],
        [52, -9],
        [137, 70],
        [65, 11],
        [56, -32],
        [-4, -98],
        [61, -54]
      ],
      [
        [11585, 14427],
        [6, -43],
        [-38, -76]
      ],
      [
        [11553, 14308],
        [-40, 6],
        [-1, -103]
      ],
      [
        [11512, 14211],
        [-131, 57],
        [-28, -58],
        [-56, 26]
      ],
      [
        [11297, 14236],
        [-10, 123],
        [27, 6],
        [-55, 107],
        [-34, -11]
      ],
      [
        [5370, 13855],
        [-114, -21],
        [-61, 20],
        [5, 37],
        [-124, 9],
        [-63, -40],
        [-8, -46],
        [-65, -6],
        [-26, -50],
        [-102, 31]
      ],
      [
        [4812, 13789],
        [-38, 38],
        [-55, -6]
      ],
      [
        [4719, 13821],
        [-8, 68],
        [-38, 57],
        [68, 53],
        [-31, 43],
        [-76, 33],
        [-49, 125],
        [11, 84],
        [25, 44]
      ],
      [
        [11297, 14236],
        [-56, 12]
      ],
      [
        [11239, 14247],
        [-4, -2]
      ],
      [
        [9235, 14289],
        [102, -22],
        [13, -58],
        [99, -9],
        [84, -23]
      ],
      [
        [9533, 14177],
        [0, -76]
      ],
      [
        [9533, 14101],
        [-65, 25],
        [-94, -64],
        [-1, -67]
      ],
      [
        [9373, 13995],
        [-49, -1],
        [-76, 38],
        [-29, -28],
        [-64, 39],
        [-34, -10]
      ],
      [
        [9121, 14033],
        [1, 66],
        [-129, 98],
        [19, 76],
        [44, 23],
        [-6, 64]
      ],
      [
        [4048, 14317],
        [9, -87],
        [-35, -31],
        [76, -69],
        [-122, -116],
        [-35, -52],
        [-13, -76]
      ],
      [
        [3928, 13886],
        [-35, -19]
      ],
      [
        [3893, 13867],
        [-38, 26],
        [-58, -91],
        [1, -41]
      ],
      [
        [3798, 13761],
        [-29, -25],
        [-80, -187],
        [-86, -78],
        [-11, -67],
        [-69, -65]
      ],
      [
        [3523, 13339],
        [-52, -12],
        [-42, -56],
        [-9, -76],
        [-79, -88],
        [-41, -27]
      ],
      [
        [3300, 13080],
        [1, 71],
        [-102, 55],
        [3, 29],
        [73, 57],
        [19, 42],
        [-90, 2],
        [-33, 31],
        [-9, 72]
      ],
      [
        [3162, 13439],
        [24, 68],
        [78, 96],
        [-25, 65],
        [-77, 58],
        [-30, 73],
        [-73, 49]
      ],
      [
        [10963, 14180],
        [21, -33]
      ],
      [
        [10984, 14147],
        [-86, -4]
      ],
      [
        [10898, 14143],
        [-73, 65],
        [-190, 51],
        [-63, -43],
        [-72, 48]
      ],
      [
        [9830, 14271],
        [-15, -74],
        [-30, -3],
        [-84, 95],
        [-35, -20],
        [3, -100],
        [-42, -42],
        [-94, 50]
      ],
      [
        [8661, 14386],
        [41, -166],
        [-33, -27],
        [11, -65],
        [-23, -103],
        [-21, -21],
        [91, -61]
      ],
      [
        [8727, 13943],
        [-74, -47],
        [4, -43]
      ],
      [
        [8657, 13853],
        [-78, 40],
        [-2, 54],
        [-100, 44],
        [-32, 54],
        [-91, -14],
        [-132, 49]
      ],
      [
        [7727, 14056],
        [25, -48],
        [-58, -64],
        [3, -39],
        [-56, -14],
        [-24, 33],
        [-90, -8],
        [-39, -55],
        [-35, 26],
        [-65, -50]
      ],
      [
        [7388, 13837],
        [-48, -16],
        [-74, 16],
        [-113, 58],
        [-66, 61]
      ],
      [
        [10049, 14191],
        [-38, -78],
        [6, -42],
        [-65, -45],
        [-15, -75],
        [34, -92]
      ],
      [
        [9971, 13859],
        [-85, -44],
        [-20, -59],
        [-79, -18]
      ],
      [
        [9787, 13738],
        [-55, 20],
        [-55, 69],
        [-48, -4],
        [-46, 49],
        [12, 43],
        [-62, 186]
      ],
      [
        [6884, 14105],
        [-28, -110],
        [-67, -32],
        [-6, -38],
        [-93, -56],
        [-23, -34]
      ],
      [
        [6667, 13835],
        [-53, -35],
        [-105, -21],
        [-90, 33],
        [-144, 107]
      ],
      [
        [6240, 13917],
        [-79, -35],
        [-64, 30],
        [-10, -58],
        [-52, -16],
        [-34, -51],
        [15, -135],
        [-79, -17],
        [-63, -127]
      ],
      [
        [5874, 13508],
        [-90, -38],
        [-58, 35],
        [-62, -9],
        [-60, 21],
        [-50, 43]
      ],
      [
        [5554, 13560],
        [-51, 87],
        [-8, 104],
        [28, 122]
      ],
      [
        [10305, 14125],
        [-42, -56],
        [-74, -25],
        [-3, -45],
        [73, -25],
        [6, -54],
        [-50, -34]
      ],
      [
        [10215, 13886],
        [-49, 32],
        [-195, -59]
      ],
      [
        [8657, 13853],
        [-73, -70],
        [-13, -85],
        [35, -36],
        [-44, -73]
      ],
      [
        [8562, 13589],
        [-3, 31],
        [-111, 41]
      ],
      [
        [8448, 13661],
        [-42, 45],
        [-15, 61],
        [-61, 24],
        [-75, -32],
        [-99, 26],
        [-33, 41],
        [20, 71],
        [-96, 31],
        [-39, -11]
      ],
      [
        [8008, 13917],
        [-72, 20]
      ],
      [
        [10434, 14063],
        [157, -112],
        [38, 10],
        [77, -56]
      ],
      [
        [10706, 13905],
        [100, -66],
        [-16, -43]
      ],
      [
        [10790, 13796],
        [-28, -38],
        [-145, 46],
        [-11, -55]
      ],
      [
        [10606, 13749],
        [-74, 1],
        [-43, 45],
        [-43, -26],
        [4, -43],
        [-98, -57]
      ],
      [
        [10352, 13669],
        [15, 139],
        [-87, 27],
        [-65, 51]
      ],
      [
        [9787, 13738],
        [3, -76]
      ],
      [
        [9790, 13662],
        [-33, 21],
        [-52, -33],
        [-44, 25],
        [-88, -14],
        [-30, -111]
      ],
      [
        [9543, 13550],
        [-48, 0],
        [-68, 34],
        [-48, 56],
        [-74, 11]
      ],
      [
        [9305, 13651],
        [-69, 41],
        [-48, 61]
      ],
      [
        [9188, 13753],
        [24, 25],
        [20, 96],
        [40, 2],
        [49, 45],
        [10, 57],
        [42, 17]
      ],
      [
        [4812, 13789],
        [-19, -72],
        [-47, -63],
        [3, -40],
        [-51, -58],
        [37, -58],
        [68, -43],
        [1, -79],
        [-29, -38],
        [32, -39]
      ],
      [
        [4807, 13299],
        [-65, -22]
      ],
      [
        [4742, 13277],
        [-105, 13]
      ],
      [
        [4637, 13290],
        [8, 39],
        [-159, 36],
        [-33, 27],
        [-75, -18],
        [-54, 38],
        [-64, -46],
        [-69, 30],
        [-80, -1],
        [-81, -84]
      ],
      [
        [4030, 13311],
        [-49, -6],
        [-15, 50],
        [-77, 81],
        [-17, 80],
        [69, 218],
        [-13, 55],
        [58, 12],
        [-9, 79]
      ],
      [
        [3977, 13880],
        [7, 4]
      ],
      [
        [3984, 13884],
        [22, -7]
      ],
      [
        [4006, 13877],
        [38, 29]
      ],
      [
        [4044, 13906],
        [68, 58]
      ],
      [
        [4112, 13964],
        [27, -24],
        [122, -19],
        [60, 12],
        [60, -34],
        [66, 6],
        [76, -17],
        [13, -53],
        [46, -65],
        [34, 20],
        [60, -28],
        [43, 59]
      ],
      [
        [11961, 13786],
        [-64, -59]
      ],
      [
        [11897, 13727],
        [-73, 20],
        [-3, 35],
        [-61, 23],
        [-56, -46],
        [-101, -27],
        [-71, -87]
      ],
      [
        [11532, 13645],
        [-55, -46],
        [-70, 16],
        [-11, 40]
      ],
      [
        [11396, 13655],
        [28, 109],
        [27, 16],
        [-1, 105],
        [23, 45]
      ],
      [
        [11473, 13930],
        [-8, 28],
        [52, 97]
      ],
      [
        [11517, 14055],
        [5, -30],
        [97, -14],
        [14, -24],
        [133, -71],
        [96, -12],
        [-10, -76],
        [109, -42]
      ],
      [
        [3162, 13439],
        [-69, 31],
        [-119, -195],
        [-111, -106],
        [8, -81],
        [-77, 5],
        [-40, -67],
        [15, -30]
      ],
      [
        [2769, 12996],
        [-111, -8],
        [-70, 66],
        [-91, -29],
        [-83, 3],
        [-89, -27],
        [-31, 27],
        [-85, 2],
        [-66, -39],
        [-59, -7]
      ],
      [
        [2084, 12984],
        [-65, 25]
      ],
      [
        [5399, 13802],
        [-38, -31],
        [-8, -111],
        [-53, -43],
        [-32, -92],
        [-144, -53],
        [-139, -81],
        [13, -47],
        [-68, -70],
        [-39, 25],
        [-28, -25]
      ],
      [
        [4863, 13274],
        [-56, 25]
      ],
      [
        [13057, 13615],
        [-70, 40],
        [-61, -30],
        [-65, -59],
        [11, -55],
        [41, -31],
        [-19, -41],
        [-36, 17],
        [-34, -5]
      ],
      [
        [12824, 13451],
        [-12, 39],
        [-92, 14]
      ],
      [
        [12720, 13504],
        [-121, 57],
        [-90, -24],
        [-8, 58]
      ],
      [
        [12501, 13595],
        [34, 77],
        [-18, 98],
        [113, -16],
        [154, 6],
        [23, 47],
        [95, 29],
        [-2, 75]
      ],
      [
        [12900, 13911],
        [43, -18],
        [49, -102],
        [54, -18],
        [-19, -76],
        [30, -82]
      ],
      [
        [7388, 13837],
        [-28, -105],
        [25, -91]
      ],
      [
        [7385, 13641],
        [-74, -142]
      ],
      [
        [7311, 13499],
        [-11, -37]
      ],
      [
        [7300, 13462],
        [10, -22]
      ],
      [
        [7310, 13440],
        [9, -43]
      ],
      [
        [7319, 13397],
        [8, -3]
      ],
      [
        [7327, 13394],
        [12, -22]
      ],
      [
        [7339, 13372],
        [-51, -26],
        [-75, -3],
        [-44, 82],
        [-87, -11],
        [-33, -36]
      ],
      [
        [7049, 13378],
        [-6, 21],
        [59, 115],
        [-53, 30],
        [41, 77],
        [-38, 17],
        [-100, -42],
        [28, -76],
        [-75, 22],
        [-96, -78],
        [30, -46]
      ],
      [
        [6839, 13418],
        [-73, -66]
      ],
      [
        [6766, 13352],
        [-37, 61]
      ],
      [
        [6729, 13413],
        [-30, 89],
        [-3, 64]
      ],
      [
        [6696, 13566],
        [0, 12]
      ],
      [
        [6696, 13578],
        [10, 14]
      ],
      [
        [6706, 13592],
        [26, -6]
      ],
      [
        [6732, 13586],
        [14, 24]
      ],
      [
        [6746, 13610],
        [2, 40]
      ],
      [
        [6748, 13650],
        [21, 29]
      ],
      [
        [6769, 13679],
        [135, -9],
        [39, 33],
        [61, 11],
        [-31, 73],
        [80, 140]
      ],
      [
        [6667, 13835],
        [-31, -47],
        [84, -46],
        [49, -63]
      ],
      [
        [6748, 13650],
        [-2, -40]
      ],
      [
        [6732, 13586],
        [-26, 6]
      ],
      [
        [6696, 13578],
        [0, -12]
      ],
      [
        [6729, 13413],
        [-33, 12],
        [-31, -68],
        [53, -22]
      ],
      [
        [6718, 13335],
        [-24, -10]
      ],
      [
        [6694, 13325],
        [-1, -12]
      ],
      [
        [6693, 13313],
        [7, -41],
        [-114, -99],
        [12, -25]
      ],
      [
        [6598, 13148],
        [-51, -4],
        [-92, 35],
        [30, 52],
        [-122, 33],
        [-60, -105],
        [-41, 5],
        [-53, 46],
        [-20, -40]
      ],
      [
        [6189, 13170],
        [-56, 3],
        [-18, 38],
        [-53, -2],
        [-38, 113]
      ],
      [
        [6024, 13322],
        [53, 28],
        [12, 76],
        [-29, 136],
        [-35, 15],
        [-52, -38],
        [-7, -44],
        [-92, 13]
      ],
      [
        [5554, 13560],
        [-27, 10],
        [-150, -29],
        [-25, -96],
        [-58, -91],
        [69, -120],
        [60, 18],
        [50, -38],
        [-19, -74]
      ],
      [
        [5454, 13140],
        [-54, 29],
        [-192, -93],
        [6, -124],
        [-100, -21]
      ],
      [
        [5114, 12931],
        [-63, 90],
        [-26, 69]
      ],
      [
        [5025, 13090],
        [18, 79],
        [-41, 11],
        [-108, 101],
        [-31, -7]
      ],
      [
        [8448, 13661],
        [4, -30],
        [-93, -66],
        [-30, -47],
        [-95, -59],
        [15, -148]
      ],
      [
        [8249, 13311],
        [-80, 18],
        [-60, -36],
        [-15, -47]
      ],
      [
        [8094, 13246],
        [-50, 68],
        [-39, -41],
        [-51, 8]
      ],
      [
        [7954, 13281],
        [18, 25]
      ],
      [
        [7972, 13306],
        [40, 47]
      ],
      [
        [8012, 13353],
        [51, 37],
        [-17, 50],
        [-61, 31],
        [3, 75],
        [-62, 6],
        [-76, -34]
      ],
      [
        [7850, 13518],
        [25, 79],
        [47, 41]
      ],
      [
        [7922, 13638],
        [42, 81],
        [27, 91],
        [-58, 34],
        [75, 73]
      ],
      [
        [10352, 13669],
        [-55, -90],
        [-44, -26]
      ],
      [
        [10253, 13553],
        [-25, 9],
        [-60, -52],
        [-73, -22]
      ],
      [
        [10095, 13488],
        [-4, 61],
        [-83, 73],
        [-45, -22],
        [-60, 44],
        [-46, 2]
      ],
      [
        [9857, 13646],
        [-67, 16]
      ],
      [
        [8657, 13853],
        [35, -28],
        [-12, -56],
        [62, -55],
        [93, -16]
      ],
      [
        [8835, 13698],
        [39, -67],
        [-27, -113],
        [-52, -42]
      ],
      [
        [8795, 13476],
        [-62, -25],
        [-35, 43],
        [-163, 57],
        [27, 38]
      ],
      [
        [11961, 13786],
        [14, 8]
      ],
      [
        [11975, 13794],
        [53, -80],
        [68, 1],
        [83, 30],
        [48, -20]
      ],
      [
        [12227, 13725],
        [27, -13],
        [-11, -125]
      ],
      [
        [12243, 13587],
        [23, -59],
        [-86, -80]
      ],
      [
        [12180, 13448],
        [-52, 14],
        [-4, 85],
        [-65, 74],
        [-20, -50]
      ],
      [
        [12039, 13571],
        [-56, 56],
        [-47, -18],
        [-46, 49],
        [7, 69]
      ],
      [
        [10790, 13796],
        [21, -18],
        [141, -6]
      ],
      [
        [10952, 13772],
        [-19, -86],
        [-42, -58],
        [16, -39],
        [-47, -101]
      ],
      [
        [10860, 13488],
        [-51, -52],
        [-70, -22],
        [-39, -34]
      ],
      [
        [10700, 13380],
        [-93, 38],
        [1, 79],
        [-31, 27]
      ],
      [
        [10577, 13524],
        [59, 82],
        [-24, 35],
        [13, 87],
        [-19, 21]
      ],
      [
        [9305, 13651],
        [-20, -168],
        [-50, -18],
        [-16, -39],
        [46, -30]
      ],
      [
        [9265, 13396],
        [37, -81],
        [-65, -103],
        [-49, -25],
        [-37, -57]
      ],
      [
        [9151, 13130],
        [-99, 21],
        [-33, 104],
        [-65, 11],
        [-82, 42],
        [-27, 72],
        [-56, 20]
      ],
      [
        [8789, 13400],
        [6, 76]
      ],
      [
        [8835, 13698],
        [92, 52],
        [30, 59],
        [58, -28],
        [89, 23],
        [27, -64],
        [57, 13]
      ],
      [
        [10577, 13524],
        [-149, 12],
        [-8, -78],
        [-90, 16]
      ],
      [
        [10330, 13474],
        [-77, 79]
      ],
      [
        [13305, 13696],
        [131, -85],
        [108, 33],
        [18, -116],
        [97, -66],
        [-51, -68],
        [-68, -7],
        [-47, 21],
        [-195, 1]
      ],
      [
        [13298, 13409],
        [9, 78],
        [-118, -3]
      ],
      [
        [13189, 13484],
        [-59, 30],
        [-8, 59],
        [126, 102],
        [57, 21]
      ],
      [
        [13057, 13615],
        [27, -114],
        [27, -40],
        [78, 23]
      ],
      [
        [13298, 13409],
        [11, -88],
        [-38, -80],
        [-76, -58],
        [-34, 51],
        [-56, -33],
        [22, -39],
        [-69, -66],
        [-27, -58]
      ],
      [
        [13031, 13038],
        [-89, 120]
      ],
      [
        [12942, 13158],
        [45, 48],
        [-4, 38],
        [-104, 83],
        [-10, 41],
        [-1, 77],
        [-44, 6]
      ],
      [
        [7339, 13372],
        [14, -179],
        [-26, -77],
        [-1, -80],
        [-56, -18],
        [-15, -36],
        [-68, 14],
        [-44, -63],
        [-25, -76]
      ],
      [
        [7118, 12857],
        [-46, 13],
        [25, 64],
        [-46, 68],
        [-86, -30],
        [19, 77],
        [-7, 112],
        [-61, 28],
        [-29, 43],
        [5, 83]
      ],
      [
        [6892, 13315],
        [134, 19],
        [23, 44]
      ],
      [
        [9857, 13646],
        [-32, -55],
        [41, -25],
        [-30, -69],
        [-79, -5],
        [6, -52]
      ],
      [
        [9763, 13440],
        [-16, -27],
        [-145, -2],
        [-5, 49],
        [-71, -11]
      ],
      [
        [9526, 13449],
        [24, 49],
        [-7, 52]
      ],
      [
        [11553, 14308],
        [35, -20],
        [-3, -84],
        [43, -14],
        [63, 36],
        [23, -56],
        [63, -39],
        [26, 31],
        [118, -58],
        [0, -47],
        [38, -42]
      ],
      [
        [11959, 14015],
        [4, -42],
        [-51, -84],
        [64, -48],
        [-1, -47]
      ],
      [
        [11517, 14055],
        [10, 27],
        [-15, 129]
      ],
      [
        [11959, 14015],
        [32, 28]
      ],
      [
        [11991, 14043],
        [62, -59],
        [74, 20]
      ],
      [
        [12127, 14004],
        [44, -111],
        [86, 4],
        [18, -108],
        [-48, -64]
      ],
      [
        [3300, 13080],
        [-3, -50],
        [-92, -145]
      ],
      [
        [3205, 12885],
        [-28, -87]
      ],
      [
        [3177, 12798],
        [-151, 5],
        [-29, 70],
        [-107, 27],
        [-13, -61],
        [-96, 107],
        [-12, 50]
      ],
      [
        [8789, 13400],
        [-27, -29],
        [-70, -12],
        [-75, 25],
        [-9, -82],
        [-68, -102],
        [-26, -7]
      ],
      [
        [8514, 13193],
        [-56, 36],
        [-58, 10],
        [-56, -28],
        [-19, 76],
        [31, 24],
        [-22, 88],
        [-79, -50],
        [-6, -38]
      ],
      [
        [10095, 13488],
        [-123, -91],
        [1, -127],
        [29, -166]
      ],
      [
        [10002, 13104],
        [-69, -44],
        [-68, -1],
        [-65, 45],
        [-17, 128]
      ],
      [
        [9783, 13232],
        [1, 77],
        [46, -2],
        [17, 94],
        [-84, 39]
      ],
      [
        [9526, 13449],
        [-98, -17],
        [-140, 27],
        [-23, -63]
      ],
      [
        [6024, 13322],
        [-28, 25],
        [-62, -3],
        [-58, -41],
        [-56, 15],
        [-81, -25],
        [-10, -58],
        [58, -67],
        [-95, -45],
        [33, -46],
        [60, 11],
        [57, -37],
        [23, -110],
        [-60, -70],
        [-76, 64],
        [-29, -11],
        [18, -71]
      ],
      [
        [5718, 12853],
        [-55, 8],
        [-100, -17],
        [-47, 63],
        [-4, 109],
        [-35, -1],
        [-23, 125]
      ],
      [
        [12942, 13158],
        [-34, -80]
      ],
      [
        [12908, 13078],
        [-83, -3],
        [-133, 42]
      ],
      [
        [12692, 13117],
        [-36, 102],
        [44, 88],
        [-32, 33],
        [4, 65]
      ],
      [
        [12672, 13405],
        [48, 99]
      ],
      [
        [10330, 13474],
        [-40, -34],
        [-20, -95],
        [20, -54],
        [-16, -57],
        [-63, -90],
        [46, -56],
        [-36, -64],
        [7, -74],
        [-29, -21],
        [-113, 7]
      ],
      [
        [10086, 12936],
        [4, 68],
        [-27, 67],
        [-61, 33]
      ],
      [
        [10700, 13380],
        [-10, -24]
      ],
      [
        [10690, 13356],
        [-16, -34],
        [-77, -51],
        [-144, -175],
        [-50, -93]
      ],
      [
        [10403, 13003],
        [-47, -68],
        [-42, -12]
      ],
      [
        [10314, 12923],
        [-101, -21],
        [-141, 16]
      ],
      [
        [10072, 12918],
        [14, 18]
      ],
      [
        [3523, 13339],
        [-10, -57],
        [89, -113],
        [52, -6],
        [-11, -67],
        [68, 7],
        [32, 39],
        [111, 64],
        [49, -36],
        [48, 7]
      ],
      [
        [3951, 13177],
        [-25, -107],
        [43, -17],
        [66, -98],
        [-9, -67],
        [34, -16],
        [38, -130],
        [41, -19]
      ],
      [
        [4139, 12723],
        [-48, -66],
        [-77, 29],
        [-11, -78],
        [32, -109]
      ],
      [
        [4035, 12499],
        [-34, -31],
        [-43, 76],
        [-53, -33],
        [-102, 14],
        [-51, -37],
        [-109, 4],
        [-58, 17],
        [-45, -24],
        [-33, -66],
        [-62, -18]
      ],
      [
        [3445, 12401],
        [6, 65]
      ],
      [
        [3451, 12466],
        [25, 15],
        [-7, 85],
        [-58, 9],
        [-48, -38],
        [-19, 55],
        [-58, 35],
        [-38, 50],
        [55, 117],
        [-49, 30],
        [7, 74],
        [-56, -13]
      ],
      [
        [12692, 13117],
        [-32, -5],
        [9, -105],
        [-35, -97]
      ],
      [
        [12634, 12910],
        [-28, -7],
        [-46, 68],
        [-41, -9],
        [-80, 35],
        [-46, -5]
      ],
      [
        [12393, 12992],
        [38, 163],
        [31, 22],
        [-8, 100],
        [20, 28]
      ],
      [
        [12474, 13305],
        [78, 23],
        [21, 98],
        [99, -21]
      ],
      [
        [9783, 13232],
        [-70, -88],
        [-96, 11],
        [-97, -51],
        [-74, 17],
        [-14, -93]
      ],
      [
        [9432, 13028],
        [-69, -18],
        [0, -42],
        [-79, 9]
      ],
      [
        [9284, 12977],
        [-53, 136],
        [-80, 17]
      ],
      [
        [6839, 13418],
        [53, -103]
      ],
      [
        [7118, 12857],
        [4, -18]
      ],
      [
        [7122, 12839],
        [-13, -50],
        [-108, -123],
        [-68, 35],
        [-76, 92],
        [-55, 27],
        [-74, -93],
        [-39, 47],
        [26, 34],
        [-66, 55]
      ],
      [
        [6649, 12863],
        [5, 155],
        [-56, 130]
      ],
      [
        [6693, 13313],
        [1, 12]
      ],
      [
        [6718, 13335],
        [48, 17]
      ],
      [
        [12035, 13251],
        [35, -205],
        [35, -68]
      ],
      [
        [12105, 12978],
        [-73, -71],
        [-31, -100]
      ],
      [
        [12001, 12807],
        [-67, 54],
        [-48, 14],
        [16, 69],
        [-110, 31],
        [-3, 69],
        [-48, 59]
      ],
      [
        [11741, 13103],
        [-53, 64],
        [-53, 5],
        [-38, 82]
      ],
      [
        [11597, 13254],
        [92, 7]
      ],
      [
        [11689, 13261],
        [94, -17],
        [60, 32],
        [105, 92]
      ],
      [
        [11948, 13368],
        [9, -63],
        [78, -54]
      ],
      [
        [4742, 13277],
        [-10, -48],
        [-100, -149],
        [178, -49],
        [61, 16]
      ],
      [
        [4871, 13047],
        [21, -44],
        [6, -89],
        [-105, -119],
        [-42, -30],
        [-105, -5],
        [-118, 45],
        [-76, -115]
      ],
      [
        [4452, 12690],
        [-27, 23],
        [-74, -1],
        [18, 70],
        [48, 62],
        [-26, 33],
        [-77, 10]
      ],
      [
        [4314, 12887],
        [58, 75],
        [-9, 55],
        [21, 54],
        [55, -74],
        [68, 43],
        [-10, 52],
        [-76, 25],
        [-23, 73],
        [50, 22],
        [37, -52],
        [52, -9],
        [51, 23],
        [-2, 65],
        [51, 51]
      ],
      [
        [12393, 12992],
        [-65, 3],
        [-26, -61]
      ],
      [
        [12302, 12934],
        [-104, 51],
        [-66, -34],
        [-27, 27]
      ],
      [
        [12035, 13251],
        [52, -26],
        [44, 25],
        [27, 97]
      ],
      [
        [12158, 13347],
        [79, -17],
        [131, 13],
        [106, -38]
      ],
      [
        [9284, 12977],
        [4, -9]
      ],
      [
        [9288, 12968],
        [-79, 6],
        [-207, -57],
        [-49, 4],
        [-188, -77],
        [-130, -74]
      ],
      [
        [8635, 12770],
        [-9, 54],
        [-88, 74],
        [0, 152],
        [-43, 49],
        [19, 94]
      ],
      [
        [8635, 12770],
        [55, -41]
      ],
      [
        [8690, 12729],
        [-27, -57],
        [-43, 2],
        [-63, -58],
        [-34, 18],
        [-86, -39]
      ],
      [
        [8437, 12595],
        [-29, -12]
      ],
      [
        [8408, 12583],
        [-58, 10],
        [-68, -63],
        [-18, 101],
        [-120, -60],
        [-56, -42],
        [-72, -16]
      ],
      [
        [8016, 12513],
        [179, 150],
        [-49, 67],
        [-63, 124],
        [6, 128],
        [-61, 49],
        [39, 48],
        [109, 61],
        [-18, 51],
        [-53, 8],
        [-11, 47]
      ],
      [
        [6189, 13170],
        [-29, -33],
        [24, -47],
        [-49, -94],
        [10, -116],
        [-14, -27],
        [81, -44],
        [34, -45]
      ],
      [
        [6246, 12764],
        [-64, -49],
        [-70, -6],
        [-82, 36],
        [16, -77],
        [-56, -83],
        [34, -44],
        [4, -85]
      ],
      [
        [6028, 12456],
        [-60, 0]
      ],
      [
        [5968, 12456],
        [-40, 41],
        [11, 96],
        [-103, 3],
        [-35, -28],
        [-59, 63]
      ],
      [
        [5742, 12631],
        [27, 59],
        [-39, 44],
        [-20, 62],
        [8, 57]
      ],
      [
        [11741, 13103],
        [-80, -30],
        [-20, 20]
      ],
      [
        [11641, 13093],
        [-107, 39],
        [-47, -115],
        [7, -51],
        [-88, -43],
        [-110, 16]
      ],
      [
        [11296, 12939],
        [-46, 57],
        [17, 58],
        [-35, 49],
        [73, 133]
      ],
      [
        [11305, 13236],
        [104, 51],
        [57, 47]
      ],
      [
        [11466, 13334],
        [86, -14],
        [2, -51],
        [43, -15]
      ],
      [
        [11296, 12939],
        [-28, -32]
      ],
      [
        [11268, 12907],
        [-28, 9],
        [-131, -111]
      ],
      [
        [11109, 12805],
        [-39, 33],
        [-82, -31],
        [-10, 66],
        [-56, 49],
        [-142, -95],
        [-58, -82]
      ],
      [
        [10722, 12745],
        [-24, 36],
        [-77, 41],
        [-10, 70]
      ],
      [
        [10611, 12892],
        [43, 56],
        [60, -39],
        [41, 10],
        [36, 94],
        [79, 32],
        [8, 47],
        [-62, 80],
        [50, 36],
        [11, 95]
      ],
      [
        [10877, 13303],
        [80, 5]
      ],
      [
        [10957, 13308],
        [35, 3],
        [118, -53],
        [24, 44],
        [49, 4]
      ],
      [
        [11183, 13306],
        [97, -28],
        [25, -42]
      ],
      [
        [6649, 12863],
        [-68, -39],
        [-47, -55],
        [-6, -45]
      ],
      [
        [6528, 12724],
        [-45, -16],
        [-150, 57],
        [-87, -1]
      ],
      [
        [3177, 12798],
        [45, -63],
        [-46, -84],
        [-22, -86],
        [-37, -11]
      ],
      [
        [3117, 12554],
        [-55, 56],
        [-85, -13],
        [-1, -66],
        [-44, -42],
        [-64, 0]
      ],
      [
        [2868, 12489],
        [-76, 26],
        [-20, 48],
        [-74, 25],
        [-13, 31],
        [-160, -90],
        [-66, -105],
        [-96, 17],
        [-17, 73],
        [-191, -3],
        [-50, 13]
      ],
      [
        [2105, 12524],
        [-16, 231],
        [52, 24],
        [-36, 49],
        [19, 84],
        [-58, 12],
        [18, 60]
      ],
      [
        [5742, 12631],
        [-52, -10],
        [-82, 54],
        [-21, 57],
        [-48, -44],
        [-43, -4],
        [-120, 30],
        [-71, -26]
      ],
      [
        [5305, 12688],
        [-62, -11],
        [6, -77],
        [-56, -16],
        [-68, -123],
        [-94, -22],
        [-68, -87]
      ],
      [
        [4963, 12352],
        [-70, 35],
        [-12, 44],
        [-67, 45]
      ],
      [
        [4814, 12476],
        [39, 78],
        [118, -43],
        [88, 66],
        [-56, 63],
        [41, 74],
        [-56, 110],
        [38, 41],
        [75, -7],
        [13, 73]
      ],
      [
        [13031, 13038],
        [69, -131],
        [132, -49],
        [31, -34],
        [116, -64],
        [81, 12],
        [38, -51],
        [3, -78],
        [-30, -37]
      ],
      [
        [13471, 12606],
        [-45, -48],
        [-78, -28],
        [-68, -125],
        [-111, -13],
        [-40, -30]
      ],
      [
        [13129, 12362],
        [-76, -28],
        [-34, 89],
        [-28, -26]
      ],
      [
        [12991, 12397],
        [-49, 22],
        [-31, 51],
        [11, 84],
        [24, 14],
        [1, 86],
        [56, 20],
        [21, 88],
        [-39, 22],
        [14, 55],
        [-20, 73],
        [-38, 35]
      ],
      [
        [12941, 12947],
        [12, 114],
        [-45, 17]
      ],
      [
        [10072, 12918],
        [-67, -20],
        [-13, -134],
        [19, -34],
        [-52, -120]
      ],
      [
        [9959, 12610],
        [-80, -131],
        [-76, -37],
        [-94, 0],
        [-88, 66]
      ],
      [
        [9621, 12508],
        [-97, 121],
        [52, 27],
        [17, 149],
        [-37, 7],
        [20, 85],
        [35, 58],
        [-16, 48],
        [-43, -4],
        [-24, 44],
        [-96, -15]
      ],
      [
        [12941, 12947],
        [-63, 13],
        [5, -146],
        [-62, -89],
        [-44, -4]
      ],
      [
        [12777, 12721],
        [-37, 2],
        [-12, 194],
        [-94, -7]
      ],
      [
        [4814, 12476],
        [-83, -56],
        [-52, -13],
        [-133, 2],
        [-73, -44]
      ],
      [
        [4473, 12365],
        [-25, 79],
        [47, 121],
        [-62, 97],
        [19, 28]
      ],
      [
        [4871, 13047],
        [39, -15],
        [115, 58]
      ],
      [
        [12180, 13448],
        [-22, -101]
      ],
      [
        [11948, 13368],
        [-12, 113],
        [-59, -14]
      ],
      [
        [11877, 13467],
        [162, 104]
      ],
      [
        [12001, 12807],
        [41, -109],
        [-20, -51],
        [56, -8]
      ],
      [
        [12078, 12639],
        [-58, -87]
      ],
      [
        [12020, 12552],
        [-67, 27],
        [-56, -104],
        [-46, 18],
        [-74, -39]
      ],
      [
        [11777, 12454],
        [-25, 25],
        [-68, -20],
        [-35, 40]
      ],
      [
        [11649, 12499],
        [-51, 89],
        [-82, 22],
        [-19, 54],
        [108, 31],
        [2, 40]
      ],
      [
        [11607, 12735],
        [12, 184],
        [-62, 61],
        [29, 82],
        [55, 31]
      ],
      [
        [12777, 12721],
        [-5, -66],
        [-125, -132],
        [-68, 38],
        [-67, -7]
      ],
      [
        [12512, 12554],
        [-64, 9],
        [-26, 51],
        [-56, 28],
        [-24, -27]
      ],
      [
        [12342, 12615],
        [-26, 20],
        [73, 63],
        [-16, 61],
        [-39, 5],
        [-48, 97],
        [16, 73]
      ],
      [
        [9621, 12508],
        [-78, -31]
      ],
      [
        [9543, 12477],
        [-38, -59],
        [-90, -39]
      ],
      [
        [9415, 12379],
        [-155, 27],
        [-34, 23]
      ],
      [
        [9226, 12429],
        [-5, 70],
        [-52, 34],
        [-100, 12],
        [-59, 83],
        [40, 80],
        [40, -1],
        [108, 89],
        [81, 105],
        [9, 67]
      ],
      [
        [12991, 12397],
        [-37, -66],
        [32, -64],
        [-19, -44],
        [-55, -14],
        [-90, 50],
        [-114, -8]
      ],
      [
        [12708, 12251],
        [-57, 4],
        [-24, 53],
        [-95, 45],
        [-72, 0],
        [-45, 46]
      ],
      [
        [12415, 12399],
        [29, 30],
        [68, 2],
        [40, 33],
        [-40, 90]
      ],
      [
        [12342, 12615],
        [-13, -49],
        [-179, 64],
        [-72, 9]
      ],
      [
        [10403, 13003],
        [55, -79],
        [107, -5],
        [46, -27]
      ],
      [
        [10722, 12745],
        [-32, -35],
        [88, -71],
        [-18, -97],
        [16, -15]
      ],
      [
        [10776, 12527],
        [-8, -44],
        [-64, 22],
        [-88, -35],
        [-129, -4],
        [-77, -74]
      ],
      [
        [10410, 12392],
        [-54, 48],
        [-47, 146],
        [81, 27],
        [-112, 133],
        [36, 177]
      ],
      [
        [9226, 12429],
        [-83, -27],
        [-49, 33],
        [-56, 7],
        [-73, -46],
        [-55, 23],
        [-38, 62],
        [-42, -29]
      ],
      [
        [8830, 12452],
        [-39, 21],
        [-5, 111],
        [-43, 79],
        [8, 41],
        [-61, 25]
      ],
      [
        [11109, 12805],
        [8, -30],
        [82, 11],
        [63, -25],
        [-33, -68],
        [-73, 10],
        [6, -95],
        [52, -47],
        [-31, -57],
        [-116, 26],
        [-2, -80],
        [21, -124]
      ],
      [
        [11086, 12326],
        [-55, 3]
      ],
      [
        [11031, 12329],
        [-20, 13],
        [9, 104],
        [-12, 47],
        [-172, 42],
        [-60, -8]
      ],
      [
        [10410, 12392],
        [-2, -122]
      ],
      [
        [10408, 12270],
        [-51, -48],
        [-107, 30],
        [-45, 153],
        [-88, 31],
        [-37, 86],
        [-54, 76],
        [-67, 12]
      ],
      [
        [7122, 12839],
        [54, -7],
        [70, 19],
        [48, -16],
        [-14, -56],
        [-89, -67],
        [-28, -52],
        [59, -50]
      ],
      [
        [7222, 12610],
        [28, -67],
        [-61, -66],
        [37, -52],
        [56, -21],
        [43, -103],
        [-9, -144],
        [-70, -39],
        [33, -98],
        [-27, -49]
      ],
      [
        [7252, 11971],
        [-64, -21],
        [-185, 30]
      ],
      [
        [7003, 11980],
        [-66, 86],
        [-51, 5],
        [-1, 66],
        [71, 58],
        [-156, 39],
        [5, 37],
        [-51, 61],
        [-42, -52],
        [-47, 20]
      ],
      [
        [6665, 12300],
        [-27, 59],
        [28, 111],
        [-10, 86],
        [-62, -13],
        [-44, 26],
        [12, 55],
        [-34, 100]
      ],
      [
        [2868, 12489],
        [-69, -50],
        [-34, 10],
        [-12, -150],
        [-13, -40],
        [-70, 16],
        [-73, -42],
        [-38, 33],
        [-29, -75]
      ],
      [
        [2530, 12191],
        [-70, -40],
        [-59, -2],
        [-110, 21],
        [-46, -13]
      ],
      [
        [2245, 12157],
        [-56, 41],
        [-47, 83],
        [-101, 5],
        [-3, 53],
        [-89, -95],
        [-11, 174],
        [24, 47],
        [143, 59]
      ],
      [
        [7222, 12610],
        [102, 57],
        [54, 11],
        [20, 113],
        [100, 56],
        [46, -33],
        [104, -6]
      ],
      [
        [7648, 12808],
        [41, -55],
        [-60, -187],
        [51, -14],
        [-8, -58],
        [21, -83]
      ],
      [
        [7693, 12411],
        [-24, -97],
        [71, -10],
        [-5, -61]
      ],
      [
        [7735, 12243],
        [-92, -110],
        [-42, -15],
        [-32, -64],
        [-104, -50],
        [-94, -75]
      ],
      [
        [7371, 11929],
        [-43, 48],
        [-76, -6]
      ],
      [
        [5852, 12148],
        [-22, -16],
        [-24, -97],
        [-51, -61],
        [-30, -87],
        [-53, 46],
        [-152, -30]
      ],
      [
        [5520, 11903],
        [-19, 36],
        [-97, 39],
        [-131, -6],
        [-28, 14]
      ],
      [
        [5245, 11986],
        [40, 18],
        [20, 84],
        [0, 76],
        [-38, 59]
      ],
      [
        [5267, 12223],
        [121, 43],
        [62, 3]
      ],
      [
        [5450, 12269],
        [13, -65],
        [47, 23],
        [89, -32],
        [20, -33],
        [76, -3],
        [70, 23],
        [87, -34]
      ],
      [
        [6665, 12300],
        [-46, -108],
        [-57, -7],
        [-33, -49],
        [-55, 12],
        [-124, -8],
        [-68, 79],
        [-54, -72],
        [-70, 30]
      ],
      [
        [6158, 12177],
        [-7, 45],
        [92, 105],
        [-48, 39],
        [-65, -7],
        [-39, 31],
        [-25, 61],
        [-38, 5]
      ],
      [
        [3117, 12554],
        [-32, -56],
        [-19, -84],
        [30, -117],
        [-2, -92],
        [-22, -32]
      ],
      [
        [3072, 12173],
        [-114, 40],
        [-78, -125],
        [11, -25],
        [-71, -50],
        [10, -100],
        [-60, -27]
      ],
      [
        [2770, 11886],
        [-35, -19],
        [-62, 46],
        [-9, 94],
        [50, 43],
        [31, 60],
        [-70, 1],
        [-25, 26],
        [-66, -6],
        [-41, 33]
      ],
      [
        [2543, 12164],
        [-13, 27]
      ],
      [
        [5968, 12456],
        [-2, -56],
        [-37, -102]
      ],
      [
        [5929, 12298],
        [-47, -133],
        [-30, -17]
      ],
      [
        [5450, 12269],
        [-35, 129],
        [-34, 39],
        [-17, 70],
        [-73, 92],
        [14, 89]
      ],
      [
        [8830, 12452],
        [5, -35],
        [56, -84],
        [-54, -42],
        [-2, -110],
        [96, 27],
        [41, -25],
        [63, 14],
        [45, -87]
      ],
      [
        [9080, 12110],
        [-47, -83],
        [-48, -3],
        [-55, -60],
        [-94, -11],
        [-62, -85],
        [-52, -18],
        [-78, 34],
        [6, 32],
        [-50, 47]
      ],
      [
        [8600, 11963],
        [21, 6],
        [45, 97],
        [-29, 50],
        [-7, 99],
        [-32, 16],
        [0, 103],
        [-45, 54],
        [28, 42],
        [-61, 85],
        [-39, -4],
        [-44, 84]
      ],
      [
        [13471, 12606],
        [28, -45],
        [-7, -90],
        [-82, -36],
        [-28, -108],
        [19, -70],
        [85, -76],
        [26, -48],
        [-35, -156]
      ],
      [
        [13477, 11977],
        [-23, -100],
        [9, -50],
        [-22, -77],
        [-28, -9],
        [-134, 26]
      ],
      [
        [13279, 11767],
        [2, 34],
        [60, 84],
        [-57, 76]
      ],
      [
        [13284, 11961],
        [-58, 77],
        [40, 132],
        [-85, 89],
        [-80, 33],
        [28, 70]
      ],
      [
        [12415, 12399],
        [-111, 51],
        [-75, -35]
      ],
      [
        [12229, 12415],
        [-143, 108],
        [-66, 29]
      ],
      [
        [4035, 12499],
        [69, -33]
      ],
      [
        [4104, 12466],
        [-68, -52],
        [-82, -36],
        [-19, -45],
        [3, -82],
        [-35, -6],
        [-72, -160]
      ],
      [
        [3831, 12085],
        [-44, -33],
        [-40, 66],
        [-49, 21],
        [-84, -4]
      ],
      [
        [3614, 12135],
        [19, 125],
        [-55, 24],
        [-32, -34],
        [-32, 71],
        [-69, 80]
      ],
      [
        [8408, 12583],
        [-73, -72],
        [-1, -43],
        [48, -85],
        [-8, -82],
        [-88, -4],
        [-53, 44],
        [-43, -101],
        [-41, -19],
        [-12, -126]
      ],
      [
        [8137, 12095],
        [-56, -36],
        [-85, -22],
        [-20, 18],
        [-40, 171],
        [-95, 14],
        [-79, -14],
        [-27, 17]
      ],
      [
        [7693, 12411],
        [80, 48],
        [43, 71],
        [61, -40],
        [56, 7],
        [49, -27],
        [34, 43]
      ],
      [
        [12229, 12415],
        [17, -50],
        [-17, -48]
      ],
      [
        [12229, 12317],
        [-58, 0],
        [-148, -46]
      ],
      [
        [12023, 12271],
        [-75, 55],
        [-83, 1],
        [-35, 27],
        [-53, 100]
      ],
      [
        [4104, 12466],
        [68, 15],
        [53, -87],
        [-28, -123],
        [86, 6],
        [64, -22],
        [16, -52]
      ],
      [
        [4363, 12203],
        [-131, -89],
        [-28, -72],
        [134, -73]
      ],
      [
        [4338, 11969],
        [-149, -99],
        [-79, 20],
        [-43, -38]
      ],
      [
        [4067, 11852],
        [-47, 90],
        [-79, -6],
        [8, 66],
        [-103, 52]
      ],
      [
        [3846, 12054],
        [-15, 31]
      ],
      [
        [8600, 11963],
        [-49, 77],
        [-33, -79]
      ],
      [
        [8518, 11961],
        [-38, -11],
        [-96, 65],
        [-37, -37],
        [-91, 20],
        [16, 50],
        [-32, 33],
        [-82, -17]
      ],
      [
        [8158, 12064],
        [-21, 31]
      ],
      [
        [11031, 12329],
        [-30, -34],
        [16, -44],
        [-41, -36]
      ],
      [
        [10976, 12215],
        [-18, -19],
        [-141, 99],
        [-113, -8],
        [-53, -39]
      ],
      [
        [10651, 12248],
        [-46, -17],
        [7, -63],
        [-54, -35],
        [9, -47],
        [-44, -41],
        [-77, 6]
      ],
      [
        [10446, 12051],
        [-73, 38],
        [34, 86],
        [1, 95]
      ],
      [
        [4963, 12352],
        [-45, -64],
        [-65, 5],
        [-33, -98],
        [-49, 51],
        [-76, -9],
        [-53, -39],
        [-23, -99],
        [63, -96],
        [-23, -44],
        [11, -52]
      ],
      [
        [4670, 11907],
        [-3, -36],
        [-84, 21],
        [-67, -4]
      ],
      [
        [4516, 11888],
        [-148, 31],
        [-30, 50]
      ],
      [
        [4363, 12203],
        [49, 7],
        [49, 83],
        [12, 72]
      ],
      [
        [12023, 12271],
        [-79, -76],
        [-36, -87],
        [-87, 42],
        [-12, 65],
        [-50, 5],
        [-28, -49],
        [-101, -11]
      ],
      [
        [11630, 12160],
        [-85, 131],
        [-92, -22],
        [-1, 120],
        [-20, 40],
        [40, 74]
      ],
      [
        [11472, 12503],
        [61, -3],
        [64, -80],
        [52, 79]
      ],
      [
        [11630, 12160],
        [-17, -39]
      ],
      [
        [11613, 12121],
        [-55, 23],
        [-40, -12],
        [-74, 32],
        [-47, 53],
        [-94, -8],
        [-77, 20],
        [-41, 36],
        [17, 41]
      ],
      [
        [11202, 12306],
        [69, 15],
        [57, -15],
        [30, 59],
        [-28, 21],
        [142, 117]
      ],
      [
        [6158, 12177],
        [-18, -66],
        [89, -73],
        [-42, -130],
        [-119, -47]
      ],
      [
        [6068, 11861],
        [-71, 16],
        [-32, 58],
        [-5, 81],
        [-29, 12],
        [77, 90],
        [-7, 127],
        [-72, 53]
      ],
      [
        [13284, 11961],
        [-35, -67],
        [-125, 28],
        [-15, -57],
        [-63, -64],
        [-72, -34],
        [-66, -5],
        [-63, 21],
        [-20, 33]
      ],
      [
        [12825, 11816],
        [34, 47],
        [-78, 88],
        [-58, 85],
        [-70, 65]
      ],
      [
        [12653, 12101],
        [0, 57],
        [55, 93]
      ],
      [
        [9170, 11884],
        [50, 153],
        [-63, 61],
        [-77, 12]
      ],
      [
        [9415, 12379],
        [68, -79],
        [-13, -95],
        [39, -32],
        [6, -85],
        [64, -22],
        [-3, -62],
        [-109, -103],
        [19, -75],
        [-22, -46]
      ],
      [
        [9464, 11780],
        [-77, 4],
        [-46, 24],
        [-82, -45],
        [-28, 5]
      ],
      [
        [4963, 12352],
        [26, 7],
        [99, -145],
        [78, 12],
        [76, -24],
        [25, 21]
      ],
      [
        [5245, 11986],
        [-17, -31],
        [-8, -112],
        [-58, 157],
        [-31, -78],
        [22, -85],
        [-54, -26]
      ],
      [
        [5099, 11811],
        [-15, 26],
        [-133, -18],
        [-30, 49],
        [-39, 3],
        [-60, -73],
        [-22, -86]
      ],
      [
        [4800, 11712],
        [-45, 1],
        [-43, 46],
        [19, 78],
        [-10, 50],
        [-51, 20]
      ],
      [
        [3072, 12173],
        [-3, -54],
        [-39, -17],
        [140, -110],
        [45, 19]
      ],
      [
        [3215, 12011],
        [-23, -41],
        [20, -45]
      ],
      [
        [3212, 11925],
        [-3, -42],
        [-54, -16],
        [-57, -61]
      ],
      [
        [3098, 11806],
        [-47, 72],
        [-66, -1],
        [-37, 25],
        [-82, 11],
        [-22, -61],
        [-74, 34]
      ],
      [
        [2460, 11351],
        [47, 60],
        [-14, 53],
        [79, -14],
        [33, -52],
        [52, 32],
        [-9, 76],
        [-54, 5],
        [-7, 149],
        [-44, 49],
        [17, 141],
        [-63, 6],
        [-8, 81],
        [53, 24],
        [-75, 50],
        [-2, 75],
        [56, 4],
        [22, 74]
      ],
      [
        [3098, 11806],
        [-31, -65],
        [-96, -7],
        [-80, -74],
        [-8, -135]
      ],
      [
        [2883, 11525],
        [-54, -29],
        [8, -45],
        [-41, -26],
        [0, -115]
      ],
      [
        [2796, 11310],
        [-25, -100],
        [-61, -133]
      ],
      [
        [7003, 11980],
        [-14, -86],
        [-37, -53],
        [-171, -29],
        [-15, -16]
      ],
      [
        [6766, 11796],
        [-83, -48],
        [-68, -17],
        [-123, -66]
      ],
      [
        [6492, 11665],
        [-44, 121],
        [-69, -15],
        [-108, -47],
        [-33, -33],
        [-71, 47],
        [-62, 20],
        [-64, 79],
        [27, 24]
      ],
      [
        [12071, 11600],
        [-92, 56],
        [11, 99],
        [43, 49],
        [-170, 2]
      ],
      [
        [11863, 11806],
        [-129, 108],
        [-104, 16]
      ],
      [
        [11630, 11930],
        [-43, 74],
        [42, 59],
        [-16, 58]
      ],
      [
        [12229, 12317],
        [66, -44]
      ],
      [
        [12295, 12273],
        [-5, -92],
        [-28, -91],
        [-42, -35],
        [-3, -57],
        [-43, -101],
        [23, -24],
        [-41, -115],
        [11, -37],
        [-63, -59]
      ],
      [
        [5905, 11485],
        [-28, 47],
        [-53, 141],
        [-2, 47],
        [-123, -13],
        [-13, -21],
        [-98, -20],
        [-46, -24],
        [-79, 110],
        [9, 105],
        [48, 46]
      ],
      [
        [6492, 11665],
        [-118, 51],
        [-69, -82],
        [-78, -12],
        [-31, -49],
        [-72, -21],
        [-87, -61],
        [-73, 4]
      ],
      [
        [11086, 12326],
        [15, -32],
        [101, 12]
      ],
      [
        [11630, 11930],
        [-49, -66],
        [31, -128],
        [-84, 32],
        [-96, -36]
      ],
      [
        [11432, 11732],
        [-22, 26],
        [70, 54],
        [-27, 80],
        [-86, 7],
        [-64, 50],
        [-107, 11],
        [4, 43],
        [-91, -18],
        [-27, -35],
        [5, -54],
        [-73, -86]
      ],
      [
        [11014, 11810],
        [-26, 39],
        [-9, 81],
        [8, 116]
      ],
      [
        [10987, 12046],
        [-11, 56],
        [39, 69],
        [-39, 44]
      ],
      [
        [12295, 12273],
        [74, -5],
        [127, -54],
        [45, -42],
        [112, -71]
      ],
      [
        [12825, 11816],
        [-46, -21],
        [-7, -60],
        [-71, 21]
      ],
      [
        [10987, 12046],
        [-71, -35],
        [-132, 29],
        [-51, 48],
        [-47, 15],
        [22, 59],
        [-3, 68],
        [-54, 18]
      ],
      [
        [3433, 11657],
        [47, 111]
      ],
      [
        [3480, 11768],
        [9, 43],
        [97, -12],
        [59, 84],
        [44, -66],
        [44, 71],
        [61, -43]
      ],
      [
        [3794, 11845],
        [8, -27],
        [-39, -125],
        [-34, -213]
      ],
      [
        [7539, 11772],
        [-14, 108],
        [-61, 32],
        [-37, -32],
        [-73, 6],
        [17, 43]
      ],
      [
        [8158, 12064],
        [4, -49],
        [-51, -59],
        [17, -87]
      ],
      [
        [8128, 11869],
        [-46, 43],
        [-65, -2],
        [-38, -30],
        [-35, 39],
        [-167, -90],
        [8, -36],
        [-27, -92]
      ],
      [
        [11014, 11810],
        [28, -60],
        [-4, -98]
      ],
      [
        [11038, 11652],
        [-80, -47],
        [-81, 59],
        [-25, -44],
        [-90, -6],
        [-1, 40],
        [-70, 35],
        [-22, -52],
        [-80, 6]
      ],
      [
        [10589, 11643],
        [20, 57],
        [48, 56],
        [-15, 37],
        [-128, 1],
        [-75, 97],
        [-17, 42]
      ],
      [
        [10422, 11933],
        [24, 118]
      ],
      [
        [3794, 11845],
        [37, 46],
        [25, 128],
        [-10, 35]
      ],
      [
        [4067, 11852],
        [48, -119],
        [44, 8],
        [3, -66],
        [-41, -62],
        [-15, -70]
      ],
      [
        [5220, 11472],
        [24, 49],
        [83, 28],
        [-37, 34],
        [-57, 8],
        [-52, 115],
        [-82, 105]
      ],
      [
        [8914, 11573],
        [-26, 76],
        [-64, -20],
        [-92, 12],
        [-16, 48],
        [-150, 56],
        [3, 66],
        [39, 49],
        [-90, 101]
      ],
      [
        [4516, 11888],
        [-2, -143],
        [-71, -120],
        [-88, 3],
        [12, -126],
        [-24, -14]
      ],
      [
        [13284, 11486],
        [-37, 55]
      ],
      [
        [13247, 11541],
        [-5, 16]
      ],
      [
        [13242, 11557],
        [2, 103],
        [35, 107]
      ],
      [
        [13477, 11977],
        [66, 17],
        [86, -36],
        [-55, -173],
        [73, -90],
        [-37, -63],
        [33, -47],
        [-24, -31],
        [48, -161],
        [-3, -103],
        [46, -58],
        [-7, -58]
      ],
      [
        [8562, 11438],
        [-48, 75],
        [-70, -2],
        [-95, 121],
        [2, 66],
        [-92, -27],
        [-135, 44],
        [27, 89],
        [-23, 65]
      ],
      [
        [13242, 11557],
        [-100, 6],
        [-134, 30],
        [-91, -79]
      ],
      [
        [11432, 11732],
        [-43, -64]
      ],
      [
        [11389, 11668],
        [-115, 55],
        [-60, -35],
        [-60, -2],
        [-55, -192]
      ],
      [
        [11099, 11494],
        [-21, 83],
        [5, 52],
        [-45, 23]
      ],
      [
        [6925, 11594],
        [6, 41],
        [-80, 73],
        [-4, 68],
        [-81, 20]
      ],
      [
        [4800, 11712],
        [-1, -68],
        [34, -8],
        [25, -97],
        [82, 6],
        [27, -31],
        [-91, -58],
        [3, -101]
      ],
      [
        [10011, 11547],
        [144, 52],
        [11, 83],
        [-33, 17],
        [-60, 74],
        [29, 58],
        [-32, 25],
        [36, 76]
      ],
      [
        [10106, 11932],
        [46, 36],
        [109, 23],
        [88, -60],
        [73, 2]
      ],
      [
        [10589, 11643],
        [-36, -59],
        [-56, -40],
        [-45, 1],
        [-48, -47],
        [1, -33]
      ],
      [
        [11681, 11434],
        [-41, 29],
        [9, 58],
        [-32, 78],
        [-92, -20],
        [-15, 89],
        [-36, 32],
        [-85, -32]
      ],
      [
        [11863, 11806],
        [-35, -36],
        [7, -94],
        [-26, -48],
        [-6, -88],
        [-54, -54]
      ],
      [
        [9464, 11780],
        [-9, -76],
        [60, -34],
        [70, -9]
      ],
      [
        [9585, 11661],
        [76, -37],
        [91, -78],
        [64, 23]
      ],
      [
        [11097, 11438],
        [2, 56]
      ],
      [
        [13067, 11271],
        [-55, -12]
      ],
      [
        [13247, 11541],
        [-24, -58],
        [-54, -6]
      ],
      [
        [11607, 12735],
        [-136, 42],
        [-82, -10],
        [-78, 32],
        [10, 33],
        [-53, 75]
      ],
      [
        [11396, 13655],
        [-64, -31],
        [-77, 12],
        [-53, 64]
      ],
      [
        [11202, 13700],
        [-25, 51],
        [-18, 122],
        [-33, 21],
        [-30, 78]
      ],
      [
        [11096, 13972],
        [70, 27],
        [71, -41],
        [82, -7],
        [65, -30],
        [89, 9]
      ],
      [
        [11877, 13467],
        [-45, -22],
        [-82, 62]
      ],
      [
        [11750, 13507],
        [-73, 57],
        [-54, 19],
        [10, 43],
        [-71, 37],
        [-30, -18]
      ],
      [
        [12243, 13587],
        [64, 35],
        [65, -23],
        [53, 42]
      ],
      [
        [12425, 13641],
        [2, -63],
        [74, 17]
      ],
      [
        [11689, 13261],
        [-16, 71],
        [20, 62],
        [-52, 56]
      ],
      [
        [11641, 13450],
        [3, 23]
      ],
      [
        [11644, 13473],
        [74, 6],
        [32, 28]
      ],
      [
        [11466, 13334],
        [35, 33],
        [9, 88],
        [87, -35],
        [44, 30]
      ],
      [
        [10860, 13488],
        [68, -67],
        [30, 7]
      ],
      [
        [10958, 13428],
        [-16, -18],
        [15, -102]
      ],
      [
        [10877, 13303],
        [-32, 33],
        [-155, 20]
      ],
      [
        [10958, 13428],
        [60, 49],
        [83, -15],
        [59, 25]
      ],
      [
        [11160, 13487],
        [-1, -120],
        [24, -61]
      ],
      [
        [11160, 13487],
        [8, 69],
        [119, -1],
        [35, 44],
        [105, -29],
        [47, -63],
        [47, 19],
        [59, -53],
        [64, 0]
      ],
      [
        [10952, 13772],
        [96, 22],
        [49, -16],
        [48, -62],
        [57, -16]
      ],
      [
        [10984, 14147],
        [26, -139],
        [86, -36]
      ],
      [
        [10706, 13905],
        [-41, 109],
        [102, -1],
        [14, 32],
        [77, 5],
        [40, 93]
      ],
      [
        [12127, 14004],
        [94, 52],
        [199, -22]
      ],
      [
        [12420, 14034],
        [-9, -69]
      ],
      [
        [12411, 13965],
        [-59, -14],
        [35, -71],
        [-23, -75],
        [12, -65],
        [49, -99]
      ],
      [
        [12420, 14034],
        [16, 86],
        [-48, 101],
        [24, 64],
        [-25, 113]
      ],
      [
        [12387, 14398],
        [32, -80],
        [46, -33],
        [135, 2],
        [62, 24],
        [82, -43],
        [46, -1]
      ],
      [
        [12790, 14267],
        [-22, -25],
        [53, -134],
        [-14, -43]
      ],
      [
        [12807, 14065],
        [-33, -62],
        [-76, -31],
        [-31, 11],
        [-130, -3],
        [-70, -31],
        [-56, 16]
      ],
      [
        [11991, 14043],
        [51, 106],
        [13, 62],
        [123, 89]
      ],
      [
        [12178, 14300],
        [81, 12],
        [128, 86]
      ],
      [
        [11585, 14427],
        [28, -23],
        [66, 60],
        [45, 11],
        [106, -37],
        [98, -6],
        [132, -50],
        [18, -30],
        [100, -52]
      ],
      [
        [12807, 14065],
        [116, -6],
        [-8, -40]
      ],
      [
        [12915, 14019],
        [2, -7]
      ],
      [
        [12917, 14012],
        [-8, -24]
      ],
      [
        [12909, 13988],
        [4, -3]
      ],
      [
        [12913, 13985],
        [-16, -41]
      ],
      [
        [12897, 13944],
        [3, -33]
      ],
      [
        [9543, 12477],
        [51, -31],
        [7, -43],
        [83, -32],
        [102, -3],
        [87, -61],
        [1, -66],
        [52, -13],
        [45, -78],
        [-92, -67],
        [1, -96],
        [24, -10]
      ],
      [
        [9904, 11977],
        [-95, -75],
        [-176, -82],
        [14, -21],
        [-63, -104],
        [1, -34]
      ],
      [
        [9904, 11977],
        [71, -43],
        [25, 71],
        [55, -9],
        [51, -64]
      ],
      [
        [3614, 12135],
        [2, -26],
        [-69, -93],
        [-48, -2],
        [-72, -60],
        [22, -21],
        [-32, -65],
        [-35, -17]
      ],
      [
        [3382, 11851],
        [-46, 64],
        [-53, 29],
        [-71, -19]
      ],
      [
        [3215, 12011],
        [56, 33],
        [70, 208],
        [-55, 71],
        [10, 50],
        [55, 58],
        [42, -17],
        [58, 52]
      ],
      [
        [3480, 11768],
        [-48, -15],
        [-70, 69],
        [20, 29]
      ],
      [
        [9121, 14033],
        [-107, 17],
        [-76, -10],
        [-110, 55],
        [-22, -51],
        [2, -71],
        [-81, -30]
      ],
      [
        [6027, 15912],
        [-12, 49]
      ],
      [
        [5965, 16050],
        [110, -2],
        [37, 72]
      ],
      [
        [6112, 16120],
        [55, -29],
        [100, -10],
        [4, -94]
      ],
      [
        [5782, 16026],
        [17, 10]
      ],
      [
        [6881, 16032],
        [38, -31],
        [-24, -69],
        [72, -18],
        [31, -80],
        [46, -48]
      ],
      [
        [5104, 15760],
        [-58, 57],
        [20, 55],
        [71, 13],
        [116, 60],
        [65, -7],
        [39, 95],
        [22, 3]
      ],
      [
        [5379, 16036],
        [39, -21],
        [24, -59]
      ],
      [
        [14213, 14292],
        [-56, 37],
        [-34, -27],
        [-105, 10],
        [-56, 33],
        [-39, -18],
        [-178, 45]
      ],
      [
        [13726, 14602],
        [25, -25],
        [83, 1],
        [78, 34],
        [52, -41],
        [61, 11],
        [58, -45],
        [83, -38],
        [58, -1]
      ],
      [
        [13485, 14819],
        [94, -22],
        [2, -104]
      ],
      [
        [3893, 13867],
        [25, -44],
        [-55, -20],
        [-14, -55],
        [-51, 13]
      ],
      [
        [4112, 13964],
        [-44, 26],
        [-36, -47],
        [12, -37]
      ],
      [
        [4006, 13877],
        [-22, 7]
      ],
      [
        [3977, 13880],
        [-49, 6]
      ],
      [
        [14144, 14115],
        [-62, 42],
        [-17, -55],
        [27, -65],
        [-71, -42],
        [-126, 3],
        [-78, 83],
        [-49, 11],
        [-38, 183],
        [-74, 41],
        [-48, -49],
        [50, -22],
        [-39, -48],
        [-109, 33]
      ],
      [
        [13231, 14352],
        [99, -26],
        [20, -70],
        [-74, -25],
        [-33, -79],
        [-113, -53],
        [-56, -159],
        [5, -73],
        [28, -26],
        [81, -9],
        [122, -86],
        [-5, -50]
      ],
      [
        [12897, 13944],
        [16, 41]
      ],
      [
        [12909, 13988],
        [8, 24]
      ],
      [
        [12915, 14019],
        [82, 76],
        [64, 23],
        [48, 55],
        [87, 58],
        [-26, 93]
      ],
      [
        [4030, 13311],
        [36, -26],
        [-81, -55],
        [-34, -53]
      ],
      [
        [7319, 13397],
        [8, -3]
      ],
      [
        [7300, 13462],
        [10, -22]
      ],
      [
        [7385, 13641],
        [88, -27],
        [73, 2],
        [39, 48],
        [57, 28],
        [55, -9],
        [133, 8],
        [92, -53]
      ],
      [
        [7850, 13518],
        [-47, -6],
        [-116, -108],
        [-10, -69],
        [-60, 30],
        [-49, -14],
        [-68, 37],
        [-51, -67],
        [-56, 20],
        [-10, 46],
        [30, 61],
        [-55, 55],
        [-47, -4]
      ],
      [
        [8012, 13353],
        [-40, -47]
      ],
      [
        [7954, 13281],
        [-74, -65],
        [-77, -10],
        [30, -89],
        [-56, -54],
        [-65, -20],
        [-12, -88],
        [7, -147],
        [-59, 0]
      ],
      [
        [4314, 12887],
        [-68, 19],
        [-49, -162],
        [-58, -21]
      ],
      [
        [2245, 12157],
        [20, -77],
        [82, -139],
        [-13, -29],
        [-101, 12],
        [-84, -9],
        [-51, 18]
      ],
      [
        [2098, 11933],
        [-122, 25],
        [-103, -37],
        [-97, 7],
        [-83, -34]
      ],
      [
        [1693, 11894],
        [19, 52],
        [-140, -9],
        [-52, 29],
        [-74, -1],
        [-96, -108],
        [-55, -107],
        [-101, -17],
        [-103, -51],
        [-79, -22],
        [-151, 11],
        [-187, 46],
        [-326, 215],
        [-66, 80],
        [12, 55],
        [-98, 47],
        [10, 48],
        [-58, 7],
        [-11, 60],
        [-110, 17],
        [-27, 56],
        [47, 13],
        [24, 130],
        [85, 66],
        [271, 4],
        [7, 236],
        [55, -41],
        [64, 46],
        [37, -58],
        [60, 37],
        [65, -27],
        [78, 32],
        [117, -10],
        [67, 19],
        [90, -89],
        [192, 0],
        [55, 90],
        [303, 93],
        [-1, -124],
        [63, -24],
        [90, 1],
        [45, 54],
        [73, 52],
        [41, -7],
        [35, 58],
        [-68, 6],
        [-8, 110],
        [82, 58]
      ],
      [
        [1884, 11383],
        [66, -9],
        [53, 74],
        [-45, 43],
        [10, 57],
        [34, 30],
        [-24, 83],
        [84, 29],
        [61, 190],
        [-25, 53]
      ],
      [
        [3347, 11538],
        [-80, 73],
        [-61, -4],
        [-12, -51],
        [-44, -42],
        [-57, -1],
        [-59, 38],
        [-34, -30],
        [-23, -76],
        [-50, 3],
        [-44, 77]
      ],
      [
        [3169, 11294],
        [-188, -10],
        [-94, 31],
        [-36, -47],
        [-55, 42]
      ],
      [
        [12790, 14267],
        [124, 41],
        [121, -32],
        [43, 46],
        [7, 67]
      ],
      [
        [1567, 11760],
        [42, 70],
        [84, 64]
      ],
      [
        [6734, 18737],
        [-56, 35],
        [61, 34],
        [-12, 100],
        [-110, -68],
        [-50, 13],
        [-29, -37],
        [-54, -8],
        [-64, 51],
        [11, 26],
        [-81, 132],
        [-46, 45],
        [-90, -19],
        [-88, -62],
        [-41, 18],
        [-44, -48],
        [-42, 42]
      ],
      [
        [5999, 18991],
        [29, 15],
        [-27, 73],
        [41, 65],
        [45, 0],
        [7, 82],
        [38, 56],
        [10, 83],
        [-33, 75],
        [-93, -5],
        [-60, 111],
        [-101, 51],
        [-74, 7],
        [-34, 47],
        [-85, 17],
        [-74, 74],
        [-47, -31],
        [-38, 59],
        [42, 73],
        [71, 25],
        [-11, 102],
        [34, 76],
        [-64, 38],
        [-45, 81],
        [3, 60],
        [-58, 46],
        [-34, 63],
        [-188, -42],
        [-105, 52],
        [-52, -138],
        [-68, -33],
        [-124, 2],
        [-60, -33],
        [-27, -53],
        [-54, -16]
      ],
      [
        [4763, 20073],
        [-6, 19]
      ],
      [
        [4757, 20092],
        [-36, 34],
        [24, 69],
        [-77, 72],
        [-70, 13],
        [-73, -15],
        [-62, 27],
        [-126, 6],
        [-86, 48]
      ],
      [
        [4251, 20346],
        [-25, 23],
        [-159, 13]
      ],
      [
        [4067, 20382],
        [61, 9],
        [29, 39],
        [72, 15],
        [13, 99],
        [-66, 73],
        [-69, -38],
        [-84, -15],
        [-69, 44]
      ],
      [
        [3954, 20608],
        [-230, 107],
        [-42, -20],
        [-20, 102],
        [61, 75],
        [-6, 47],
        [-98, 34],
        [-149, -6],
        [-177, 113],
        [11, 89],
        [-42, 30],
        [-105, -27],
        [-18, 26],
        [-138, -35],
        [-102, 61],
        [40, 80],
        [-42, 34],
        [42, 137],
        [120, 35],
        [68, 56],
        [-2, 41],
        [73, 10],
        [79, 111],
        [9, 56],
        [123, 14],
        [83, 28],
        [170, -44],
        [70, 23],
        [36, 52],
        [-91, 34],
        [-22, 57],
        [123, -13],
        [116, -64],
        [57, 24],
        [17, 46],
        [60, -12],
        [110, 75],
        [67, -2],
        [36, 42],
        [80, 24],
        [17, -41],
        [69, 1],
        [53, -85],
        [63, 51],
        [51, -24],
        [74, 68],
        [88, 12],
        [5, -52],
        [47, -15],
        [33, -109],
        [93, -36],
        [87, -126],
        [114, -62],
        [101, -21],
        [116, -92],
        [63, 9],
        [53, -38],
        [32, -70],
        [78, -33],
        [28, 13],
        [50, -73],
        [53, -26],
        [-51, -69],
        [58, -79],
        [81, -44],
        [118, 10],
        [33, -46],
        [173, -58],
        [22, -59],
        [-19, -41],
        [116, -35],
        [72, 5],
        [62, 27],
        [54, -33],
        [43, 76],
        [49, 11],
        [63, -35],
        [40, 95],
        [48, 38],
        [74, 10],
        [25, 36],
        [64, -16],
        [94, 69],
        [103, -2],
        [90, 27],
        [40, -32],
        [72, -9],
        [41, 37],
        [14, 67],
        [106, 12],
        [29, -72],
        [293, -83],
        [84, 40],
        [71, -114],
        [120, -53],
        [24, -100],
        [-67, -182],
        [-28, -39],
        [-5, -119],
        [-67, -127],
        [-2, -83],
        [-82, -24],
        [-55, 6],
        [-55, -45],
        [12, -104],
        [-131, 12],
        [-56, -19],
        [55, -140],
        [-56, -56],
        [-8, -51],
        [-91, -72],
        [-103, 11],
        [-41, -18],
        [-74, 18],
        [-76, -55],
        [62, -125],
        [30, -28],
        [40, -108],
        [-77, -4],
        [-49, -27],
        [12, -103],
        [37, -72],
        [79, -30],
        [85, 4],
        [140, -29],
        [-51, -126],
        [30, -90],
        [95, -127],
        [39, -34],
        [-117, -151],
        [-84, 44],
        [-82, -80],
        [-38, -4],
        [-14, -68],
        [-53, 2],
        [-34, -35],
        [-81, 74],
        [-53, 86],
        [-10, 70],
        [-65, 0],
        [-133, -54],
        [-39, -40]
      ],
      [
        [5999, 18991],
        [-81, 75],
        [-92, 8],
        [-50, 29],
        [-31, 68],
        [-45, 28],
        [-29, 66]
      ],
      [
        [5671, 19265],
        [-177, 193],
        [-126, 40],
        [-25, 52],
        [-4, 72],
        [-62, 39],
        [-80, 97],
        [-17, 50],
        [-103, -14],
        [-116, 132],
        [-60, 28]
      ],
      [
        [4901, 19954],
        [-64, 26]
      ],
      [
        [4837, 19980],
        [-55, 36],
        [-19, 57]
      ],
      [
        [4251, 20346],
        [-35, -133],
        [-77, -88]
      ],
      [
        [4139, 20125],
        [-54, -63],
        [-107, -20],
        [-28, -55],
        [-96, 10]
      ],
      [
        [3854, 19997],
        [-37, 55],
        [-116, 14],
        [32, 53],
        [55, 18],
        [48, 93],
        [7, 79],
        [118, -2],
        [106, 75]
      ],
      [
        [4757, 20092],
        [-148, -31],
        [-86, 66],
        [-77, 9],
        [-4, -53],
        [-97, -45],
        [-51, 6],
        [-5, -69],
        [27, -31]
      ],
      [
        [4316, 19944],
        [-10, -5]
      ],
      [
        [4306, 19939],
        [-88, 47],
        [-22, 40],
        [16, 73],
        [-73, 26]
      ],
      [
        [4306, 19939],
        [5, -29]
      ],
      [
        [4311, 19910],
        [-50, -17],
        [-92, -80],
        [-39, -70]
      ],
      [
        [4130, 19743],
        [-111, 82],
        [-191, -3],
        [-39, 35]
      ],
      [
        [3789, 19857],
        [25, 55],
        [46, 32],
        [-6, 53]
      ],
      [
        [4837, 19980],
        [-79, -20],
        [-70, 36],
        [-107, -65]
      ],
      [
        [4581, 19931],
        [-62, -4],
        [-52, 30],
        [-53, -57],
        [-98, 44]
      ],
      [
        [4901, 19954],
        [-41, -58],
        [-7, -52],
        [-49, -5],
        [-34, -100],
        [83, -136],
        [5, -83],
        [-47, -75],
        [10, -72]
      ],
      [
        [4821, 19373],
        [-59, -26]
      ],
      [
        [4762, 19347],
        [-151, 140]
      ],
      [
        [4611, 19487],
        [-30, 55],
        [9, 97],
        [-56, 11]
      ],
      [
        [4534, 19650],
        [-1, 0]
      ],
      [
        [4533, 19650],
        [-1, 0]
      ],
      [
        [4532, 19650],
        [8, 24]
      ],
      [
        [4540, 19674],
        [98, 66],
        [22, 38],
        [-14, 82],
        [-36, 12]
      ],
      [
        [4610, 19872],
        [-29, 59]
      ],
      [
        [5671, 19265],
        [-16, -52]
      ],
      [
        [5655, 19213],
        [-67, -13],
        [-50, 35],
        [-104, -17],
        [-77, -60],
        [-46, -60]
      ],
      [
        [5311, 19098],
        [-6, 49],
        [-44, 52],
        [-96, -53],
        [-91, 27],
        [-109, 83],
        [-58, 13],
        [-86, 104]
      ],
      [
        [4610, 19872],
        [-49, 23],
        [-105, -70]
      ],
      [
        [4456, 19825],
        [-145, 85]
      ],
      [
        [4456, 19825],
        [-63, -114],
        [-67, -43]
      ],
      [
        [4326, 19668],
        [-97, -82]
      ],
      [
        [4229, 19586],
        [-16, -8]
      ],
      [
        [4213, 19578],
        [-59, 52],
        [-24, 113]
      ],
      [
        [4540, 19674],
        [-109, -18],
        [-105, 12]
      ],
      [
        [4213, 19578],
        [-19, -60],
        [39, -66]
      ],
      [
        [4233, 19452],
        [-30, -29],
        [-69, 72],
        [-139, -16],
        [11, -41],
        [-39, -56]
      ],
      [
        [3967, 19382],
        [-13, 93],
        [-54, 8],
        [-73, 52],
        [-69, -21],
        [-94, 21],
        [-69, 66]
      ],
      [
        [3595, 19601],
        [-25, 46],
        [19, 78],
        [-44, 74],
        [-22, 116]
      ],
      [
        [3523, 19915],
        [30, 5],
        [78, -64],
        [100, 13],
        [58, -12]
      ],
      [
        [4532, 19650],
        [-52, -30],
        [9, -42],
        [-62, -42],
        [-124, 57],
        [-74, -7]
      ],
      [
        [4534, 19650],
        [-1, 0]
      ],
      [
        [4611, 19487],
        [-84, -42]
      ],
      [
        [4527, 19445],
        [-149, -24],
        [-55, 43],
        [-56, -21]
      ],
      [
        [4267, 19443],
        [-34, 9]
      ],
      [
        [4267, 19443],
        [39, -99],
        [4, -86],
        [-79, -155]
      ],
      [
        [4231, 19103],
        [-155, -54]
      ],
      [
        [4076, 19049],
        [-9, 55],
        [-102, 33],
        [-11, 47],
        [-95, 57],
        [2, 30],
        [83, 35],
        [23, 76]
      ],
      [
        [4762, 19347],
        [-22, -48],
        [18, -69],
        [-27, -45],
        [14, -52]
      ],
      [
        [4745, 19133],
        [-80, 58],
        [-93, 27]
      ],
      [
        [4572, 19218],
        [-36, 15],
        [-13, 76],
        [28, 34],
        [-33, 42],
        [9, 60]
      ],
      [
        [4572, 19218],
        [-41, -63],
        [35, -25],
        [-67, -100]
      ],
      [
        [4499, 19030],
        [-30, -29],
        [-55, 74],
        [-74, 51],
        [-76, -44],
        [-33, 21]
      ],
      [
        [5311, 19098],
        [-72, -11],
        [-16, -36],
        [-87, -61],
        [-68, 41],
        [-32, -32]
      ],
      [
        [5036, 18999],
        [-78, -17]
      ],
      [
        [4958, 18982],
        [-17, 45],
        [-62, 30],
        [-72, -4],
        [-62, 80]
      ],
      [
        [6734, 18737],
        [37, -53],
        [52, -28],
        [-35, -48],
        [1, -50],
        [83, -47],
        [-12, -44],
        [54, -55]
      ],
      [
        [6914, 18412],
        [-108, -22],
        [-39, 9],
        [-19, -91],
        [-143, -2],
        [-113, -126],
        [-108, 16]
      ],
      [
        [6384, 18196],
        [-63, 118],
        [21, 32],
        [-36, 75],
        [-180, 97],
        [-31, -25],
        [-50, 42],
        [-17, 55],
        [-109, 67],
        [-51, -12]
      ],
      [
        [5868, 18645],
        [-61, 4],
        [-75, 43]
      ],
      [
        [5732, 18692],
        [1, 51],
        [-100, 4],
        [-78, 71],
        [-84, 11],
        [-42, 56],
        [-15, 66],
        [73, -13],
        [78, 37],
        [45, -4],
        [24, 52],
        [46, 25],
        [-30, 110],
        [5, 55]
      ],
      [
        [5732, 18692],
        [-75, -77],
        [8, -108],
        [-64, -24],
        [-52, 34],
        [-103, 28],
        [-48, 47],
        [-87, 50],
        [-39, -69],
        [-86, -22],
        [-5, 47],
        [-60, 44]
      ],
      [
        [5121, 18642],
        [-62, 85]
      ],
      [
        [5059, 18727],
        [53, 89],
        [4, 83],
        [-80, 100]
      ],
      [
        [4499, 19030],
        [121, -118],
        [-48, -36]
      ],
      [
        [4572, 18876],
        [-57, 18],
        [-70, -69],
        [29, -44],
        [-35, -47]
      ],
      [
        [4439, 18734],
        [-13, -25],
        [-123, 4],
        [-28, 88],
        [14, 127],
        [-95, -32],
        [-44, 33]
      ],
      [
        [4150, 18929],
        [-23, 78],
        [-51, 42]
      ],
      [
        [5059, 18727],
        [-71, -43],
        [-27, -45],
        [-59, -9],
        [-55, -51],
        [-112, 28]
      ],
      [
        [4735, 18607],
        [-89, 52]
      ],
      [
        [4646, 18659],
        [35, 50],
        [17, 113]
      ],
      [
        [4698, 18822],
        [84, 27],
        [53, 62],
        [105, 5],
        [18, 66]
      ],
      [
        [4760, 18488],
        [36, -24],
        [100, -6],
        [9, -35]
      ],
      [
        [4905, 18423],
        [-2, -8]
      ],
      [
        [4903, 18415],
        [-44, -103],
        [24, -102],
        [-60, -110]
      ],
      [
        [4823, 18100],
        [-47, -41]
      ],
      [
        [4776, 18059],
        [-115, 66],
        [-25, 41],
        [-78, 49],
        [-66, 17],
        [-52, 71],
        [15, 84]
      ],
      [
        [4455, 18387],
        [65, -6],
        [72, 33],
        [34, -10],
        [134, 84]
      ],
      [
        [5868, 18645],
        [-3, -47],
        [-87, -198]
      ],
      [
        [5778, 18400],
        [-108, 1],
        [-71, -36],
        [22, -58],
        [-37, -45]
      ],
      [
        [5584, 18262],
        [-54, 10],
        [-80, -67],
        [-88, -10],
        [8, -42]
      ],
      [
        [5370, 18153],
        [-132, 53],
        [-44, 48],
        [-54, -3]
      ],
      [
        [5140, 18251],
        [-33, 68],
        [-167, 92],
        [-37, 4]
      ],
      [
        [4905, 18423],
        [39, 32],
        [-15, 83],
        [87, 27],
        [67, 78],
        [38, -1]
      ],
      [
        [6384, 18196],
        [-75, -49]
      ],
      [
        [6309, 18147],
        [-67, -37],
        [2, -58],
        [38, -59],
        [-52, -37],
        [1, -45],
        [-73, -30],
        [-88, 9]
      ],
      [
        [6070, 17890],
        [-55, 139],
        [3, 85],
        [-59, 41],
        [-23, 85],
        [-78, 13],
        [-80, 147]
      ],
      [
        [5140, 18251],
        [0, -55],
        [37, -109],
        [68, -97],
        [52, -142],
        [58, 3]
      ],
      [
        [5355, 17851],
        [27, -61]
      ],
      [
        [5382, 17790],
        [-62, 15],
        [-17, -78],
        [-47, 7],
        [-95, 82],
        [-67, 12]
      ],
      [
        [5094, 17828],
        [-27, 71],
        [-40, -6]
      ],
      [
        [5027, 17893],
        [8, 65],
        [-64, 55],
        [-21, 56],
        [-47, -1]
      ],
      [
        [4903, 18068],
        [-80, 32]
      ],
      [
        [4776, 18059],
        [-74, -74]
      ],
      [
        [4702, 17985],
        [-144, 27],
        [-148, 2],
        [-33, 29],
        [-95, -22],
        [-24, -30]
      ],
      [
        [4258, 17991],
        [-71, 175],
        [37, 13],
        [8, 59],
        [62, 61],
        [91, 29],
        [70, 59]
      ],
      [
        [6070, 17890],
        [-51, -67],
        [-98, -28],
        [-81, 31]
      ],
      [
        [5840, 17826],
        [-101, 57]
      ],
      [
        [5739, 17883],
        [-49, 51],
        [-46, 117]
      ],
      [
        [5644, 18051],
        [-5, 60],
        [-56, 60],
        [1, 91]
      ],
      [
        [6914, 18412],
        [71, -62],
        [-50, -159],
        [38, -73],
        [54, -48],
        [-73, -52],
        [41, -68],
        [-31, -56],
        [27, -45],
        [59, -15]
      ],
      [
        [7050, 17834],
        [68, -80],
        [15, -46],
        [-80, -9],
        [-50, 73],
        [-90, -1],
        [-41, 23],
        [-82, -22],
        [-74, 64],
        [-39, -2]
      ],
      [
        [6677, 17834],
        [-13, 31],
        [-84, 13],
        [-40, 55],
        [-89, -13],
        [-82, 76],
        [-18, 114],
        [-42, 37]
      ],
      [
        [5370, 18153],
        [58, -83],
        [40, -88]
      ],
      [
        [5468, 17982],
        [-46, -54]
      ],
      [
        [5422, 17928],
        [-67, -77]
      ],
      [
        [6677, 17834],
        [-42, -39],
        [-94, -32],
        [-89, -9],
        [-67, -47],
        [-23, -58]
      ],
      [
        [6362, 17649],
        [-15, -128],
        [-67, -65]
      ],
      [
        [6280, 17456],
        [-29, 31],
        [-74, -24],
        [-35, 16],
        [-74, 164],
        [-87, -74]
      ],
      [
        [5981, 17569],
        [-130, 142],
        [-11, 115]
      ],
      [
        [5027, 17893],
        [-69, -36],
        [-6, -34],
        [82, -38]
      ],
      [
        [5034, 17785],
        [65, -44],
        [36, -106]
      ],
      [
        [5135, 17635],
        [-102, -11],
        [-33, 13],
        [-100, -32],
        [-153, 18]
      ],
      [
        [4747, 17623],
        [-139, 71]
      ],
      [
        [4608, 17694],
        [-45, 41]
      ],
      [
        [4563, 17735],
        [31, 16],
        [94, -16],
        [5, 29],
        [92, 45],
        [28, -10],
        [20, 108],
        [-33, 81],
        [52, 3],
        [51, 77]
      ],
      [
        [4702, 17985],
        [-120, -127],
        [-40, -92],
        [-53, -27]
      ],
      [
        [4489, 17739],
        [-146, -25],
        [-22, -34]
      ],
      [
        [4321, 17680],
        [-12, 41],
        [-117, 3],
        [27, 169],
        [65, 67],
        [-26, 31]
      ],
      [
        [5422, 17928],
        [26, -63],
        [43, -41],
        [59, 3],
        [38, -47]
      ],
      [
        [5588, 17780],
        [-14, -153],
        [71, -45]
      ],
      [
        [5645, 17582],
        [-82, -34],
        [-50, -89]
      ],
      [
        [5513, 17459],
        [-57, -6],
        [-50, 82],
        [-31, 4]
      ],
      [
        [5375, 17539],
        [-9, 82]
      ],
      [
        [5366, 17621],
        [123, -11],
        [-107, 180]
      ],
      [
        [7050, 17834],
        [41, 60],
        [41, 9],
        [43, 56],
        [43, -16],
        [19, -53],
        [43, -20],
        [-7, -53],
        [48, -31],
        [15, -60],
        [58, -45]
      ],
      [
        [7394, 17681],
        [-75, -76],
        [-44, -115],
        [32, -63]
      ],
      [
        [7307, 17427],
        [-49, 6],
        [-109, 56]
      ],
      [
        [7149, 17489],
        [-19, 36],
        [-81, 12],
        [-21, -100],
        [-84, -3],
        [-78, -45],
        [-35, -101],
        [-61, 7],
        [-39, -27],
        [-76, 77],
        [-47, -24],
        [-31, 36],
        [-95, -8]
      ],
      [
        [6482, 17349],
        [43, 90],
        [-68, 108],
        [-7, 64],
        [-72, -17],
        [-16, 55]
      ],
      [
        [5981, 17569],
        [-86, -50],
        [-59, -74]
      ],
      [
        [5836, 17445],
        [-71, 110],
        [-31, -20],
        [-60, 23]
      ],
      [
        [5674, 17558],
        [-29, 24]
      ],
      [
        [5588, 17780],
        [57, 23],
        [70, -7],
        [57, 53],
        [-33, 34]
      ],
      [
        [5366, 17621],
        [-19, 18],
        [-92, -13],
        [-120, 9]
      ],
      [
        [5034, 17785],
        [60, 43]
      ],
      [
        [4151, 16862],
        [-98, 5]
      ],
      [
        [4053, 16867],
        [-264, 14],
        [6, 56],
        [47, 50],
        [-5, 54]
      ],
      [
        [3837, 17041],
        [-5, 56],
        [-53, 65],
        [56, 47],
        [-1, 44],
        [165, 150]
      ],
      [
        [3999, 17403],
        [131, -56]
      ],
      [
        [4130, 17347],
        [-32, -20],
        [-6, -134],
        [-62, -113],
        [62, -5],
        [20, -121],
        [39, -92]
      ],
      [
        [4747, 17623],
        [24, -137],
        [-15, -130],
        [23, -31]
      ],
      [
        [4779, 17325],
        [-31, -52],
        [-42, 3]
      ],
      [
        [4706, 17276],
        [-75, -4],
        [-11, 49],
        [-95, -64]
      ],
      [
        [4525, 17257],
        [-49, 59],
        [7, 77],
        [-33, 43]
      ],
      [
        [4450, 17436],
        [30, 113],
        [83, 40],
        [11, 73],
        [34, 32]
      ],
      [
        [5375, 17539],
        [-25, -35],
        [14, -110],
        [-99, -17],
        [-43, -68]
      ],
      [
        [5222, 17309],
        [-50, 39],
        [-48, -35],
        [-37, 79],
        [-61, -14],
        [-67, -48]
      ],
      [
        [4959, 17330],
        [-69, -15],
        [-74, 26],
        [-37, -16]
      ],
      [
        [7394, 17681],
        [65, -30],
        [62, -72],
        [85, 33],
        [87, -4],
        [16, -40],
        [108, -54],
        [31, -40]
      ],
      [
        [7848, 17474],
        [-77, -72],
        [39, -67],
        [-31, -44],
        [27, -68],
        [-33, -91]
      ],
      [
        [7773, 17132],
        [-74, -35],
        [-72, -100],
        [32, -80],
        [-60, -16],
        [-72, 14],
        [-91, -30]
      ],
      [
        [7436, 16885],
        [-31, -32],
        [-65, -4],
        [-62, 33]
      ],
      [
        [7278, 16882],
        [-24, 79],
        [-76, 100]
      ],
      [
        [7178, 17061],
        [54, 78],
        [5, 86],
        [51, 82],
        [59, 27],
        [8, 39],
        [-48, 54]
      ],
      [
        [6482, 17349],
        [-26, -95],
        [87, -6],
        [77, -53],
        [-59, -45],
        [94, -52],
        [-28, -63],
        [44, -53]
      ],
      [
        [6671, 16982],
        [-65, -106]
      ],
      [
        [6606, 16876],
        [-35, 1],
        [-52, 54],
        [-72, 145]
      ],
      [
        [6447, 17076],
        [-155, 64],
        [-42, 52],
        [-54, 0]
      ],
      [
        [6196, 17192],
        [157, 76],
        [2, 40],
        [-75, 148]
      ],
      [
        [6196, 17192],
        [3, -16]
      ],
      [
        [6199, 17176],
        [-37, 47],
        [-76, -12],
        [-130, 44]
      ],
      [
        [5956, 17255],
        [-56, 55]
      ],
      [
        [5900, 17310],
        [32, 28],
        [-3, 60],
        [-93, 47]
      ],
      [
        [5674, 17558],
        [45, -51],
        [-5, -58]
      ],
      [
        [5714, 17449],
        [-84, 5],
        [19, -50],
        [58, -8]
      ],
      [
        [5707, 17396],
        [64, -52],
        [-12, -110]
      ],
      [
        [5759, 17234],
        [-6, -10]
      ],
      [
        [5753, 17224],
        [9, -14]
      ],
      [
        [5762, 17210],
        [-107, 2]
      ],
      [
        [5655, 17212],
        [14, 54],
        [-23, 51],
        [-65, 34]
      ],
      [
        [5581, 17351],
        [-66, 66],
        [-2, 42]
      ],
      [
        [4525, 17257],
        [-16, -62],
        [-49, -28],
        [-65, 19]
      ],
      [
        [4395, 17186],
        [-42, 1],
        [-44, 93],
        [13, 27],
        [-90, 76],
        [-47, 2]
      ],
      [
        [4185, 17385],
        [-19, 60],
        [100, 64],
        [96, -16],
        [88, -57]
      ],
      [
        [5581, 17351],
        [-65, -44],
        [-66, -84],
        [-134, 92],
        [-94, -24]
      ],
      [
        [5222, 17291],
        [0, 18]
      ],
      [
        [7149, 17489],
        [-3, -30],
        [-77, -56],
        [-31, -90],
        [-18, -153],
        [42, -82]
      ],
      [
        [7062, 17078],
        [-61, -18],
        [-59, 13],
        [-45, -22],
        [-45, -75],
        [-44, -36],
        [-66, 59],
        [-71, -17]
      ],
      [
        [5714, 17449],
        [-7, -53]
      ],
      [
        [4130, 17347],
        [55, 38]
      ],
      [
        [4395, 17186],
        [-64, -61],
        [-13, -108],
        [1, -135]
      ],
      [
        [4319, 16882],
        [-38, -46],
        [-79, 21]
      ],
      [
        [4202, 16857],
        [-51, 5]
      ],
      [
        [7178, 17061],
        [-62, -31],
        [-54, 48]
      ],
      [
        [7848, 17474],
        [47, 14],
        [50, -46],
        [-24, -117],
        [134, -43],
        [80, -56],
        [44, 17],
        [66, -39],
        [62, -68],
        [128, -41],
        [30, -42],
        [-76, -26],
        [-109, -91],
        [-57, -67],
        [-48, 0],
        [-31, -78],
        [-78, -33],
        [-45, -47],
        [28, -105],
        [-44, -62],
        [-65, -48]
      ],
      [
        [7940, 16496],
        [-109, 56]
      ],
      [
        [7831, 16552],
        [-50, 28],
        [-31, 88],
        [-40, 23]
      ],
      [
        [7710, 16691],
        [63, 38],
        [44, 100],
        [68, 2],
        [-59, 83],
        [31, 151],
        [-84, 67]
      ],
      [
        [5222, 17291],
        [1, -58],
        [-65, -85],
        [65, -22],
        [52, 8],
        [-1, -59],
        [-76, -39],
        [36, -60],
        [-64, -88],
        [-15, -56],
        [75, -70]
      ],
      [
        [5230, 16762],
        [-32, -46],
        [-67, -13]
      ],
      [
        [5131, 16703],
        [-110, 68],
        [-38, -6]
      ],
      [
        [4983, 16765],
        [29, 76],
        [-58, -7],
        [8, 75],
        [-73, 96]
      ],
      [
        [4889, 17005],
        [-13, 39],
        [112, 55],
        [-29, 57],
        [-21, 139],
        [21, 35]
      ],
      [
        [4889, 17005],
        [-74, 36],
        [-62, 5]
      ],
      [
        [4753, 17046],
        [2, 44],
        [-37, 49],
        [12, 36],
        [-52, 63],
        [28, 38]
      ],
      [
        [4753, 17046],
        [-16, -50],
        [-60, -19],
        [-10, -106],
        [-36, 7],
        [6, -91]
      ],
      [
        [4637, 16787],
        [-48, -9],
        [-79, 26],
        [-46, 60],
        [-75, 31],
        [-70, -13]
      ],
      [
        [5655, 17212],
        [-24, -75],
        [-98, -61],
        [53, -67]
      ],
      [
        [5586, 17009],
        [-3, -2]
      ],
      [
        [5583, 17007],
        [-40, -33]
      ],
      [
        [5543, 16974],
        [-72, -2]
      ],
      [
        [5471, 16972],
        [-37, 34],
        [-102, -41],
        [-54, -118],
        [28, -63]
      ],
      [
        [5306, 16784],
        [-76, -22]
      ],
      [
        [6199, 17176],
        [2, -52],
        [-83, -105],
        [-150, -163]
      ],
      [
        [5968, 16856],
        [-70, 38]
      ],
      [
        [5898, 16894],
        [-36, 98]
      ],
      [
        [5862, 16992],
        [18, 72],
        [56, 72],
        [-7, 83],
        [27, 36]
      ],
      [
        [6447, 17076],
        [-65, -93],
        [-38, -13],
        [-56, -153],
        [68, -154]
      ],
      [
        [6356, 16663],
        [-52, -47],
        [-166, 18]
      ],
      [
        [6138, 16634],
        [-31, 26],
        [-67, -19],
        [-74, 38],
        [-47, -6]
      ],
      [
        [5919, 16673],
        [-21, 49],
        [35, 36],
        [35, 98]
      ],
      [
        [4053, 16867],
        [-29, -44],
        [18, -37],
        [-64, -68],
        [-134, -22],
        [-20, -39],
        [-77, -7],
        [33, -48],
        [52, -16],
        [38, -205],
        [48, -21],
        [49, 50],
        [32, -61],
        [-9, -67],
        [-105, -102]
      ],
      [
        [3885, 16180],
        [-10, -56],
        [-97, 5],
        [-52, 47],
        [-118, 22],
        [-64, -30],
        [-120, 14],
        [-36, -56],
        [-48, -10],
        [-1, -53],
        [-129, -90],
        [-100, 0],
        [-70, 42],
        [-57, 80]
      ],
      [
        [2983, 16095],
        [46, 40],
        [139, 58],
        [39, 91],
        [52, 60],
        [130, 245],
        [75, 272],
        [130, 53],
        [137, 35],
        [106, 92]
      ],
      [
        [4983, 16765],
        [-92, -54],
        [-78, 49],
        [-75, -81],
        [-28, -99]
      ],
      [
        [4710, 16580],
        [-88, 78],
        [48, 61],
        [-33, 68]
      ],
      [
        [5586, 17009],
        [27, 27],
        [87, 23],
        [94, -18],
        [68, -49]
      ],
      [
        [5898, 16894],
        [-15, -30],
        [-74, 6],
        [-67, -57],
        [-31, 16],
        [-68, -23]
      ],
      [
        [5643, 16806],
        [-45, 30],
        [-128, 1],
        [-28, 86],
        [29, 49]
      ],
      [
        [5543, 16974],
        [40, 33]
      ],
      [
        [7710, 16691],
        [-86, -8],
        [-41, 47],
        [8, 44],
        [-131, 34],
        [-24, 77]
      ],
      [
        [6606, 16876],
        [74, -76],
        [13, -47]
      ],
      [
        [6693, 16753],
        [-86, -44],
        [-48, -62],
        [-72, -51]
      ],
      [
        [6487, 16596],
        [-61, 96],
        [-70, -29]
      ],
      [
        [7278, 16882],
        [-95, -63],
        [24, -124],
        [-40, -94]
      ],
      [
        [7167, 16601],
        [-33, -2],
        [-55, -107]
      ],
      [
        [7079, 16492],
        [-82, 19],
        [-120, 68],
        [-55, 59],
        [-14, 62],
        [-115, 53]
      ],
      [
        [5643, 16806],
        [-30, -140],
        [-94, -47],
        [-24, -71]
      ],
      [
        [5495, 16548],
        [-85, 9],
        [-15, 38],
        [-73, 9],
        [-46, 70],
        [30, 110]
      ],
      [
        [4710, 16580],
        [-1, -88],
        [-53, -30],
        [13, -100]
      ],
      [
        [4669, 16362],
        [-104, -23],
        [-20, 42],
        [-59, -4],
        [-15, 59],
        [-57, 30],
        [-41, -30],
        [-121, 2],
        [-12, 68],
        [25, 53],
        [-31, 24],
        [27, 137],
        [-89, -5],
        [3, 50],
        [50, 40],
        [-23, 52]
      ],
      [
        [3963, 16010],
        [-68, 1],
        [49, 72],
        [-11, 46],
        [-48, 51]
      ],
      [
        [4669, 16362],
        [69, 17]
      ],
      [
        [4738, 16379],
        [39, -17],
        [-9, -144],
        [33, -3],
        [56, -63]
      ],
      [
        [4857, 16152],
        [-35, -33]
      ],
      [
        [5919, 16673],
        [-30, -40],
        [17, -108]
      ],
      [
        [5906, 16525],
        [-81, -28],
        [-124, 50],
        [-38, -38]
      ],
      [
        [5663, 16509],
        [-36, 19],
        [-114, -18],
        [-18, 38]
      ],
      [
        [7831, 16552],
        [-148, -65]
      ],
      [
        [7683, 16487],
        [-105, 30],
        [-44, 60],
        [-62, -5],
        [-29, -38],
        [-96, 84],
        [-76, -65],
        [-104, 48]
      ],
      [
        [5663, 16509],
        [-17, -54],
        [-55, -15],
        [17, -63]
      ],
      [
        [5608, 16377],
        [-75, 0],
        [4, -40],
        [-47, -35],
        [-12, -62]
      ],
      [
        [5478, 16240],
        [-115, -4]
      ],
      [
        [5363, 16236],
        [-1, 74],
        [-49, 22],
        [-22, 139],
        [-39, -14],
        [-77, 66],
        [-33, 59]
      ],
      [
        [5142, 16582],
        [-11, 121]
      ],
      [
        [5142, 16582],
        [-69, -9],
        [-149, -97],
        [-10, -33],
        [-122, -2],
        [-54, -62]
      ],
      [
        [6521, 16233],
        [34, 65],
        [-7, 61]
      ],
      [
        [6548, 16359],
        [-57, 95],
        [-26, 103],
        [22, 39]
      ],
      [
        [7079, 16492],
        [-49, -66]
      ],
      [
        [7030, 16426],
        [-59, -61]
      ],
      [
        [6971, 16365],
        [-47, -18],
        [-25, -85],
        [-77, -42]
      ],
      [
        [6548, 16359],
        [-81, 0],
        [-127, -52],
        [-99, 30],
        [-38, 29],
        [-53, -54]
      ],
      [
        [6150, 16312],
        [-66, 42],
        [-83, 14]
      ],
      [
        [6001, 16368],
        [96, 89],
        [26, 44],
        [15, 133]
      ],
      [
        [5363, 16236],
        [-48, -70]
      ],
      [
        [5315, 16166],
        [-25, 44],
        [-145, 9],
        [-89, -111],
        [-98, 0],
        [-34, 49],
        [-67, -5]
      ],
      [
        [7683, 16487],
        [28, -45],
        [-24, -68],
        [47, -45],
        [-32, -41],
        [63, -27],
        [-2, -48]
      ],
      [
        [7763, 16213],
        [-49, -45],
        [-63, 23],
        [-239, 43],
        [-103, 113],
        [-173, 37],
        [-56, 37],
        [-50, 5]
      ],
      [
        [5906, 16525],
        [-3, -98],
        [18, -38]
      ],
      [
        [5921, 16389],
        [-8, -95]
      ],
      [
        [5913, 16294],
        [-105, 16],
        [-42, 22],
        [-70, -1],
        [-21, 47],
        [-67, -1]
      ],
      [
        [7940, 16496],
        [50, -104],
        [-39, -83],
        [-75, -62],
        [-17, -88],
        [-29, -29]
      ],
      [
        [7830, 16130],
        [-10, 46],
        [-57, 37]
      ],
      [
        [7404, 16098],
        [-10, 40],
        [-97, 29],
        [-76, 55],
        [7, 35],
        [-77, 39],
        [-40, -28]
      ],
      [
        [7111, 16268],
        [-31, -9],
        [-34, 63],
        [-75, 43]
      ],
      [
        [7830, 16130],
        [-6, -76]
      ],
      [
        [5744, 16034],
        [-97, 144],
        [-54, 35],
        [-115, 27]
      ],
      [
        [5913, 16294],
        [16, -97],
        [43, -83],
        [-11, -48]
      ],
      [
        [5921, 16389],
        [80, -21]
      ],
      [
        [6150, 16312],
        [-49, -62],
        [30, -102],
        [-19, -28]
      ],
      [
        [7111, 16268],
        [-47, -98],
        [10, -72],
        [54, -97],
        [-27, -45],
        [-65, -31],
        [65, -80],
        [-13, -65]
      ],
      [
        [2472, 15383],
        [31, 151],
        [44, 63],
        [89, 76],
        [49, 59],
        [61, 200],
        [68, 83],
        [169, 80]
      ],
      [
        [5315, 16166],
        [5, -58],
        [76, -11],
        [-17, -61]
      ],
      [
        [3999, 17403],
        [98, 147],
        [151, 105],
        [73, 25]
      ],
      [
        [4489, 17739],
        [74, -4]
      ],
      [
        [4760, 18488],
        [1, 63],
        [-26, 56]
      ],
      [
        [4698, 18822],
        [-81, 59],
        [-45, -5]
      ],
      [
        [4646, 18659],
        [-64, 31],
        [-105, -10],
        [-38, 54]
      ],
      [
        [5753, 17224],
        [9, -14]
      ],
      [
        [5900, 17310],
        [-141, -76]
      ],
      [
        [9225, 15332],
        [158, -120],
        [141, 32],
        [27, -14],
        [31, -85],
        [-14, -73]
      ],
      [
        [5644, 18051],
        [-73, -5],
        [-6, -115],
        [-97, 51]
      ],
      [
        [3523, 19915],
        [3, 55],
        [-67, 112],
        [37, 145],
        [112, 9],
        [86, 146],
        [140, 40],
        [72, 71],
        [-5, 79],
        [53, 36]
      ],
      [
        [4150, 18929],
        [-42, -23],
        [-134, 91],
        [-77, 19],
        [-67, 57],
        [-84, 15],
        [-92, 58],
        [-40, 2],
        [19, 86],
        [-60, 97],
        [37, 169],
        [-39, 34],
        [24, 67]
      ]
    ],
    "transform": {
      "scale": [0.001529187792573607, 0.0013747543925508978],
      "translate": [68.10055226476403, 6.766373153037801]
    },
    "objects": {
      "states": {
        "type": "GeometryCollection",
        "geometries": [
          {
            "arcs": [
              [35, 30, 18, 23, 25, 26, 27, 28, 15, 16, 4, 5, 8, 9, 34, 13, 32]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Mizoram", "st_code": "15"},
            "id": "Mizoram"
          },
          {
            "arcs": [
              [
                137, 138, 139, 140, 147, 148, 149, 150, 164, 165, 114, 162, 163,
                110, 152, 159, 154, 160, 161, 130, 170, 133, 134, 171, 172, 167,
                168, 169, 128, 123, 118, 105, 88, 89, 90, 91, 92, 93, 77, 78, 79,
                80, 75, 64, 48, 49, 50, 51, 52, 53, 178, 174, 177, 39, 40, 41, 43,
                180
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Tamil Nadu", "st_code": "33"},
            "id": "Tamil Nadu",
            "region": "South"
          },
          {
            "arcs": [
              [
                -199, 796, 797, 730, 731, 732, -1918, -1849, -1848, 1861, 1767,
                1714, 1715, -1555, 1712, 1768, -1611, -1756, -1755, -1754, -1753,
                1732, -1674, 1607, 1534, 1535, -1490, -1452, -1451, -1467, -1408,
                -1407, -1466, 1485, 1486, -1597, -1596, -1595, -1594, -1593,
                -1592, -1591, -1590, -1589, -1705, 1602, -1704, 1604, -1703,
                -1702, -1701, 1653, -1700, -1587, -1586, -1585, -2008, -1583,
                -2009, -1581, -2011, -1618, -1617, -1616, -1615, -1614, -1669,
                -1668, -1641, -1699, -1698, -1764, 1781, 1782, 1783, 1793, 1827,
                -1874, -872, -871, -833, -775, -774, -773, 789, -190, -194, 787,
                724, 734, 735, -820, 777, -819, 779, -818, 781, 181, 182, 183,
                -200
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Madhya Pradesh", "st_code": "23"},
            "id": "Madhya Pradesh",
            "region": "Central"
          },
          {
            "arcs": [
              [
                280, 281, 284, 334, 335, 336, 337, 338, 366, 368, 369, 375, 376,
                399, 400, 402, -416, 423, 424, 390, 865, 355, 880, 578, 691, -226,
                -691, -224, -223, 257, 258, -686, 824, -681, -683, 803, -688, 804,
                -796, -792, 805, -731, -798, -797, 198, 199, -184, -183, -182,
                -782, 817, -780, 818, -778, 819, -736, -735, -725, -788, 193, 189,
                186, 263, 264, 265, 266, 267, 268, 269
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Maharashtra", "st_code": "27"},
            "id": "Maharashtra",
            "region": "North"
          },
          {
            "arcs": [
              [
                -327, -326, -325, -324, -360, -375, -374, -434, -709, -708, -597,
                864, -267, -266, -265, -264, -187, -790, 772, 773, 774, 832, 870,
                871, 1873, -1828, -1794, -1784, -1783, -1782, -1763, -1800, -1858,
                -1916, -1915, 1934, -766, -765, -814, -828, 207, -827, 200, 201,
                -249, -311, -328
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Chhattisgarh", "st_code": "22"},
            "id": "Chhattisgarh"
          },
          {
            "arcs": [
              [
                [
                  760, 712, 2019, 1887, 854, 672, 840, 841, 842, 856, 785, 862,
                  859, 860, 2021, 2016, -1479, -1571, -1570, -1667, -1666, -1692,
                  -1691, -1840, -1839, -1851, -1850, 1917, -733, -732, -806, 791,
                  795, -805, 687, -804, 682, 680, -825, 685, -259, -258, 222, 223,
                  224, 225, 218, 219, 220, 876, 823
                ]
              ],
              [[852]]
            ],
            "type": "MultiPolygon",
            "properties": {"st_nm": "Gujarat", "st_code": "24"},
            "id": "Gujarat"
          },
          {
            "arcs": [
              [
                755, 756, 757, 752, 809, -720, -752, 810, 231, 689, 312, 314, 692,
                -362, -361, 331, 332, 356, 357, 371, 372, 373, 374, 359, 323, 324,
                325, 326, 327, 310, 248, -202, -201, 826, -208, 827, 813, 764,
                765, 766, 767, 807
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Odisha", "st_code": "21", "year": "2011_c"},
            "id": "Odisha"
          },
          {
            "arcs": [
              [
                -41, -40, -178, -175, -179, -54, -509, -499, 476, 477, 478, 479,
                480, -461, 451, -438, 446, 447, 448, 445, 427, 428, 429, 405, 406,
                555, 556, 432, 433, -373, -372, -358, -357, -333, -332, 360, 361,
                362, 364, 379, 430, 557, 408, 425, 441, 483
              ],
              [434]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Andhra Pradesh",
              "st_code": "37",
              "year": "2011_c"
            },
            "id": "Andhra Pradesh"
          },
          {
            "arcs": [
              [
                435, 436, 437, -452, 460, -481, -480, -479, -478, -477, 498, 508,
                -53, -52, -51, -50, -49, -65, -76, -81, 522, -530, 520, 521, -517,
                513, 514, 494, 469, 470, -458, 414, 415, -403, -401, -400, -377,
                -376, -370, -369, -367, -339, 381, 382, 392, 393, 394, 395, 396,
                416
              ]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Karnataka",
              "st_code": "29",
              "year": "2011_c"
            },
            "id": "Karnataka"
          },
          {
            "arcs": [[459, -424, -415, 457, -471, 471]],
            "type": "Polygon",
            "properties": {"st_nm": "Goa", "st_code": "30", "year": "2011_c"},
            "id": "Goa"
          },
          {
            "arcs": [
              [
                -80, -79, -78, -94, -93, -92, -91, -90, -89, -106, -119, -124,
                -129, -170, -169, -168, -173, -172, -135, 554, 553, 549, 545, 538,
                534, 531, 699, 700, 701, 518, -514, 516, -522, -521, 529, -523
              ],
              [702]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Kerala", "st_code": "32", "year": "2011_c"},
            "id": "Kerala"
          },
          {
            "arcs": [
              [
                -270, -269, -268, -865, 596, 707, 708, -433, -557, -556, -407,
                -406, -430, -429, -428, -446, -449, -448, -447, -437, -436, -417,
                -397, -396, -395, -394, -393, -383, -382, -338, -337, -336, -335,
                -285, -282, -281
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Telangana", "st_code": "36"},
            "id": "Telangana"
          },
          {
            "arcs": [
              [[660]],
              [[661]],
              [
                [
                  750, 751, 719, -810, -753, 844, 1891, 1892, 1893, -1866, -1863,
                  -1845, -1844, -1835, 1787, -1779, -1765, 1760, -1676, 1651,
                  -1574, -1578, -1979, 2003, -1977, 2004, -1975, 2005, 1421, 1422,
                  -1379, -1383, -1382, -1385, 1996, 1436, 1995, -989, -988, -1015,
                  2001, 1439, 1419, 2002, 1645, 1649, 1756, 1830, 1924, 665, 1940
                ]
              ],
              [[666]],
              [[667]]
            ],
            "type": "MultiPolygon",
            "properties": {"st_nm": "West Bengal", "st_code": "19"},
            "id": "West Bengal"
          },
          {
            "arcs": [[[-225, 690]], [[-220, 878]], [[-842, 879]]],
            "type": "MultiPolygon",
            "properties": {
              "st_nm": "Dadra and Nagar Haveli and Daman and Diu",
              "st_code": "26",
              "year": "2011_c"
            },
            "id": "Dadra and Nagar Haveli and Daman and Diu"
          },
          {
            "arcs": [
              [[-141, 704, -148]],
              [[-115, -166, 874, -163]],
              [[-703]],
              [[-435]]
            ],
            "type": "MultiPolygon",
            "properties": {
              "st_nm": "Puducherry",
              "st_code": "34",
              "year": "2011_c"
            },
            "id": "Puducherry"
          },
          {
            "arcs": [[877]],
            "type": "Polygon",
            "properties": {
              "district": "Lakshadweep",
              "dt_code": "587",
              "st_nm": "Lakshadweep",
              "st_code": "31",
              "year": "2011_c"
            },
            "id": "Lakshadweep"
          },
          {
            "arcs": [
              [
                -904, -931, 920, 921, -1158, -955, -954, -970, 1145, 916, 1141,
                1138, 887, 1190, 1178, 1185, 1187, 892, 906, 931, 1162, -945,
                -1157, -912, -911, -896, -895, -894, -901, -900, -899, -906, -905
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Arunachal Pradesh", "st_code": "12"},
            "id": "Arunachal Pradesh"
          },
          {
            "arcs": [
              [
                1156, -944, 934, 935, 936, 939, 940, 956, 957, -1130, -1044, 1028,
                1029, -1063, 1070, 1071, -5, -17, -16, -29, -28, 1078, 1079, 1069,
                -1054, 1031, 1032, -1147, -1023, 1002, 1015, 1005, 1006, 1007,
                1019, 1020, -1127, -1151, 1160, 1013, 1014, 987, 988, 989, 973,
                979, 968, 969, 953, 954, 1157, -922, -921, 930, 903, 904, 905,
                898, 899, 900, 893, 894, 895, 910, 911
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Assam", "st_code": "18"},
            "id": "Assam"
          },
          {
            "arcs": [
              [
                1016, 1119, 1120, -1050, -1049, 1046, 1047, -1029, 1043, 1129,
                -958, -957, -941, -940, -937, -936, -935, 943, 944, 945, 993
              ]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Nagaland",
              "st_code": "13",
              "year": "2011_c"
            },
            "id": "Nagaland"
          },
          {
            "arcs": [
              [
                1147, 1057, 1148, 1064, 1124, 1149, 1150, 1126, -1021, -1020,
                -1008, -1007, -1006, -1016, -1003, 1022, 1146, -1033, -1032, 1053,
                1054
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Meghalaya", "st_code": "17"},
            "id": "Meghalaya"
          },
          {
            "arcs": [
              [
                1036, 1172, 1092, 1094, 1175, -9, -6, -1072, -1071, 1062, -1030,
                -1048, -1047, 1048, 1049, -1121, 1173
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Manipur", "st_code": "14"},
            "id": "Manipur"
          },
          {
            "arcs": [
              [
                1154, 1107, 1153, 1152, 1104, 1155, 1100, -1079, -27, 1097, 1101,
                1111
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Tripura", "st_code": "16"},
            "id": "Tripura"
          },
          {
            "arcs": [
              [[1194, 1199]],
              [[1195]],
              [[1196]],
              [[1197]],
              [[1198]],
              [[1200]],
              [[1201]],
              [[1202]]
            ],
            "type": "MultiPolygon",
            "properties": {
              "st_nm": "Andaman and Nicobar Islands",
              "st_code": "35",
              "year": "2011_c"
            },
            "id": "Andaman and Nicobar Islands"
          },
          {
            "arcs": [
              [
                -2295, -2294, 1236, 1237, 1238, 1271, 1310, 1346, 2310, 1398,
                1404, -1391, -1390, 1426, 1493, 1494, 1542, 1543, 1544, 1545,
                1620, 1621, 1669, -1681, -1686, 1761, 1762, 1763, 1697, 1698,
                1640, 1667, 1668, 1613, 1614, 1615, 1616, 1617, 2010, 1580, 2008,
                1582, 2007, 1584, 1585, 1586, 1699, -1654, 1700, 1701, 1702,
                -1605, 1703, -1603, 1704, 1588, 1589, 1590, 1591, 1592, 1593,
                1594, 1595, 1596, -1487, -1486, 1465, 1406, 1407, 1408, -1358,
                1341, -1317, -1325, -1324, 1264, 1265, 1266, -1257, -1256, 1987,
                -1244, -1260, -1221, -1220, -2298, -2290, -2289, -2266, 2240,
                -2234, -2190, -2188, 2237, -2254, -2253, -2257, 2278, 2279
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Uttar Pradesh", "st_code": "09"},
            "id": "Uttar Pradesh"
          },
          {
            "arcs": [
              [
                -1294, -1293, -1292, -1296, -1319, -1318, -1342, 1357, -1409,
                1466, 1450, 1451, 1489, -1536, -1535, -1608, 1673, -1733, 1752,
                1753, 1754, 1755, 1610, -1769, -1713, 1554, -1716, -1715, -1768,
                -1862, 1847, 1848, 1849, 1850, 1838, 1839, 1690, 1691, 1665, 1666,
                1569, 1570, 1478, 1479, 1309, 2301, 2243, -2167, -2166, -2213,
                -2261, 2262, 2263, 2264, 1209, 1279, 1280
              ]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Rajasthan",
              "st_code": "08",
              "year": "2011_c"
            },
            "id": "Rajasthan"
          },
          {
            "arcs": [
              [
                1243, -1988, 1255, 1256, -1267, -1288, 1277, 1278, 1270, 1258,
                -1228, -1227, -1226, 1990, 1223, 1219, 1220, 1259
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Delhi", "st_code": "07"},
            "id": "Delhi"
          },
          {
            "arcs": [
              [
                -1224, -1991, 1225, 1226, 1227, -1259, -1271, -1279, -1278, 1287,
                -1266, -1265, 1323, 1324, 1316, 1317, 1318, 1295, 1291, 1292,
                1293, -1281, -1280, -1210, -2265, -2264, -2263, 2260, -2212,
                -2227, -2246, -2245, -2221, -2220, -2233, -2232, -2231, -2230,
                -2229, -2228, -2199, -2198, -2197, -2196, -2209, -2194, -2161,
                -2193, -2192, -2191, 2233, -2241, 2265, 2288, 2289, 2297
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Haryana", "st_code": "06"},
            "id": "Haryana"
          },
          {
            "arcs": [[1378, 1379, 1330, 1383, 1384, 1381, 1382]],
            "type": "Polygon",
            "properties": {"st_nm": "Sikkim", "st_code": "11", "year": "2011_c"},
            "id": "Sikkim"
          },
          {
            "arcs": [
              [
                1389, 1390, 1391, 1453, 1497, 1972, 1971, 1967, 2020, -1422,
                -2006, 1974, -2005, 1976, -2004, 1978, 1577, 1573, 1574, -1679,
                -1696, -1695, 1716, 1717, 1706, 1707, 1733, 1734, 1738, 1739,
                1740, 1741, -1790, 1683, 1684, 1685, 1680, -1670, -1622, -1621,
                -1546, -1545, -1544, -1543, -1495, -1494, -1427
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Bihar", "st_code": "10", "year": "2011_c"},
            "id": "Bihar"
          },
          {
            "arcs": [
              [
                1778, -1788, 1834, 1843, 1844, 1862, 1865, -1894, -1893, -1892,
                -845, -758, -757, -756, -808, -768, -767, -1935, 1914, 1915, 1857,
                1799, -1762, -1685, -1684, 1789, -1742, -1741, -1740, -1739,
                -1735, -1734, -1708, -1707, -1718, -1717, 1694, 1695, 1678, -1575,
                -1652, 1675, -1761, 1764
              ]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Jharkhand",
              "st_code": "20",
              "year": "2011_c"
            },
            "id": "Jharkhand"
          },
          {
            "arcs": [
              [2024, 2025, 2026, 2027, 2028, 2022, 2029, 2030, 2031, 2032]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Ladakh", "st_code": "38", "year": "2011_c"},
            "id": "Ladakh"
          },
          {
            "arcs": [
              [
                -2025, -2033, -2032, -2031, 2054, 2055, 2082, -2093, 2097, 2098,
                2307, 2095, 2313, 2067, 2312, -2028, -2027, -2026
              ]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Jammu and Kashmir",
              "st_code": "01",
              "year": "2011_c"
            },
            "id": "Jammu and Kashmir"
          },
          {
            "arcs": [
              [
                2135, 2136, -2189, 2189, 2190, 2191, 2192, 2160, 2161, -2150,
                -2149, 2134, -2117, 2111, -2103, 2112, 2091, 2092, -2083, -2056,
                -2055, -2030, -2023, 2085, 2129, 2130
              ]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Himachal Pradesh",
              "st_code": "02",
              "year": "2011_c"
            },
            "id": "Himachal Pradesh"
          },
          {
            "arcs": [
              [
                -2092, -2113, 2102, -2112, 2116, -2135, 2148, 2149, -2162, 2193,
                2194, 2195, 2196, 2197, 2198, 2227, 2228, 2229, 2230, 2231, 2232,
                2219, 2220, 2244, 2245, 2226, 2211, 2212, 2165, 2166, 2167, 2303,
                2147, 2124, 2106, 2305, -2098
              ]
            ],
            "type": "Polygon",
            "properties": {"st_nm": "Punjab", "st_code": "03"},
            "id": "Punjab"
          },
          {
            "arcs": [
              [
                2214, 2291, 2295, -1238, -1237, 2293, 2294, -2280, -2279, 2256,
                2252, 2253, -2238, 2187, 2188, -2137, -2136, -2131, 2154, 2178
              ]
            ],
            "type": "Polygon",
            "properties": {
              "st_nm": "Uttarakhand",
              "st_code": "05",
              "year": "2011_c"
            },
            "id": "Uttarakhand"
          },
          {
            "arcs": [[-2195, 2208]],
            "type": "Polygon",
            "properties": {
              "district": "Chandigarh",
              "dt_code": "055",
              "st_nm": "Chandigarh",
              "st_code": "04",
              "year": "2011_c"
            },
            "id": "Chandigarh"
          }
        ]
      }
    }
  }
  